/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: string; output: string; }
  /** An ISO 8601-encoded date */
  ISO8601Date: { input: string; output: string; }
  /** An ISO 8601-encoded datetime */
  ISO8601DateTime: { input: string; output: string; }
  /** Represents untyped JSON */
  JSON: { input: any; output: any; }
};

/** Autogenerated input type of AcceptDjEngagement */
export type AcceptDjEngagementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptDjEngagement. */
export type AcceptDjEngagementPayload = {
  __typename?: 'AcceptDjEngagementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<DjEngagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of AcceptOrganizationInvitation */
export type AcceptOrganizationInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptOrganizationInvitation. */
export type AcceptOrganizationInvitationPayload = {
  __typename?: 'AcceptOrganizationInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  organizationMembership?: Maybe<OrganizationMembership>;
};

/** Autogenerated input type of ActivateDevice */
export type ActivateDeviceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Device to activate */
  deviceId: Scalars['ID']['input'];
};

/** Autogenerated return type of ActivateDevice. */
export type ActivateDevicePayload = {
  __typename?: 'ActivateDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Device>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of AddTrackToPlaylist */
export type AddTrackToPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  playlistId: Scalars['ID']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  trackId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddTrackToPlaylist. */
export type AddTrackToPlaylistPayload = {
  __typename?: 'AddTrackToPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  playlistTrack?: Maybe<PlaylistTrack>;
};

/** Autogenerated input type of AddVideoToPlaylist */
export type AddVideoToPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  videoId: Scalars['ID']['input'];
  videoPlaylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddVideoToPlaylist. */
export type AddVideoToPlaylistPayload = {
  __typename?: 'AddVideoToPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  videoPlaylist?: Maybe<VideoPlaylist>;
};

/** Autogenerated input type of AddVideosToPlaylist */
export type AddVideosToPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  videoIds: Array<Scalars['ID']['input']>;
  videoPlaylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddVideosToPlaylist. */
export type AddVideosToPlaylistPayload = {
  __typename?: 'AddVideosToPlaylistPayload';
  addedCount: Scalars['Int']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  videoPlaylist?: Maybe<VideoPlaylist>;
};

/** Staff-only queries for the internal admin tool */
export type Admin = {
  __typename?: 'Admin';
  /** Admin activity feed (polled — no subscription), newest first, 30-day retention. */
  activity: Array<AdminActivityEvent>;
  /** Kept albums with per-album track/playable/licensed counts, ordered by name. Requires the music.view staff permission. */
  albumRollup: AlbumRollupConnection;
  /**
   * Subscriptions in a payment-failure state (past_due, unpaid, incomplete,
   * incomplete_expired), newest first. Requires the billing.view staff permission.
   */
  billingExceptions: BillingExceptionConnection;
  /**
   * Aggregate billing numbers (MRR, zones billed, at-risk revenue, infra spend,
   * gross margin). Requires the billing.view staff permission.
   */
  billingSummary: BillingSummary;
  /** Kept campaigns across all organizations, newest first. Requires the campaigns.manage staff permission. */
  campaigns: CampaignConnection;
  /**
   * Per-organization derived catalog rollup over kept tracks reachable through the
   * org's zones' scheduled playlists (zone -> playlist_schedules -> playlist ->
   * playlist_tracks -> track — the canonical assignment path; ad-hoc zone override
   * playlists are not counted). Organizations with zero reachable tracks are
   * omitted. Requires the music.view staff permission.
   */
  catalogs: Array<OrgCatalogRollup>;
  /** Kept devices across all organizations, ordered by code. Requires the devices.view staff permission. */
  devices: DeviceConnection;
  /**
   * Kept DJ profiles across ALL statuses (djDirectory serves published only),
   * newest first. Requires the dj.manage staff permission.
   */
  djProfiles: DjProfileConnection;
  /**
   * Event-explorer aggregation over playback events. Requires the analytics.query
   * staff permission. plays = COUNT of trackStarted events; hours =
   * SUM(position_ms) of trackEnded events / 3,600,000; completion (per trackEnded
   * row, only when duration_ms > 0 and position_ms is present) = LEAST(position_ms
   * / duration_ms, 1.0); avgCompletionPct = AVG(completion) * 100; skipRatePct =
   * share of qualifying trackEnded rows with completion < 0.5, * 100. When
   * minCompletionPct is set, plays stays the raw trackStarted count, hours and
   * avgCompletionPct are computed only over trackEnded rows with completion >= the
   * threshold, and skipRatePct becomes the share of ALL qualifying rows below the threshold.
   */
  eventQuery: EventQueryResult;
  /** Aggregate fleet counts over kept devices. Requires the devices.view staff permission. */
  fleetSummary: FleetSummary;
  /** Hardware orders across all organizations, newest first. Requires the billing.view or hardware.manage staff permission. */
  hardwareOrders: HardwareOrderConnection;
  /**
   * OAuth applications (aggregate token counts only — never secrets or per-user
   * token rows) and third-party service status (configuration presence only, never
   * credential values). Requires the integrations.manage staff permission.
   */
  integrationsOverview: IntegrationsOverview;
  /**
   * Effective jukebox configuration for a zone with per-key provenance (which of
   * org / location / zone decided each value). Cross-tenant — requires the
   * jukebox.manage staff permission.
   */
  jukeboxEffectiveConfiguration: Array<JukeboxConfigProvenance>;
  /** Aggregate jukebox counters and live queues across kept zones. Requires the jukebox.manage staff permission. */
  jukeboxOverview: JukeboxOverview;
  /**
   * Open (live) karaoke sessions — pending, active, paused or ending — newest
   * first. Requires the karaoke.manage staff permission.
   */
  karaokeSessions: Array<KaraokeLiveSession>;
  /**
   * Per-PRO matched-track counts over the kept catalog, one entry per supported
   * PRO. Requires the licensing.view staff permission.
   */
  licensingSummary: Array<ProLicensingStat>;
  /** A single organization by id. Requires the orgs.view staff permission. */
  organization?: Maybe<Organization>;
  /** Kept organizations, ordered by name. Requires the orgs.view staff permission. */
  organizations: OrganizationConnection;
  /**
   * Headline KPIs for the Overview dashboard. Viewable by any staff member;
   * sub-values requiring billing.view (MRR) or finance.view (infra spend) resolve
   * to null without them.
   */
  platformKpis: PlatformKpis;
  /**
   * Cross-tenant playback analytics for one organization — the same
   * Queries::PlaybackAnalyticsQuery members use, with only the org-membership
   * check bypassed. Requires the analytics.view staff permission.
   */
  playbackAnalyticsAdmin: PlaybackAnalytics;
  /**
   * A single kept playlist by id, with its ordered tracks and the schedules
   * programming it. Requires the playlists.manage staff permission.
   */
  playlist?: Maybe<Playlist>;
  /** Kept playlist schedules across all organizations, newest first. Requires the scheduling.manage staff permission. */
  playlistSchedules: PlaylistScheduleConnection;
  /** Kept playlists across all organizations, most recently updated first. Requires the playlists.manage staff permission. */
  playlists: PlaylistConnection;
  /**
   * Platform-wide per-PRO royalty rollup for one calendar month, one row per
   * supported PRO plus 'unmatched'. Royalty-bearing plays are finalized qualified
   * track plays — the same definition TrackPlay.royalty_summary uses for PRO
   * remittance. Requires the royalties.view staff permission.
   */
  royaltyReport: Array<RoyaltyPeriodProRow>;
  /** Saved Event-explorer queries (shared across staff), newest first. Requires the analytics.query staff permission. */
  savedQueries: Array<AdminSavedQuery>;
  /**
   * Overlapping playlist/video schedule windows per zone over the next N days. A
   * diagnostic window, not a guarantee — conflicts beyond it are simply not looked
   * at. Cross-media (music/video) overlaps are flagged distinctly. Requires the
   * scheduling.manage staff permission.
   */
  scheduleConflicts: Array<ScheduleConflict>;
  /** Point-in-time health of backing services. Requires the health.view staff permission. */
  serviceHealth: ServiceHealth;
  /** Cheap cached (15s) header-bar health summary. Requires the health.view staff permission. */
  serviceHealthSummary: Array<ServiceSummary>;
  /** All staff roles. Requires the iam.manage staff permission; staff read their own role via viewerStaff. */
  staffRoles: Array<StaffRole>;
  /** Counters over the support-ticket mirror. Requires the support.view staff permission. */
  supportTicketStats: SupportTicketStats;
  /**
   * Mirrored support tickets from the external ticketing platform, most recently
   * active first (tickets with no recorded activity sort last). Requires the
   * support.view staff permission.
   */
  supportTickets: SupportTicketConnection;
  /** Kept tracks across the full catalog, ordered by name. Requires the music.view staff permission. */
  tracks: TrackConnection;
  /**
   * Grouped items needing attention, built only from existing queryable state.
   * Empty groups and groups whose underlying data the viewer lacks permission for are omitted.
   */
  triage: Array<TriageGroup>;
  /** Kept tracks with no licensing PRO assigned. Requires the licensing.view staff permission. */
  unlicensedTracksCount: Scalars['Int']['output'];
  /**
   * Kept tracks with no licensing PRO assigned (the unmatched works queue), newest
   * first. Requires the licensing.view staff permission.
   */
  unmatchedTracks: TrackConnection;
  /** User accounts across all organizations (including discarded), newest first. Requires the users.manage staff permission. */
  users: AdminUserConnection;
  /**
   * Monthly vendor/infra spend, newest month first, one entry per month in the
   * window even when empty. Requires the finance.view staff permission.
   */
  vendorExpenses: VendorExpenseReport;
  /**
   * A single kept video asset by id, with the playlists including it and the
   * schedules playing it. Requires the video.manage staff permission.
   */
  video?: Maybe<Video>;
  /** Kept video schedules across all organizations, newest first. Requires the scheduling.manage staff permission. */
  videoSchedules: VideoScheduleConnection;
  /** Kept videos across all organizations, newest first. Requires the video.manage staff permission. */
  videos: VideoConnection;
  /** The current staff member's own membership, role, and resolved permissions */
  viewerStaff?: Maybe<StaffMember>;
  /** Kept voice messages across all organizations, newest first. Requires the voice.manage staff permission. */
  voiceMessages: VoiceMessageConnection;
  /** Voice playlist requests across all organizations, newest first. Requires the voice.manage staff permission. */
  voicePlaylistRequests: VoicePlaylistRequestConnection;
  /**
   * Kept zones across all organizations, ordered by name. Powers cross-tenant zone
   * pickers. Requires the orgs.view or jukebox.manage staff permission.
   */
  zones: ZoneConnection;
};


/** Staff-only queries for the internal admin tool */
export type AdminActivityArgs = {
  before?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  beforeId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminAlbumRollupArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminBillingExceptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminBillingSummaryArgs = {
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminCampaignsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminDevicesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  firmware?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  mediaKind?: InputMaybe<MediaKindEnum>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminDjProfilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<DjProfileStatus>;
};


/** Staff-only queries for the internal admin tool */
export type AdminEventQueryArgs = {
  input: EventQueryInput;
};


/** Staff-only queries for the internal admin tool */
export type AdminFleetSummaryArgs = {
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminHardwareOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminJukeboxEffectiveConfigurationArgs = {
  zoneId: Scalars['ID']['input'];
};


/** Staff-only queries for the internal admin tool */
export type AdminJukeboxOverviewArgs = {
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminKaraokeSessionsArgs = {
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminOrganizationArgs = {
  id: Scalars['ID']['input'];
};


/** Staff-only queries for the internal admin tool */
export type AdminOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeDiscarded?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminPlaybackAnalyticsAdminArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


/** Staff-only queries for the internal admin tool */
export type AdminPlaylistArgs = {
  id: Scalars['ID']['input'];
};


/** Staff-only queries for the internal admin tool */
export type AdminPlaylistSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  playlistType?: InputMaybe<PlaylistType>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminRoyaltyReportArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminScheduleConflictsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminSupportTicketStatsArgs = {
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminSupportTicketsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  licensingPro?: InputMaybe<LicensingProEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
  unlicensed?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminUnmatchedTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  staff?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminVendorExpensesArgs = {
  months?: InputMaybe<Scalars['Int']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminVideoArgs = {
  id: Scalars['ID']['input'];
};


/** Staff-only queries for the internal admin tool */
export type AdminVideoSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  processingStatus?: InputMaybe<VideoProcessingStatusEnum>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminVoiceMessagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminVoicePlaylistRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
};


/** Staff-only queries for the internal admin tool */
export type AdminZonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orgId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** One row of the admin Overview live-activity feed (polled, 30-day retention) */
export type AdminActivityEvent = {
  __typename?: 'AdminActivityEvent';
  /** device_status | zone_command | sign_in | billing */
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurredAt: Scalars['ISO8601DateTime']['output'];
  organizationName?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
};

export type AdminOrganizationSummary = {
  __typename?: 'AdminOrganizationSummary';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated input type of AdminProvisionDevice */
export type AdminProvisionDeviceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional display name for the device */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Organization the device belongs to */
  organizationId: Scalars['ID']['input'];
  /** Zone to attach the device to. Optional only when the organization has exactly one zone. */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AdminProvisionDevice. */
export type AdminProvisionDevicePayload = {
  __typename?: 'AdminProvisionDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Device>;
  errors: Array<Scalars['String']['output']>;
  /** The new device's code, returned here for installer handoff */
  provisioningCode?: Maybe<Scalars['String']['output']>;
};

/** A saved Event-explorer query configuration */
export type AdminSavedQuery = {
  __typename?: 'AdminSavedQuery';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Email of the staff member who saved the query */
  createdByEmail?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Same shape as EventQueryInput: {from, to, groupBy, orgId?, zoneId?, minCompletionPct?} */
  queryConfig: Scalars['JSON']['output'];
  scheduledReports: Array<AdminScheduledReport>;
};

/** An email schedule over a saved Event-explorer query */
export type AdminScheduledReport = {
  __typename?: 'AdminScheduledReport';
  cadence: ReportCadenceEnum;
  createdAt: Scalars['ISO8601DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastRunAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Recipient email addresses */
  recipients: Array<Scalars['String']['output']>;
  savedQueryId: Scalars['ID']['output'];
};

export type AdminUser = {
  __typename?: 'AdminUser';
  createdAt: Scalars['ISO8601DateTime']['output'];
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Whether the user holds a StaffMembership (internal admin tool access) */
  isStaff: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
  lastSignInAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lockedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Kept organization memberships */
  memberships: Array<AdminUserMembership>;
  signInCount: Scalars['Int']['output'];
  timeZone: Scalars['String']['output'];
  userRole: UserRole;
  userStatus: UserStatus;
};

/** The connection type for AdminUser. */
export type AdminUserConnection = {
  __typename?: 'AdminUserConnection';
  /** A list of edges. */
  edges: Array<AdminUserEdge>;
  /** A list of nodes. */
  nodes: Array<AdminUser>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AdminUserEdge = {
  __typename?: 'AdminUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AdminUser>;
};

export type AdminUserMembership = {
  __typename?: 'AdminUserMembership';
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  membershipRole: MembershipRole;
  organization: AdminOrganizationSummary;
};

export type Album = Node & {
  __typename?: 'Album';
  albumType: AlbumType;
  artists?: Maybe<Array<Artist>>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  name: Scalars['String']['output'];
  popularity?: Maybe<Scalars['Int']['output']>;
  releaseDate?: Maybe<Scalars['ISO8601Date']['output']>;
  releaseDatePrecision?: Maybe<ReleaseDatePrecision>;
  tags: Array<Scalars['String']['output']>;
  tracksCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Album. */
export type AlbumConnection = {
  __typename?: 'AlbumConnection';
  /** A list of edges. */
  edges: Array<AlbumEdge>;
  /** A list of nodes. */
  nodes: Array<Album>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AlbumEdge = {
  __typename?: 'AlbumEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Album>;
};

/** Per-album catalog rollup: track counts, playable audio and licensing coverage */
export type AlbumRollup = {
  __typename?: 'AlbumRollup';
  id: Scalars['ID']['output'];
  /** Kept tracks with a licensing PRO assigned (licensing coverage) */
  licensedCount: Scalars['Int']['output'];
  /** Album name */
  name: Scalars['String']['output'];
  /** Kept tracks with transcoded audio attached (Track.playable) */
  playableCount: Scalars['Int']['output'];
  /** Credited album artist — alphabetically first when several are credited, since album_artists stores no credit order */
  primaryArtist: Scalars['String']['output'];
  /** Kept tracks on the album */
  trackCount: Scalars['Int']['output'];
};

/** The connection type for AlbumRollup. */
export type AlbumRollupConnection = {
  __typename?: 'AlbumRollupConnection';
  /** A list of edges. */
  edges: Array<AlbumRollupEdge>;
  /** A list of nodes. */
  nodes: Array<AlbumRollup>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AlbumRollupEdge = {
  __typename?: 'AlbumRollupEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<AlbumRollup>;
};

/** Album type enum */
export enum AlbumType {
  Album = 'ALBUM',
  Compilation = 'COMPILATION',
  Single = 'SINGLE'
}

export type ApiToken = {
  __typename?: 'ApiToken';
  active: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  createdBy: User;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastUsedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  name: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  scopes: Scalars['String']['output'];
  /** First characters of the token for identification */
  tokenPrefix: Scalars['String']['output'];
};

export type Artist = Node & {
  __typename?: 'Artist';
  albums?: Maybe<Array<Album>>;
  bio: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  popularity?: Maybe<Scalars['Int']['output']>;
  tags: Array<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Artist. */
export type ArtistConnection = {
  __typename?: 'ArtistConnection';
  /** A list of edges. */
  edges: Array<ArtistEdge>;
  /** A list of nodes. */
  nodes: Array<Artist>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ArtistEdge = {
  __typename?: 'ArtistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Artist>;
};

export type BillingException = {
  __typename?: 'BillingException';
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** The billing subscription id */
  id: Scalars['ID']['output'];
  /** Current monthly amount of the subscription (canonical tier-aware pricing) */
  monthlyAmountCents: Scalars['Int']['output'];
  organization: Organization;
  /** past_due | unpaid | incomplete | incomplete_expired */
  status: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
  /** The legacy single-zone link, when present; multi-zone subscriptions carry zones on their items */
  zone?: Maybe<Zone>;
};

/** The connection type for BillingException. */
export type BillingExceptionConnection = {
  __typename?: 'BillingExceptionConnection';
  /** A list of edges. */
  edges: Array<BillingExceptionEdge>;
  /** A list of nodes. */
  nodes: Array<BillingException>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BillingExceptionEdge = {
  __typename?: 'BillingExceptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BillingException>;
};

export type BillingPlan = Node & {
  __typename?: 'BillingPlan';
  active: Scalars['Boolean']['output'];
  /** Monthly price of each additional zone under this plan */
  additionalZonePriceCents?: Maybe<Scalars['Int']['output']>;
  entitlements: Scalars['JSON']['output'];
  /** Monthly price of the first zone under this plan */
  firstZonePriceCents?: Maybe<Scalars['Int']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** 'plan' (a zone subscription plan), 'addon' (per-zone add-on like karaoke/video), or 'base' (the $0 anchor) */
  kind: Scalars['String']['output'];
  /** Flat monthly price per zone. Null for tiered plans — see priceTiers. */
  monthlyBasePriceCents?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Graduated tiers, e.g. [{"up_to":1,"unit_amount_cents":2500},{"up_to":null,"unit_amount_cents":2000}] */
  priceTiers?: Maybe<Scalars['JSON']['output']>;
  restrictions: Scalars['JSON']['output'];
  slug: Scalars['String']['output'];
  stripePriceId: Scalars['String']['output'];
  stripeProductId?: Maybe<Scalars['String']['output']>;
};

/** The connection type for BillingPlan. */
export type BillingPlanConnection = {
  __typename?: 'BillingPlanConnection';
  /** A list of edges. */
  edges: Array<BillingPlanEdge>;
  /** A list of nodes. */
  nodes: Array<BillingPlan>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BillingPlanEdge = {
  __typename?: 'BillingPlanEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BillingPlan>;
};

export type BillingSubscription = Node & {
  __typename?: 'BillingSubscription';
  billingPlan?: Maybe<BillingPlan>;
  billingSubscriptionItems: Array<BillingSubscriptionItem>;
  cancelAtPeriodEnd: Scalars['Boolean']['output'];
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currentPeriodStart?: Maybe<Scalars['ISO8601DateTime']['output']>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  latestInvoiceId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
  quantity: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  stripeSubscriptionId: Scalars['String']['output'];
  zone?: Maybe<Zone>;
};

/** The connection type for BillingSubscription. */
export type BillingSubscriptionConnection = {
  __typename?: 'BillingSubscriptionConnection';
  /** A list of edges. */
  edges: Array<BillingSubscriptionEdge>;
  /** A list of nodes. */
  nodes: Array<BillingSubscription>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type BillingSubscriptionEdge = {
  __typename?: 'BillingSubscriptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BillingSubscription>;
};

export type BillingSubscriptionItem = Node & {
  __typename?: 'BillingSubscriptionItem';
  billingPlan: BillingPlan;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** 'plan' for the zone's subscription line item, 'addon' for per-zone add-ons (karaoke, video) */
  kind: Scalars['String']['output'];
  /** When set, this zone's line item is removed at this time (end of the billing period) */
  pendingRemovalAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  quantity: Scalars['Int']['output'];
  /** Set once the Stripe quantity decrement for a pending removal has been applied */
  removalAppliedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** 'pending_removal' when an end-of-period cancellation is scheduled, else 'active' */
  status: Scalars['String']['output'];
  stripePriceId: Scalars['String']['output'];
  stripeSubscriptionItemId: Scalars['String']['output'];
  zone?: Maybe<Zone>;
};

export type BillingSummary = {
  __typename?: 'BillingSummary';
  /** Monthly amount of past_due/unpaid/incomplete subscriptions */
  atRiskCents: Scalars['Int']['output'];
  /** Number of past_due/unpaid/incomplete subscriptions */
  failedPaymentsCount: Scalars['Int']['output'];
  /**
   * (mrr - infraSpend) / mrr * 100. Platform-wide only — null when orgId is given,
   * when no vendor spend is recorded, or when MRR is zero
   */
  grossMarginPct?: Maybe<Scalars['Float']['output']>;
  /**
   * Vendor spend for the latest month with any recorded vendor expenses. Always
   * platform-wide, even with orgId; null when no data
   */
  infraSpendCents?: Maybe<Scalars['Int']['output']>;
  /** Monthly recurring revenue across active and trialing subscriptions (canonical tier-aware pricing) */
  mrrCents: Scalars['Int']['output'];
  /** Distinct zones across live items on active subscriptions (applied removals excluded) */
  zonesBilled: Scalars['Int']['output'];
};

/** Autogenerated input type of BookmarkDj */
export type BookmarkDjInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  djProfileId: Scalars['ID']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /**
   * Bookmarking organization (defaults to the viewer's current organization). The
   * viewer must be a full member; the policy enforces this.
   */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of BookmarkDj. */
export type BookmarkDjPayload = {
  __typename?: 'BookmarkDjPayload';
  bookmark?: Maybe<OrgDjBookmark>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** A campaign that schedules voice messages for playback in zones */
export type Campaign = {
  __typename?: 'Campaign';
  createdAt: Scalars['ISO8601DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endTime: Scalars['String']['output'];
  forceInterrupt: Scalars['Boolean']['output'];
  frequencyDescription: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nextOccurrence?: Maybe<Scalars['ISO8601DateTime']['output']>;
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  priority: Scalars['Int']['output'];
  rrule?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  voiceMessages: Array<VoiceMessage>;
  zones: Array<Zone>;
};

/** The connection type for Campaign. */
export type CampaignConnection = {
  __typename?: 'CampaignConnection';
  /** A list of edges. */
  edges: Array<CampaignEdge>;
  /** A list of nodes. */
  nodes: Array<Campaign>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type CampaignEdge = {
  __typename?: 'CampaignEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Campaign>;
};

/** Input for creating or updating a campaign */
export type CampaignInput = {
  /** Whether this campaign is enabled (create default true) */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** End date */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** End time in HH:MM format (create default 09:01) */
  endTime?: InputMaybe<Scalars['String']['input']>;
  /** Whether to interrupt current playback (create default false) */
  forceInterrupt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Campaign name */
  name: Scalars['String']['input'];
  /** Organization ID (required for create) */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Priority level, higher wins (create default 100) */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Recurrence rule in RRULE format */
  rrule?: InputMaybe<Scalars['String']['input']>;
  /** Start date */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Start time in HH:MM format (create default 09:00) */
  startTime?: InputMaybe<Scalars['String']['input']>;
  /** Voice message IDs in playback order */
  voiceMessageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Zone IDs where this campaign runs */
  zoneIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated input type of CancelAiTrackGeneration */
export type CancelAiTrackGenerationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Playlist ID */
  playlistId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelAiTrackGeneration. */
export type CancelAiTrackGenerationPayload = {
  __typename?: 'CancelAiTrackGenerationPayload';
  cancelledCount: Scalars['Int']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CancelSubscription */
export type CancelSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  subscriptionId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelSubscription. */
export type CancelSubscriptionPayload = {
  __typename?: 'CancelSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  subscription?: Maybe<BillingSubscription>;
};

/** Autogenerated input type of CancelZoneBilling */
export type CancelZoneBillingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An add-on plan id to cancel only that add-on for the zone; omit to cancel the zone's subscription */
  planId?: InputMaybe<Scalars['ID']['input']>;
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelZoneBilling. */
export type CancelZoneBillingPayload = {
  __typename?: 'CancelZoneBillingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  zoneItem?: Maybe<BillingSubscriptionItem>;
};

/** Input for generating a Cartesia voice preview */
export type CartesiaPreviewInput = {
  /** Text to synthesize for the preview */
  text: Scalars['String']['input'];
  /** Emotion for the generated voice */
  ttsEmotion?: InputMaybe<Scalars['String']['input']>;
  /** Cartesia model ID */
  ttsModelId?: InputMaybe<Scalars['String']['input']>;
  /** Playback speed multiplier */
  ttsSpeed?: InputMaybe<Scalars['Float']['input']>;
  /** Cartesia voice ID */
  ttsVoiceId?: InputMaybe<Scalars['String']['input']>;
  /** Volume multiplier */
  ttsVolume?: InputMaybe<Scalars['Float']['input']>;
};

/** Represents an available Cartesia voice option */
export type CartesiaVoice = {
  __typename?: 'CartesiaVoice';
  description?: Maybe<Scalars['String']['output']>;
  emotive: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recommended: Scalars['Boolean']['output'];
  tags?: Maybe<Scalars['String']['output']>;
  voiceId: Scalars['String']['output'];
};

/** Configuration and selectable options for Cartesia TTS */
export type CartesiaVoiceOptions = {
  __typename?: 'CartesiaVoiceOptions';
  defaultModelId: Scalars['String']['output'];
  defaultSpeed: Scalars['Float']['output'];
  defaultVoiceId: Scalars['String']['output'];
  defaultVolume: Scalars['Float']['output'];
  emotions: Array<Scalars['String']['output']>;
  recommendedVoiceIds: Array<Scalars['String']['output']>;
  speedMax: Scalars['Float']['output'];
  speedMin: Scalars['Float']['output'];
  voices: Array<CartesiaVoice>;
  volumeMax: Scalars['Float']['output'];
  volumeMin: Scalars['Float']['output'];
};

export type Category = {
  __typename?: 'Category';
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  playlists: PlaylistConnection;
  tag: Scalars['String']['output'];
  tracks: TrackConnection;
  type: Scalars['String']['output'];
};


export type CategoryPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type CategoryTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type CheckoutSession = {
  __typename?: 'CheckoutSession';
  checkoutRequired: Scalars['Boolean']['output'];
  sessionId?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

/** Command action enum */
export enum CommandAction {
  /** Load a playlist and start playing (impromptu play) */
  LoadPlaylist = 'LOAD_PLAYLIST',
  /** Skip to the next track */
  Next = 'NEXT',
  /** Pause the current track */
  Pause = 'PAUSE',
  /** Play the current track */
  Play = 'PLAY',
  /** Play an advertisement */
  PlayAd = 'PLAY_AD',
  /** Go to the previous track */
  Prev = 'PREV',
  /** Gracefully restart the spin-pi-player service on the device */
  Restart = 'RESTART',
  /** Recover the device's tailnet connection (try `tailscale up`, fall back to a tailscaled daemon restart) */
  RestartTailscale = 'RESTART_TAILSCALE',
  /** Resume playback after pause */
  Resume = 'RESUME',
  /** Seek to a specific time position */
  SetPosition = 'SET_POSITION',
  /** Set the volume level */
  SetVolume = 'SET_VOLUME',
  /** Shuffle the playlist */
  Shuffle = 'SHUFFLE',
  /** Stop the current playback */
  Stop = 'STOP'
}

/** Autogenerated input type of CompleteDjEngagement */
export type CompleteDjEngagementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CompleteDjEngagement. */
export type CompleteDjEngagementPayload = {
  __typename?: 'CompleteDjEngagementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<DjEngagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CompleteOnboarding */
export type CompleteOnboardingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CompleteOnboarding. */
export type CompleteOnboardingPayload = {
  __typename?: 'CompleteOnboardingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of ConnectDevice */
export type ConnectDeviceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Device token from the device (displayed or printed on device) */
  deviceToken: Scalars['String']['input'];
  /** Whether this device plays music (audio) or signage video */
  mediaKind?: InputMaybe<MediaKindEnum>;
  /** Code from a staff pre-provisioned device record to claim instead of creating a new one */
  provisioningCode?: InputMaybe<Scalars['String']['input']>;
  /** Zone to connect the device to */
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConnectDevice. */
export type ConnectDevicePayload = {
  __typename?: 'ConnectDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Device>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

export type Conversation = Node & {
  __typename?: 'Conversation';
  createdAt: Scalars['ISO8601DateTime']['output'];
  djProfile: DjProfile;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  lastMessageAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latestMessage?: Maybe<Message>;
  messages: Array<Message>;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  unreadCount: Scalars['Int']['output'];
};


export type ConversationMessagesArgs = {
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of CreateApiToken */
export type CreateApiTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Human-readable label for the token */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateApiToken. */
export type CreateApiTokenPayload = {
  __typename?: 'CreateApiTokenPayload';
  apiToken?: Maybe<ApiToken>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** The full token value. Only shown once. */
  rawToken?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCampaign */
export type CreateCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Campaign attributes */
  input: CampaignInput;
};

/** Autogenerated return type of CreateCampaign. */
export type CreateCampaignPayload = {
  __typename?: 'CreateCampaignPayload';
  campaign?: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCheckoutSession */
export type CreateCheckoutSessionInput = {
  cancelUrl: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Billing plan ID for subscription */
  planId?: InputMaybe<Scalars['ID']['input']>;
  /** Hardware product ID for hardware purchase */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** Hardware product type: 'audio' or 'video' */
  productType?: InputMaybe<Scalars['String']['input']>;
  /** Quantity for hardware purchase */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  successUrl: Scalars['String']['input'];
  /** Zone ID for zone-specific subscription */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateCheckoutSession. */
export type CreateCheckoutSessionPayload = {
  __typename?: 'CreateCheckoutSessionPayload';
  checkoutSession?: Maybe<CheckoutSession>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCustomerPortalSession */
export type CreateCustomerPortalSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  returnUrl: Scalars['String']['input'];
};

/** Autogenerated return type of CreateCustomerPortalSession. */
export type CreateCustomerPortalSessionPayload = {
  __typename?: 'CreateCustomerPortalSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  customerPortalSession: CustomerPortalSession;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateDjEngagement */
export type CreateDjEngagementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  djProfileId: Scalars['ID']['input'];
  /**
   * Hiring organization (defaults to the viewer's current organization). The
   * viewer must be a full member; the policy enforces this.
   */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateDjEngagement. */
export type CreateDjEngagementPayload = {
  __typename?: 'CreateDjEngagementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<DjEngagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateHardwareCheckoutSession */
export type CreateHardwareCheckoutSessionInput = {
  cancelUrl: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Either 'audio' or 'video' */
  productType: Scalars['String']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
  shippingAddress?: InputMaybe<Scalars['JSON']['input']>;
  /** Stripe price ID for the hardware product */
  stripePriceId: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};

/** Autogenerated return type of CreateHardwareCheckoutSession. */
export type CreateHardwareCheckoutSessionPayload = {
  __typename?: 'CreateHardwareCheckoutSessionPayload';
  checkoutSession: CheckoutSession;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of CreateLocation */
export type CreateLocationInput = {
  address: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Freeform opening hours, e.g. "Open till 2" */
  hoursNote?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Organization ID (defaults to current user's organization) */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  publicEmail?: InputMaybe<Scalars['String']['input']>;
  timeZone: Scalars['String']['input'];
};

/** Autogenerated return type of CreateLocation. */
export type CreateLocationPayload = {
  __typename?: 'CreateLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  location: Location;
};

/** Autogenerated input type of CreateOauthApplication */
export type CreateOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateOauthApplication. */
export type CreateOauthApplicationPayload = {
  __typename?: 'CreateOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  oauthApplication: OauthApplication;
};

/** Autogenerated input type of CreatePlaylist */
export type CreatePlaylistInput = {
  aiGenerated?: InputMaybe<Scalars['Boolean']['input']>;
  aiPrompt?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Organization ID (defaults to current user's organization) */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreatePlaylist. */
export type CreatePlaylistPayload = {
  __typename?: 'CreatePlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  playlist: Playlist;
};

/** Autogenerated input type of CreateStation */
export type CreateStationInput = {
  /** AI prompt describing the station (e.g., 'upbeat coffee shop music', 'relaxing jazz for evening') */
  aiPrompt: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Organization ID (defaults to current user's organization) */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateStation. */
export type CreateStationPayload = {
  __typename?: 'CreateStationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  playlist: Playlist;
};

/** Autogenerated input type of CreateTrack */
export type CreateTrackInput = {
  albumId?: InputMaybe<Scalars['ID']['input']>;
  artistIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  audioFeatures?: InputMaybe<TrackAudioFeatureInput>;
  audioSignedId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverSignedId?: InputMaybe<Scalars['ID']['input']>;
  discNumber?: InputMaybe<Scalars['Int']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  explicit?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  popularity?: InputMaybe<Scalars['Int']['input']>;
  trackNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of CreateUser */
export type CreateUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userInput: UserInput;
};

/** Autogenerated return type of CreateUser. */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  user: User;
};

/** Autogenerated input type of CreateVideo */
export type CreateVideoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** ActiveStorage signed blob ID from a direct upload */
  originalSignedId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of CreateVideo. */
export type CreateVideoPayload = {
  __typename?: 'CreateVideoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  video?: Maybe<Video>;
};

/** Autogenerated input type of CreateVideoPlaylist */
export type CreateVideoPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Initial videos, in order */
  videoIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of CreateVideoPlaylist. */
export type CreateVideoPlaylistPayload = {
  __typename?: 'CreateVideoPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  videoPlaylist?: Maybe<VideoPlaylist>;
};

/** Autogenerated input type of CreateVideos */
export type CreateVideosInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  items: Array<VideoUploadItemInput>;
};

/** Autogenerated return type of CreateVideos. */
export type CreateVideosPayload = {
  __typename?: 'CreateVideosPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  videos: Array<Video>;
};

/** Autogenerated input type of CreateVoiceMessage */
export type CreateVoiceMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Voice message attributes */
  input: VoiceMessageInput;
};

/** Autogenerated return type of CreateVoiceMessage. */
export type CreateVoiceMessagePayload = {
  __typename?: 'CreateVoiceMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  voiceMessage?: Maybe<VoiceMessage>;
};

/** Autogenerated input type of CreateVoiceMessageSchedule */
export type CreateVoiceMessageScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Voice message schedule attributes */
  input: VoiceMessageScheduleInput;
};

/** Autogenerated return type of CreateVoiceMessageSchedule. */
export type CreateVoiceMessageSchedulePayload = {
  __typename?: 'CreateVoiceMessageSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  voiceMessageSchedule?: Maybe<VoiceMessageSchedule>;
};

/** Autogenerated input type of CreateZone */
export type CreateZoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateZone. */
export type CreateZonePayload = {
  __typename?: 'CreateZonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  zone?: Maybe<Zone>;
};

export type CustomerPortalSession = {
  __typename?: 'CustomerPortalSession';
  url: Scalars['String']['output'];
};

/** Daily listening hours data */
export type DailyListening = {
  __typename?: 'DailyListening';
  /** The date */
  date: Scalars['ISO8601Date']['output'];
  /** Hours of listening on this date */
  hours: Scalars['Float']['output'];
  /** Number of tracks played on this date */
  tracksPlayed: Scalars['Int']['output'];
};

/** Track starts per day, for the Event-explorer bar chart */
export type DailyPlays = {
  __typename?: 'DailyPlays';
  date: Scalars['ISO8601Date']['output'];
  /** COUNT of trackStarted events on this day */
  plays: Scalars['Int']['output'];
};

/** Date range for analytics */
export type DateRange = {
  __typename?: 'DateRange';
  /** Number of days in range */
  days: Scalars['Int']['output'];
  /** End date */
  endDate: Scalars['ISO8601Date']['output'];
  /** Start date */
  startDate: Scalars['ISO8601Date']['output'];
};

/** Autogenerated input type of DeactivateDevice */
export type DeactivateDeviceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Device to deactivate */
  deviceId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeactivateDevice. */
export type DeactivateDevicePayload = {
  __typename?: 'DeactivateDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Device>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Autogenerated input type of DeclineDjEngagement */
export type DeclineDjEngagementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeclineDjEngagement. */
export type DeclineDjEngagementPayload = {
  __typename?: 'DeclineDjEngagementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<DjEngagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeclineOrganizationInvitation */
export type DeclineOrganizationInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeclineOrganizationInvitation. */
export type DeclineOrganizationInvitationPayload = {
  __typename?: 'DeclineOrganizationInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteAdminQuery */
export type DeleteAdminQueryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAdminQuery. */
export type DeleteAdminQueryPayload = {
  __typename?: 'DeleteAdminQueryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteAdminReport */
export type DeleteAdminReportInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteAdminReport. */
export type DeleteAdminReportPayload = {
  __typename?: 'DeleteAdminReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteCampaign */
export type DeleteCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Campaign ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteCampaign. */
export type DeleteCampaignPayload = {
  __typename?: 'DeleteCampaignPayload';
  campaign?: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteDjTestimonial */
export type DeleteDjTestimonialInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDjTestimonial. */
export type DeleteDjTestimonialPayload = {
  __typename?: 'DeleteDjTestimonialPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteOauthApplication */
export type DeleteOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteOauthApplication. */
export type DeleteOauthApplicationPayload = {
  __typename?: 'DeleteOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeletePlaylist */
export type DeletePlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Playlist ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePlaylist. */
export type DeletePlaylistPayload = {
  __typename?: 'DeletePlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeletePlaylistSchedule */
export type DeletePlaylistScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePlaylistSchedule. */
export type DeletePlaylistSchedulePayload = {
  __typename?: 'DeletePlaylistSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  schedule: PlaylistSchedule;
};

/** Autogenerated input type of DeleteUser */
export type DeleteUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteUser. */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteVenueLink */
export type DeleteVenueLinkInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVenueLink. */
export type DeleteVenueLinkPayload = {
  __typename?: 'DeleteVenueLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteVideo */
export type DeleteVideoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVideo. */
export type DeleteVideoPayload = {
  __typename?: 'DeleteVideoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteVideoPlaylist */
export type DeleteVideoPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVideoPlaylist. */
export type DeleteVideoPlaylistPayload = {
  __typename?: 'DeleteVideoPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteVideoSchedule */
export type DeleteVideoScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVideoSchedule. */
export type DeleteVideoSchedulePayload = {
  __typename?: 'DeleteVideoSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteVoiceMessage */
export type DeleteVoiceMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Voice message ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVoiceMessage. */
export type DeleteVoiceMessagePayload = {
  __typename?: 'DeleteVoiceMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteVoiceMessageSchedule */
export type DeleteVoiceMessageScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Voice message schedule ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVoiceMessageSchedule. */
export type DeleteVoiceMessageSchedulePayload = {
  __typename?: 'DeleteVoiceMessageSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteZone */
export type DeleteZoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Zone ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteZone. */
export type DeleteZonePayload = {
  __typename?: 'DeleteZonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Device = Node & {
  __typename?: 'Device';
  active: Scalars['Boolean']['output'];
  appVersion?: Maybe<Scalars['String']['output']>;
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Canonical fleet status bucket (online / degraded / offline) — same logic the fleetSummary counters use */
  derivedStatus: Scalars['String']['output'];
  deviceType: DeviceType;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /**
   * Last heartbeat from this device. A device without a recent heartbeat is
   * offline; its offline duration is now minus lastSeenAt.
   */
  lastSeenAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  mediaKind: MediaKindEnum;
  name?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  status?: Maybe<Scalars['String']['output']>;
  /**
   * Internal fleet-ops telemetry (tailnet IP, fault reason, link quality). Staff
   * with devices.view only; nil for customer users.
   */
  telemetry?: Maybe<DeviceTelemetry>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zone?: Maybe<Zone>;
};

/** The connection type for Device. */
export type DeviceConnection = {
  __typename?: 'DeviceConnection';
  /** A list of edges. */
  edges: Array<DeviceEdge>;
  /** A list of nodes. */
  nodes: Array<Device>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DeviceEdge = {
  __typename?: 'DeviceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Device>;
};

/** Location analytics data for a specific device */
export type DeviceLocationAnalytics = {
  __typename?: 'DeviceLocationAnalytics';
  /** Current city */
  city?: Maybe<Scalars['String']['output']>;
  /** Current country */
  country?: Maybe<Scalars['String']['output']>;
  /** Device unique identifier */
  deviceId: Scalars['ID']['output'];
  /** Device name */
  deviceName?: Maybe<Scalars['String']['output']>;
  /** Internet service provider */
  isp?: Maybe<Scalars['String']['output']>;
  /** When location was last updated */
  lastLocationUpdate?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When device was last seen */
  lastSeen?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current latitude coordinate */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Total listening time in hours */
  listeningTimeHours: Scalars['Float']['output'];
  /** Total listening time in seconds */
  listeningTimeSeconds: Scalars['Int']['output'];
  /** Human-readable location name */
  locationDisplayName: Scalars['String']['output'];
  /** Current longitude coordinate */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The organization */
  organization?: Maybe<Organization>;
  /** Organization ID */
  organizationId?: Maybe<Scalars['ID']['output']>;
  /** Current region/state */
  region?: Maybe<Scalars['String']['output']>;
  /** Current device status */
  status?: Maybe<Scalars['String']['output']>;
  /** Current timezone */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Total events from this device */
  totalEvents: Scalars['Int']['output'];
  /** Number of unique tracks played */
  uniqueTracksPlayed: Scalars['Int']['output'];
  /** The zone */
  zone?: Maybe<Zone>;
  /** Zone ID where device is located */
  zoneId?: Maybe<Scalars['ID']['output']>;
};

/** Fleet telemetry for a device (tailnet identity, boot time, firmware, link quality) */
export type DeviceTelemetry = {
  __typename?: 'DeviceTelemetry';
  bootedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  firmwareVersion?: Maybe<Scalars['String']['output']>;
  headscaleNodeId?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lastErrorAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  latencyMs?: Maybe<Scalars['Float']['output']>;
  packetLossPct?: Maybe<Scalars['Float']['output']>;
  tailnetIp?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Device type enum */
export enum DeviceType {
  Desktop = 'DESKTOP',
  Hardware = 'HARDWARE',
  Web = 'WEB'
}

/** Autogenerated input type of DisconnectDevice */
export type DisconnectDeviceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Device to disconnect */
  deviceId: Scalars['ID']['input'];
};

/** Autogenerated return type of DisconnectDevice. */
export type DisconnectDevicePayload = {
  __typename?: 'DisconnectDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  success: Scalars['Boolean']['output'];
};

export type Discover = {
  __typename?: 'Discover';
  businesses: Array<Category>;
  categoryAlbums?: Maybe<AlbumConnection>;
  categoryArtists?: Maybe<ArtistConnection>;
  categoryTracks?: Maybe<TrackConnection>;
  decades: Array<Category>;
  energyLevels: Array<Category>;
  genres: GenreConnection;
  seasonal: Array<Category>;
  sounds: Array<Category>;
  topCategories: Array<Category>;
};


export type DiscoverCategoryAlbumsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DiscoverCategoryArtistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DiscoverCategoryTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type DiscoverGenresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of DislikePlaylistTrack */
export type DislikePlaylistTrackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Playlist ID (non-station) */
  playlistId: Scalars['ID']['input'];
  /** Track ID to dislike */
  trackId: Scalars['ID']['input'];
};

/** Autogenerated return type of DislikePlaylistTrack. */
export type DislikePlaylistTrackPayload = {
  __typename?: 'DislikePlaylistTrackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  feedback?: Maybe<PlaylistTrackFeedback>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DislikeStationTrack */
export type DislikeStationTrackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Station playlist ID */
  playlistId: Scalars['ID']['input'];
  /** Track ID to dislike */
  trackId: Scalars['ID']['input'];
};

/** Autogenerated return type of DislikeStationTrack. */
export type DislikeStationTrackPayload = {
  __typename?: 'DislikeStationTrackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  feedback?: Maybe<StationTrackFeedback>;
  success: Scalars['Boolean']['output'];
};

export type DjEngagement = Node & {
  __typename?: 'DjEngagement';
  activatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  djProfile: DjProfile;
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  endsOn?: Maybe<Scalars['ISO8601Date']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  rateCents?: Maybe<Scalars['Int']['output']>;
  rateCurrency: Scalars['String']['output'];
  rateType?: Maybe<DjRateType>;
  startsOn?: Maybe<Scalars['ISO8601Date']['output']>;
  status: DjEngagementStatus;
  terms?: Maybe<Scalars['String']['output']>;
};

/** Lifecycle status of a DJ engagement */
export enum DjEngagementStatus {
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Declined = 'DECLINED',
  Inquiry = 'INQUIRY',
  Proposed = 'PROPOSED',
  Terminated = 'TERMINATED'
}

export type DjProfile = Node & {
  __typename?: 'DjProfile';
  bio?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName: Scalars['String']['output'];
  /**
   * Total engagements for this profile, across all engagement statuses. Staff with
   * dj.manage only — nil for public directory viewers.
   */
  engagementsCount?: Maybe<Scalars['Int']['output']>;
  genres: Array<Genre>;
  headline?: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  links: Scalars['JSON']['output'];
  markets: Array<Market>;
  photoCardUrl?: Maybe<Scalars['String']['output']>;
  photoThumbUrl?: Maybe<Scalars['String']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  rateCents?: Maybe<Scalars['Int']['output']>;
  rateCurrency: Scalars['String']['output'];
  rateNotes?: Maybe<Scalars['String']['output']>;
  rateType?: Maybe<DjRateType>;
  samplePlaylists: Array<DjSamplePlaylist>;
  slug: Scalars['String']['output'];
  status: DjProfileStatus;
  testimonials: Array<DjTestimonial>;
  yearsExperience?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for DjProfile. */
export type DjProfileConnection = {
  __typename?: 'DjProfileConnection';
  /** A list of edges. */
  edges: Array<DjProfileEdge>;
  /** A list of nodes. */
  nodes: Array<DjProfile>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type DjProfileEdge = {
  __typename?: 'DjProfileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DjProfile>;
};

/** Lifecycle status of a DJ profile */
export enum DjProfileStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Suspended = 'SUSPENDED'
}

/** How a DJ structures their rate */
export enum DjRateType {
  Custom = 'CUSTOM',
  Hourly = 'HOURLY',
  PerEvent = 'PER_EVENT'
}

export type DjSamplePlaylist = {
  __typename?: 'DjSamplePlaylist';
  description?: Maybe<Scalars['String']['output']>;
  /** The underlying playlist id */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  tags: Scalars['JSON']['output'];
  totalDurationMs: Scalars['BigInt']['output'];
  trackCount: Scalars['Int']['output'];
  tracks: Array<DjSampleTrack>;
};

export type DjSampleTrack = {
  __typename?: 'DjSampleTrack';
  artistNames: Array<Scalars['String']['output']>;
  coverThumbUrl?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  explicit?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** Autogenerated input type of DjSignUp */
export type DjSignUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

/** Autogenerated return type of DjSignUp. */
export type DjSignUpPayload = {
  __typename?: 'DjSignUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type DjTestimonial = Node & {
  __typename?: 'DjTestimonial';
  authorName: Scalars['String']['output'];
  authorTitle?: Maybe<Scalars['String']['output']>;
  displayed: Scalars['Boolean']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  quote: Scalars['String']['output'];
};

/** Dimension to group Event-explorer aggregation rows by */
export enum EventQueryDimension {
  /** Group by calendar day (UTC) of the event */
  Day = 'DAY',
  /** Group by organization */
  Org = 'ORG',
  /** Group by zone */
  Zone = 'ZONE'
}

/** Filters and grouping for the staff Event-explorer aggregation */
export type EventQueryInput = {
  /** Start date (inclusive, from the beginning of the day) */
  from: Scalars['ISO8601Date']['input'];
  /** 1 or 2 distinct dimensions to group by; empty or more than 2 is rejected */
  groupBy: Array<EventQueryDimension>;
  /**
   * 0-100. When set, plays stays the raw trackStarted count, but hours and
   * avgCompletionPct are computed only over trackEnded rows with completion
   * at/above this threshold, and skipRatePct becomes the share of ALL qualifying
   * trackEnded rows below the threshold.
   */
  minCompletionPct?: InputMaybe<Scalars['Int']['input']>;
  /** Only events for this organization */
  orgId?: InputMaybe<Scalars['ID']['input']>;
  /** End date (inclusive, to the end of the day). The range may span at most 92 days. */
  to: Scalars['ISO8601Date']['input'];
  /** Only events for this zone */
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};

/** Result of the staff Event-explorer aggregation */
export type EventQueryResult = {
  __typename?: 'EventQueryResult';
  /** Plays per day over the same filters, for the bar chart */
  daily: Array<DailyPlays>;
  /** Wall time of the aggregation in milliseconds */
  elapsedMs: Scalars['Int']['output'];
  /** Aggregated groups, ordered by plays desc, capped at 500 */
  rows: Array<EventQueryRow>;
  /** Number of groups before the 500-row cap */
  totalRows: Scalars['Int']['output'];
};

/** One aggregated group from the Event-explorer query */
export type EventQueryRow = {
  __typename?: 'EventQueryRow';
  /** AVG completion (LEAST(position/duration, 1)) * 100 over qualifying trackEnded rows; null when none qualify */
  avgCompletionPct?: Maybe<Scalars['Float']['output']>;
  /** Present when grouped by DAY */
  date?: Maybe<Scalars['ISO8601Date']['output']>;
  /**
   * SUM of trackEnded position_ms / 3,600,000 (listened hours). When
   * minCompletionPct is set, only trackEnded rows at/above the threshold are summed.
   */
  hours: Scalars['Float']['output'];
  /**
   * SUM of jukebox_play_events.payment_amount_cents for the same group and
   * filters; null when the group has no paid jukebox plays
   */
  jukeboxRevenueCents?: Maybe<Scalars['Int']['output']>;
  /** Present when grouped by ORG */
  organization?: Maybe<Organization>;
  /** COUNT of trackStarted events */
  plays: Scalars['Int']['output'];
  /**
   * Share of qualifying trackEnded rows with completion below 0.5 (or below
   * minCompletionPct when set), * 100; null when none qualify
   */
  skipRatePct?: Maybe<Scalars['Float']['output']>;
  /** Present when grouped by ZONE */
  zone?: Maybe<Zone>;
};

/** Autogenerated input type of FetchSpotifyPlaylists */
export type FetchSpotifyPlaylistsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of FetchSpotifyPlaylists. */
export type FetchSpotifyPlaylistsPayload = {
  __typename?: 'FetchSpotifyPlaylistsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  playlists: Array<SpotifyPlaylist>;
  requiresReauth: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

/** Device count per firmware version; a null version is the unknown bucket */
export type FirmwareCount = {
  __typename?: 'FirmwareCount';
  count: Scalars['Int']['output'];
  version?: Maybe<Scalars['String']['output']>;
};

/**
 * A device that is not derived-online right now, with a human-readable reason
 * derived from existing state (offline since X, never provisioned, degraded)
 */
export type FleetNotHealthyDevice = {
  __typename?: 'FleetNotHealthyDevice';
  code?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['ID']['output'];
  orgName: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  zoneName?: Maybe<Scalars['String']['output']>;
};

/** Org-wide rollups for the fleet home stat strip */
export type FleetOverview = {
  __typename?: 'FleetOverview';
  /** Jukebox requests across all zones */
  jukeboxRequests: Scalars['Int']['output'];
  /** Venue net revenue share from jukebox plays, in cents */
  jukeboxRevenueCents: Scalars['Int']['output'];
  /** Total listening time across all zones, in seconds */
  listeningSeconds: Scalars['Int']['output'];
  /** Same metrics for the immediately preceding window, for the comparison sentence */
  previousPeriod: FleetOverviewPeriod;
};

/** One period's fleet-wide totals */
export type FleetOverviewPeriod = {
  __typename?: 'FleetOverviewPeriod';
  /** Jukebox requests across all zones */
  jukeboxRequests: Scalars['Int']['output'];
  /** Venue net revenue share from jukebox plays, in cents */
  jukeboxRevenueCents: Scalars['Int']['output'];
  /** Total listening time across all zones, in seconds */
  listeningSeconds: Scalars['Int']['output'];
};

/** Time window for the fleet overview stat strip */
export enum FleetOverviewRangeEnum {
  /** Trailing 7 days, compared with the 7 days before */
  D7 = 'D7',
  /** Trailing 24 hours, compared with the 24 hours before */
  H24 = 'H24',
  /** Today so far, compared with yesterday up to the same time */
  Now = 'NOW'
}

/** Aggregate device-fleet counts using the derived status semantics (see Device#derived_status) */
export type FleetSummary = {
  __typename?: 'FleetSummary';
  degraded: Scalars['Int']['output'];
  /** Device counts grouped by telemetry firmware version, falling back to app_version */
  firmware: Array<FirmwareCount>;
  /**
   * Devices not derived-online right now — degraded, offline or never provisioned
   * — most recently seen first, capped at 50 rows
   */
  notHealthy: Array<FleetNotHealthyDevice>;
  offline: Scalars['Int']['output'];
  online: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  /** Devices registered but never seen (no heartbeat yet) */
  unprovisioned: Scalars['Int']['output'];
};

/** Autogenerated input type of GenerateAiMusicPlaylist */
export type GenerateAiMusicPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Generate instrumental only (default true) */
  instrumental?: InputMaybe<Scalars['Boolean']['input']>;
  /** AI model to use (required for orgs with mixed plans, auto-resolved for uniform plans) */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Playlist name */
  name: Scalars['String']['input'];
  /** Elements to avoid in generated music */
  negativePrompt?: InputMaybe<Scalars['String']['input']>;
  /** Organization ID (defaults to current user's organization) */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Music description prompt */
  prompt: Scalars['String']['input'];
  /** Number of tracks to generate (1-20, default 5) */
  trackCount?: InputMaybe<Scalars['Int']['input']>;
  /** Duration of each track in seconds (30-600, default 180) */
  trackDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of GenerateAiMusicPlaylist. */
export type GenerateAiMusicPlaylistPayload = {
  __typename?: 'GenerateAiMusicPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  playlist?: Maybe<Playlist>;
};

/** Autogenerated input type of GenerateAiTracksForPlaylist */
export type GenerateAiTracksForPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Generate instrumental only (default true) */
  instrumental?: InputMaybe<Scalars['Boolean']['input']>;
  /** AI model to use (required for orgs with mixed plans, auto-resolved for uniform plans) */
  model?: InputMaybe<Scalars['String']['input']>;
  /** Elements to avoid in generated music */
  negativePrompt?: InputMaybe<Scalars['String']['input']>;
  /** ID of the playlist to add tracks to */
  playlistId: Scalars['ID']['input'];
  /** Music description prompt */
  prompt: Scalars['String']['input'];
  /** Number of tracks to generate (1-20, default 5) */
  trackCount?: InputMaybe<Scalars['Int']['input']>;
  /** Duration of each track in seconds (30-600, default 180) */
  trackDurationSeconds?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of GenerateAiTracksForPlaylist. */
export type GenerateAiTracksForPlaylistPayload = {
  __typename?: 'GenerateAiTracksForPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  playlist?: Maybe<Playlist>;
};

/** Autogenerated input type of GenerateAiVideo */
export type GenerateAiVideoInput = {
  aspectRatio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  durationSeconds?: InputMaybe<Scalars['Int']['input']>;
  negativePrompt?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
};

/** Autogenerated return type of GenerateAiVideo. */
export type GenerateAiVideoPayload = {
  __typename?: 'GenerateAiVideoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  videoGeneration?: Maybe<VideoGeneration>;
};

export type Genre = Node & {
  __typename?: 'Genre';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Genre. */
export type GenreConnection = {
  __typename?: 'GenreConnection';
  /** A list of edges. */
  edges: Array<GenreEdge>;
  /** A list of nodes. */
  nodes: Array<Genre>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type GenreEdge = {
  __typename?: 'GenreEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Genre>;
};

export type HardwareOrder = Node & {
  __typename?: 'HardwareOrder';
  createdAt: Scalars['ISO8601DateTime']['output'];
  hardwareProduct?: Maybe<HardwareProduct>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  quantity: Scalars['Int']['output'];
  /** pending | paid | shipped | delivered | cancelled */
  status: Scalars['String']['output'];
  stripeCheckoutSessionId?: Maybe<Scalars['String']['output']>;
  /** quantity * unit price of the product */
  totalCents: Scalars['Int']['output'];
};

/** The connection type for HardwareOrder. */
export type HardwareOrderConnection = {
  __typename?: 'HardwareOrderConnection';
  /** A list of edges. */
  edges: Array<HardwareOrderEdge>;
  /** A list of nodes. */
  nodes: Array<HardwareOrder>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type HardwareOrderEdge = {
  __typename?: 'HardwareOrderEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<HardwareOrder>;
};

export type HardwareProduct = Node & {
  __typename?: 'HardwareProduct';
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priceCents: Scalars['Int']['output'];
  /** Either 'audio' or 'video' */
  productType: Scalars['String']['output'];
  stripePriceId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ImportPlaylist */
export type ImportPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional name for the copy (defaults to the source name) */
  name?: InputMaybe<Scalars['String']['input']>;
  sourcePlaylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of ImportPlaylist. */
export type ImportPlaylistPayload = {
  __typename?: 'ImportPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  playlist?: Maybe<Playlist>;
  tracksCopied: Scalars['Int']['output'];
  /** Tracks excluded by the target org's plan (e.g. licensed tracks on a Royalty-Free plan) */
  tracksSkipped: Scalars['Int']['output'];
};

/** Autogenerated input type of ImportSpotifyPlaylist */
export type ImportSpotifyPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Custom name for the imported playlist (uses Spotify name if not provided) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Spotify ID of the playlist to import */
  spotifyPlaylistId: Scalars['String']['input'];
};

/** Autogenerated return type of ImportSpotifyPlaylist. */
export type ImportSpotifyPlaylistPayload = {
  __typename?: 'ImportSpotifyPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  playlist?: Maybe<Playlist>;
  requiresReauth: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  syncHistoryId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of ImportVideos */
export type ImportVideosInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  items: Array<VideoImportItemInput>;
  source: VideoImportSourceEnum;
};

/** Autogenerated return type of ImportVideos. */
export type ImportVideosPayload = {
  __typename?: 'ImportVideosPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  videos: Array<Video>;
};

/** Integrations screen payload: OAuth applications (aggregate token counts only) and third-party service status */
export type IntegrationsOverview = {
  __typename?: 'IntegrationsOverview';
  /** All OAuth applications, via the policy-scoped OauthApplicationsQuery */
  oauthApplications: Array<OauthApplication>;
  /** Third-party services with configuration presence and cheap status */
  thirdParty: Array<ThirdPartyIntegration>;
};

/** Autogenerated input type of InviteOrganizationMember */
export type InviteOrganizationMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  membershipRole?: InputMaybe<MembershipRole>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of InviteOrganizationMember. */
export type InviteOrganizationMemberPayload = {
  __typename?: 'InviteOrganizationMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** Set when the email belongs to an existing account: it joins once its owner accepts */
  organizationInvitation?: Maybe<OrganizationInvitation>;
  /** Set when the invite created a new account (it joins straight away) */
  organizationMembership?: Maybe<OrganizationMembership>;
};

export type Invoice = {
  __typename?: 'Invoice';
  /** Amount in cents */
  amount: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoicePdf?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  pdfUrl?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** A failed Sidekiq job from the retry set (dead: false) or the dead set (dead: true) */
export type JobFailure = {
  __typename?: 'JobFailure';
  dead: Scalars['Boolean']['output'];
  errorClass?: Maybe<Scalars['String']['output']>;
  /** Truncated to 500 characters */
  errorMessage?: Maybe<Scalars['String']['output']>;
  failedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  jid: Scalars['String']['output'];
  jobClass: Scalars['String']['output'];
  queue: Scalars['String']['output'];
  retryCount: Scalars['Int']['output'];
};

/** Autogenerated input type of JukeboxCancelPendingRequest */
export type JukeboxCancelPendingRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  queueItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of JukeboxCancelPendingRequest. */
export type JukeboxCancelPendingRequestPayload = {
  __typename?: 'JukeboxCancelPendingRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  queueItemId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of JukeboxCancelRequest */
export type JukeboxCancelRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  previousTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  queueItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of JukeboxCancelRequest. */
export type JukeboxCancelRequestPayload = {
  __typename?: 'JukeboxCancelRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  queueItemId?: Maybe<Scalars['ID']['output']>;
};

/** One jukebox config key with its effective value and where in the org → location → zone hierarchy that value was decided. */
export type JukeboxConfigProvenance = {
  __typename?: 'JukeboxConfigProvenance';
  effectiveValue?: Maybe<Scalars['JSON']['output']>;
  /** camelCase config key, e.g. standardPriceCents */
  key: Scalars['String']['output'];
  /** Which level decided the effective value: organization, location, zone or default */
  level: Scalars['String']['output'];
  /** Raw value at location level (null when unset) */
  locationValue?: Maybe<Scalars['JSON']['output']>;
  /** Raw value at org level (null when unset) */
  organizationValue?: Maybe<Scalars['JSON']['output']>;
  /** Raw value at zone level (null when unset) */
  zoneValue?: Maybe<Scalars['JSON']['output']>;
};

export type JukeboxConfiguration = {
  __typename?: 'JukeboxConfiguration';
  allowedPlaylistIds?: Maybe<Array<Scalars['ID']['output']>>;
  boostPriceCents?: Maybe<Scalars['Int']['output']>;
  cooldownSeconds?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  densityMax?: Maybe<Scalars['Int']['output']>;
  densityMin?: Maybe<Scalars['Int']['output']>;
  duplicateWindowTracks?: Maybe<Scalars['Int']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  level: Scalars['String']['output'];
  locationId?: Maybe<Scalars['ID']['output']>;
  maxQueueSize?: Maybe<Scalars['Int']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  priorityPriceCents?: Maybe<Scalars['Int']['output']>;
  revenueSharePct?: Maybe<Scalars['Float']['output']>;
  scheduleEndTime?: Maybe<Scalars['String']['output']>;
  scheduleRrule?: Maybe<Scalars['String']['output']>;
  scheduleStartTime?: Maybe<Scalars['String']['output']>;
  standardPriceCents?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zoneId?: Maybe<Scalars['ID']['output']>;
};

/** Input for updating jukebox configuration at any level */
export type JukeboxConfigurationInput = {
  allowedPlaylistIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  boostPriceCents?: InputMaybe<Scalars['Int']['input']>;
  cooldownSeconds?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  densityMax?: InputMaybe<Scalars['Int']['input']>;
  densityMin?: InputMaybe<Scalars['Int']['input']>;
  duplicateWindowTracks?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  maxQueueSize?: InputMaybe<Scalars['Int']['input']>;
  /** controlled, ai_guided, open, or scheduled */
  mode?: InputMaybe<Scalars['String']['input']>;
  priorityPriceCents?: InputMaybe<Scalars['Int']['input']>;
  revenueSharePct?: InputMaybe<Scalars['Float']['input']>;
  scheduleEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduleRrule?: InputMaybe<Scalars['String']['input']>;
  scheduleStartTime?: InputMaybe<Scalars['String']['input']>;
  standardPriceCents?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of JukeboxConfirmPayment */
export type JukeboxConfirmPaymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  queueItemId: Scalars['ID']['input'];
};

/** Autogenerated return type of JukeboxConfirmPayment. */
export type JukeboxConfirmPaymentPayload = {
  __typename?: 'JukeboxConfirmPaymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  estimatedPlayAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  queueItemId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of JukeboxEmergencyLock */
export type JukeboxEmergencyLockInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of JukeboxEmergencyLock. */
export type JukeboxEmergencyLockPayload = {
  __typename?: 'JukeboxEmergencyLockPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  refundedCount?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of JukeboxLockAll */
export type JukeboxLockAllInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Only lock zones belonging to this organization */
  orgId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of JukeboxLockAll. */
export type JukeboxLockAllPayload = {
  __typename?: 'JukeboxLockAllPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  /** Zones successfully locked */
  lockedZones: Scalars['Int']['output'];
  /** Queue items refunded across all locked zones */
  refundedCount: Scalars['Int']['output'];
};

/** Aggregate jukebox counters for spin-admin, optionally scoped to one organization */
export type JukeboxOverview = {
  __typename?: 'JukeboxOverview';
  /** Zones whose jukebox queue is currently paused or emergency-locked */
  lockedZones: Scalars['Int']['output'];
  /** Queued jukebox requests across all scoped zones */
  pendingRequests: Scalars['Int']['output'];
  /** Jukebox play events recorded today (UTC) */
  playedToday: Scalars['Int']['output'];
  /** Zones with non-empty queues, deepest queue first, capped at 50 */
  queues: Array<JukeboxZoneQueue>;
  /** Sum of payment amounts over today's (UTC) play events */
  revenueTodayCents: Scalars['Int']['output'];
  /** Kept zones whose effective (zone overrides location overrides org) jukebox configuration is enabled */
  zonesEnabled: Scalars['Int']['output'];
};

export type JukeboxPageInfo = {
  __typename?: 'JukeboxPageInfo';
  /** True if more items exist beyond the current page */
  hasMore: Scalars['Boolean']['output'];
  /** Offset to request for the next page; null when has_more is false */
  nextOffset?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of JukeboxPauseQueue */
export type JukeboxPauseQueueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** true to pause, false to resume */
  paused: Scalars['Boolean']['input'];
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of JukeboxPauseQueue. */
export type JukeboxPauseQueuePayload = {
  __typename?: 'JukeboxPauseQueuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  paused: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

/** Admin view of one queued jukebox request. The id is the JukeboxQueueItem id that jukeboxRemoveItem(itemId:) accepts. */
export type JukeboxQueueItemInfo = {
  __typename?: 'JukeboxQueueItemInfo';
  artistName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Amount the patron paid for this request, when it was a paid request */
  paidCents?: Maybe<Scalars['Int']['output']>;
  /** True for the paid priority tier */
  priority: Scalars['Boolean']['output'];
  /** When the item entered the queue (queued_at) */
  requestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  trackName: Scalars['String']['output'];
};

/** Autogenerated input type of JukeboxRemoveItem */
export type JukeboxRemoveItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['ID']['input'];
};

/** Autogenerated return type of JukeboxRemoveItem. */
export type JukeboxRemoveItemPayload = {
  __typename?: 'JukeboxRemoveItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of JukeboxSkipCurrent */
export type JukeboxSkipCurrentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of JukeboxSkipCurrent. */
export type JukeboxSkipCurrentPayload = {
  __typename?: 'JukeboxSkipCurrentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of JukeboxSubmitRequest */
export type JukeboxSubmitRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  tier: Scalars['String']['input'];
  trackId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of JukeboxSubmitRequest. */
export type JukeboxSubmitRequestPayload = {
  __typename?: 'JukeboxSubmitRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  clientSecret?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  estimatedPlayAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  queueItemId?: Maybe<Scalars['ID']['output']>;
};

/** Why a track cannot be requested in the current zone/mode context */
export enum JukeboxUnavailableReasonEnum {
  /** AI-guided mode: FitScoreService rejected this track as a poor fit */
  AiGuidedRejected = 'AI_GUIDED_REJECTED',
  /** Controlled mode: track is not in the zone's allowed playlists */
  NotInAllowedPlaylists = 'NOT_IN_ALLOWED_PLAYLISTS'
}

/** One zone's live jukebox queue as seen by spin-admin */
export type JukeboxZoneQueue = {
  __typename?: 'JukeboxZoneQueue';
  /** Queued items in play order (priority score desc, oldest first) */
  items: Array<JukeboxQueueItemInfo>;
  organization: Organization;
  /** Whether the zone's queue is currently paused (jukeboxPauseQueue or an emergency lock) */
  paused: Scalars['Boolean']['output'];
  zone: Zone;
};

/** Autogenerated input type of KaraokeAddEntry */
export type KaraokeAddEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  karaokeTrackId: Scalars['ID']['input'];
  sessionId: Scalars['ID']['input'];
  singerName: Scalars['String']['input'];
};

/** Autogenerated return type of KaraokeAddEntry. */
export type KaraokeAddEntryPayload = {
  __typename?: 'KaraokeAddEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<KaraokeQueueEntry>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of KaraokeEndSession */
export type KaraokeEndSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of KaraokeEndSession. */
export type KaraokeEndSessionPayload = {
  __typename?: 'KaraokeEndSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  session?: Maybe<KaraokeSession>;
};

/** An open (live) karaoke session with its zone and organization context for spin-admin */
export type KaraokeLiveSession = {
  __typename?: 'KaraokeLiveSession';
  organization: Organization;
  /** Entries currently waiting in the queue */
  queueDepth: Scalars['Int']['output'];
  session: KaraokeSession;
  zone: Zone;
};

export type KaraokeQueueEntry = {
  __typename?: 'KaraokeQueueEntry';
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  karaokeTrack: KaraokeTrack;
  position: Scalars['Int']['output'];
  requestedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  singerName: Scalars['String']['output'];
  skipReason?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
};

/** Autogenerated input type of KaraokeRemoveEntry */
export type KaraokeRemoveEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryId: Scalars['ID']['input'];
};

/** Autogenerated return type of KaraokeRemoveEntry. */
export type KaraokeRemoveEntryPayload = {
  __typename?: 'KaraokeRemoveEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<KaraokeQueueEntry>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of KaraokeReorderEntry */
export type KaraokeReorderEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entryId: Scalars['ID']['input'];
  position: Scalars['Int']['input'];
};

/** Autogenerated return type of KaraokeReorderEntry. */
export type KaraokeReorderEntryPayload = {
  __typename?: 'KaraokeReorderEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<KaraokeQueueEntry>;
  errors: Array<Scalars['String']['output']>;
};

export type KaraokeSession = {
  __typename?: 'KaraokeSession';
  currentEntry?: Maybe<KaraokeQueueEntry>;
  endedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['ID']['output'];
  queue: Array<KaraokeQueueEntry>;
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  status: Scalars['String']['output'];
  zoneId: Scalars['ID']['output'];
};

/** Autogenerated input type of KaraokeSkipCurrent */
export type KaraokeSkipCurrentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  sessionId: Scalars['ID']['input'];
};

/** Autogenerated return type of KaraokeSkipCurrent. */
export type KaraokeSkipCurrentPayload = {
  __typename?: 'KaraokeSkipCurrentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  entry?: Maybe<KaraokeQueueEntry>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of KaraokeStartSession */
export type KaraokeStartSessionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of KaraokeStartSession. */
export type KaraokeStartSessionPayload = {
  __typename?: 'KaraokeStartSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  session?: Maybe<KaraokeSession>;
};

export type KaraokeTrack = {
  __typename?: 'KaraokeTrack';
  availabilityStatus: Scalars['String']['output'];
  displayArtist?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  explicit: Scalars['Boolean']['output'];
  genre?: Maybe<Scalars['String']['output']>;
  hasSyncedLyrics: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Publish rates for one configured LavinMQ exchange */
export type LavinmqExchangeStat = {
  __typename?: 'LavinmqExchangeStat';
  name: Scalars['String']['output'];
  publishInRate?: Maybe<Scalars['Float']['output']>;
  publishOutRate?: Maybe<Scalars['Float']['output']>;
};

/** One LavinMQ queue as reported by the management API */
export type LavinmqQueueStat = {
  __typename?: 'LavinmqQueueStat';
  name: Scalars['String']['output'];
  publishRate?: Maybe<Scalars['Float']['output']>;
  ready: Scalars['Int']['output'];
  unacked: Scalars['Int']['output'];
};

/** LavinMQ management API stats; null when the management API is unreachable */
export type LavinmqStats = {
  __typename?: 'LavinmqStats';
  /** Only the exchanges configured in config.lavinmq.exchanges */
  exchanges: Array<LavinmqExchangeStat>;
  queues: Array<LavinmqQueueStat>;
};

/** Performing rights organizations supported by Spin */
export enum LicensingProEnum {
  /** American Society of Composers, Authors & Publishers */
  Ascap = 'ASCAP',
  /** Broadcast Music, Inc. */
  Bmi = 'BMI',
  /** Global Music Rights */
  Gmr = 'GMR',
  /** Society of European Stage Authors & Composers */
  Sesac = 'SESAC'
}

/** Autogenerated input type of LikePlaylistTrack */
export type LikePlaylistTrackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Playlist ID (non-station) */
  playlistId: Scalars['ID']['input'];
  /** Track ID to like */
  trackId: Scalars['ID']['input'];
};

/** Autogenerated return type of LikePlaylistTrack. */
export type LikePlaylistTrackPayload = {
  __typename?: 'LikePlaylistTrackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  feedback?: Maybe<PlaylistTrackFeedback>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of LikeStationTrack */
export type LikeStationTrackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Station playlist ID */
  playlistId: Scalars['ID']['input'];
  /** Track ID to like */
  trackId: Scalars['ID']['input'];
};

/** Autogenerated return type of LikeStationTrack. */
export type LikeStationTrackPayload = {
  __typename?: 'LikeStationTrackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  feedback?: Maybe<StationTrackFeedback>;
  success: Scalars['Boolean']['output'];
};

export type Location = Node & {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** This location's own hours. Null means it inherits the organization's. */
  hours?: Maybe<Scalars['JSON']['output']>;
  /** Free text beside the structured week, e.g. Kitchen closes at 11 */
  hoursNote?: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  publicEmail?: Maybe<Scalars['String']['output']>;
  /** Operational region used by the fleet home's coverage rollup */
  region?: Maybe<Scalars['String']['output']>;
  /** Effective venue profile with per-field source: location, organization or unset */
  resolvedVenueProfile: Scalars['JSON']['output'];
  timeZone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  venueLinks: Array<VenueLink>;
  zones?: Maybe<Array<Zone>>;
};

/** Analytics data grouped by geographical location */
export type LocationAnalytics = {
  __typename?: 'LocationAnalytics';
  /** City name */
  city?: Maybe<Scalars['String']['output']>;
  /** Country name */
  country?: Maybe<Scalars['String']['output']>;
  /** Average latitude for this location */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Total listening time in hours */
  listeningTimeHours: Scalars['Float']['output'];
  /** Total listening time in seconds */
  listeningTimeSeconds: Scalars['Int']['output'];
  /** Human-readable location name */
  locationDisplayName?: Maybe<Scalars['String']['output']>;
  /** Average longitude for this location */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** Region/state name */
  region?: Maybe<Scalars['String']['output']>;
  /** Primary timezone for this location */
  timezone?: Maybe<Scalars['String']['output']>;
  /** Most played tracks in this location */
  topTracks: Array<TopTrack>;
  /** Total number of playback events */
  totalEvents: Scalars['Int']['output'];
  /** Number of unique devices */
  uniqueDevices: Scalars['Int']['output'];
  /** Number of unique tracks played */
  uniqueTracks: Scalars['Int']['output'];
};

/** The connection type for Location. */
export type LocationConnection = {
  __typename?: 'LocationConnection';
  /** A list of edges. */
  edges: Array<LocationEdge>;
  /** A list of nodes. */
  nodes: Array<Location>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type LocationEdge = {
  __typename?: 'LocationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Location>;
};

/** How to group location analytics data */
export enum LocationGrouping {
  /** Group by city */
  City = 'CITY',
  /** Group by country */
  Country = 'COUNTRY',
  /** Group by region/state */
  Region = 'REGION',
  /** Group by timezone */
  Timezone = 'TIMEZONE'
}

/** Autogenerated input type of Logout */
export type LogoutInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of Logout. */
export type LogoutPayload = {
  __typename?: 'LogoutPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MarkConversationRead */
export type MarkConversationReadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkConversationRead. */
export type MarkConversationReadPayload = {
  __typename?: 'MarkConversationReadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  errors: Array<Scalars['String']['output']>;
};

export type Market = Node & {
  __typename?: 'Market';
  code: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** What a device plays */
export enum MediaKindEnum {
  /** Music player */
  Audio = 'audio',
  /** Karaoke renderer (instrumental + lyrics on a TV) */
  Karaoke = 'karaoke',
  /** Signage video player (screen) */
  Video = 'video'
}

/** The connection type for Organization. */
export type MembershipConnection = {
  __typename?: 'MembershipConnection';
  /** A list of edges. */
  edges: Array<MembershipEdge>;
  /** A list of nodes. */
  nodes: Array<Organization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type MembershipEdge = {
  __typename?: 'MembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organization>;
  role: MembershipRole;
};

/** Membership role enum */
export enum MembershipRole {
  Default = 'DEFAULT',
  ExternalDj = 'EXTERNAL_DJ',
  OrganizationAdmin = 'ORGANIZATION_ADMIN'
}

export type Message = Node & {
  __typename?: 'Message';
  body: Scalars['String']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  senderId: Scalars['ID']['output'];
  senderName: Scalars['String']['output'];
  sentByViewer: Scalars['Boolean']['output'];
};

/** A single labelled metric on a service status card */
export type Metric = {
  __typename?: 'Metric';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Org admin activates an engagement, granting the DJ external access to the organization */
  acceptDjEngagement: AcceptDjEngagementPayload;
  /** Accept an invitation to join an organization (the invited account only) */
  acceptOrganizationInvitation: AcceptOrganizationInvitationPayload;
  /** Activate a device, deactivating all other devices in the same zone */
  activateDevice: ActivateDevicePayload;
  addTrackToPlaylist: AddTrackToPlaylistPayload;
  addVideoToPlaylist: AddVideoToPlaylistPayload;
  addVideosToPlaylist: AddVideosToPlaylistPayload;
  /**
   * Pre-create an unprovisioned hardware device for an organization. Returns the
   * device code once for installer handoff. Requires the devices.provision staff permission.
   */
  adminProvisionDevice: AdminProvisionDevicePayload;
  /**
   * Bookmark a DJ for the given organizationId (defaults to the viewer's current
   * organization). The viewer must be a full member.
   */
  bookmarkDj: BookmarkDjPayload;
  /** Cancel all active AI track generations for a playlist */
  cancelAiTrackGeneration: CancelAiTrackGenerationPayload;
  /**
   * Cancel all paid zone line items at the end of the current billing period. The
   * organization's base subscription is never cancelled (base-subscription model);
   * zones stay billed and playable until period end. Undo per zone with
   * uncancelZoneBilling.
   */
  cancelSubscription: CancelSubscriptionPayload;
  /**
   * Cancel a zone's paid line item at the end of the current billing period
   * (add-on items are cancelled with it). Pass an add-on planId to cancel only
   * that add-on. The zone stays billed and playable until then; undo with
   * uncancelZoneBilling.
   */
  cancelZoneBilling: CancelZoneBillingPayload;
  /** Mark an active engagement as completed, revoking the DJ's access */
  completeDjEngagement: CompleteDjEngagementPayload;
  /** Mark the current organization's onboarding wizard as complete. Idempotent. */
  completeOnboarding: CompleteOnboardingPayload;
  /** Connect a device to a zone using the device token from the device */
  connectDevice: ConnectDevicePayload;
  /** Create a new API token for the organization */
  createApiToken: CreateApiTokenPayload;
  /** Create a new campaign */
  createCampaign: CreateCampaignPayload;
  createCheckoutSession: CreateCheckoutSessionPayload;
  createCustomerPortalSession: CreateCustomerPortalSessionPayload;
  /**
   * Start an engagement (hiring inquiry) with a DJ. Created for the given
   * organizationId, or the viewer's current organization by default; the viewer
   * must be a full member.
   */
  createDjEngagement: CreateDjEngagementPayload;
  createHardwareCheckoutSession: CreateHardwareCheckoutSessionPayload;
  createLocation: CreateLocationPayload;
  createOauthApplication: CreateOauthApplicationPayload;
  createPlaylist: CreatePlaylistPayload;
  createStation: CreateStationPayload;
  createTrack: Track;
  /**
   * Create a new user (system admin only). Creates the user in invited status and
   * sends an invitation email to set up their account.
   */
  createUser: CreateUserPayload;
  createVideo: CreateVideoPayload;
  createVideoPlaylist: CreateVideoPlaylistPayload;
  createVideos: CreateVideosPayload;
  /** Create a new voice message */
  createVoiceMessage: CreateVoiceMessagePayload;
  /** Create a new voice message schedule */
  createVoiceMessageSchedule: CreateVoiceMessageSchedulePayload;
  createZone: CreateZonePayload;
  /** Deactivate a device */
  deactivateDevice: DeactivateDevicePayload;
  /** DJ declines an inquiry or proposal */
  declineDjEngagement: DeclineDjEngagementPayload;
  /** Decline an invitation to join an organization (the invited account only) */
  declineOrganizationInvitation: DeclineOrganizationInvitationPayload;
  /** Delete a saved Event-explorer query (and any scheduled reports on it). Requires the analytics.query staff permission. */
  deleteAdminQuery: DeleteAdminQueryPayload;
  /** Delete a scheduled admin report. Requires the analytics.query staff permission. */
  deleteAdminReport: DeleteAdminReportPayload;
  /** Delete (soft delete) a campaign */
  deleteCampaign: DeleteCampaignPayload;
  /** Remove a testimonial from the viewer's DJ profile */
  deleteDjTestimonial: DeleteDjTestimonialPayload;
  deleteOauthApplication: DeleteOauthApplicationPayload;
  /** Soft-delete a playlist (preserves data; fires playlist.deleted event so zones fall back) */
  deletePlaylist: DeletePlaylistPayload;
  deletePlaylistSchedule: DeletePlaylistSchedulePayload;
  /** Soft-delete (discard) a user (system admin only). */
  deleteUser: DeleteUserPayload;
  deleteVenueLink: DeleteVenueLinkPayload;
  deleteVideo: DeleteVideoPayload;
  deleteVideoPlaylist: DeleteVideoPlaylistPayload;
  deleteVideoSchedule: DeleteVideoSchedulePayload;
  /** Delete a voice message */
  deleteVoiceMessage: DeleteVoiceMessagePayload;
  /** Delete a voice message schedule */
  deleteVoiceMessageSchedule: DeleteVoiceMessageSchedulePayload;
  /** Soft-delete a zone (schedules are retained but become inactive since the zone is discarded) */
  deleteZone: DeleteZonePayload;
  /** Disconnect (soft-delete) a device from its zone */
  disconnectDevice: DisconnectDevicePayload;
  dislikePlaylistTrack: DislikePlaylistTrackPayload;
  dislikeStationTrack: DislikeStationTrackPayload;
  /** Create a DJ account (user + personal workspace + draft profile). Requires an invite code while DJ signups are invite-only. */
  djSignUp: DjSignUpPayload;
  /** Fetch user's Spotify playlists */
  fetchSpotifyPlaylists: FetchSpotifyPlaylistsPayload;
  generateAiMusicPlaylist: GenerateAiMusicPlaylistPayload;
  generateAiTracksForPlaylist: GenerateAiTracksForPlaylistPayload;
  generateAiVideo: GenerateAiVideoPayload;
  /** Copy a playlist from the viewer's personal workspace into the current organization */
  importPlaylist: ImportPlaylistPayload;
  /** Import a Spotify playlist into the organization */
  importSpotifyPlaylist: ImportSpotifyPlaylistPayload;
  importVideos: ImportVideosPayload;
  /**
   * Invite someone to an organization. A new email creates the account and its
   * membership and sends a set-password email. An existing account gets a pending
   * invitation instead, which grants nothing until its owner accepts it
   * (acceptOrganizationInvitation).
   */
  inviteOrganizationMember: InviteOrganizationMemberPayload;
  jukeboxCancelPendingRequest: JukeboxCancelPendingRequestPayload;
  jukeboxCancelRequest: JukeboxCancelRequestPayload;
  jukeboxConfirmPayment: JukeboxConfirmPaymentPayload;
  jukeboxEmergencyLock: JukeboxEmergencyLockPayload;
  /**
   * Emergency-lock all zones with an enabled jukebox (scoped to orgId when given).
   * Requires the jukebox.manage staff permission.
   */
  jukeboxLockAll: JukeboxLockAllPayload;
  jukeboxPauseQueue: JukeboxPauseQueuePayload;
  jukeboxRemoveItem: JukeboxRemoveItemPayload;
  jukeboxSkipCurrent: JukeboxSkipCurrentPayload;
  jukeboxSubmitRequest: JukeboxSubmitRequestPayload;
  karaokeAddEntry: KaraokeAddEntryPayload;
  karaokeEndSession: KaraokeEndSessionPayload;
  karaokeRemoveEntry: KaraokeRemoveEntryPayload;
  karaokeReorderEntry: KaraokeReorderEntryPayload;
  karaokeSkipCurrent: KaraokeSkipCurrentPayload;
  karaokeStartSession: KaraokeStartSessionPayload;
  likePlaylistTrack: LikePlaylistTrackPayload;
  likeStationTrack: LikeStationTrackPayload;
  logout: LogoutPayload;
  /** Mark a conversation read for the viewer (clears unread badges) */
  markConversationRead: MarkConversationReadPayload;
  /** Updates an organization by id */
  organizationUpdate: OrganizationUpdatePayload;
  /** Play a playlist in a zone immediately, overriding the active schedule */
  playPlaylistInZone: PlayPlaylistInZonePayload;
  /** Generate a short Cartesia TTS preview with the provided options */
  previewCartesiaVoice: PreviewCartesiaVoicePayload;
  processVoiceCommand: ProcessVoiceCommandPayload;
  /** DJ attaches rate/terms to an inquiry, moving it to proposed */
  proposeDjEngagement: ProposeDjEngagementPayload;
  /** Publish (or unpublish) the viewer's DJ profile to the marketplace */
  publishDjProfile: PublishDjProfilePayload;
  recheckTrackLicensingPro: Track;
  /** Record or update a vendor expense for a month (upserts on vendor + month). Requires the billing.manage staff permission. */
  recordVendorExpense: RecordVendorExpensePayload;
  /** Re-pull real album art for a playlist's tracks whose cover is missing or a DMS placeholder. Runs in the background. */
  refreshPlaylistTrackCovers: RefreshPlaylistTrackCoversPayload;
  /**
   * Recompute a support ticket's Spin context payload and push it to the ticketing
   * provider. Requires the support.view staff permission.
   */
  refreshSupportContext: RefreshSupportContextPayload;
  regeneratePlaylist: RegeneratePlaylistPayload;
  /** Regenerate TTS audio for a voice message */
  regenerateVoiceMessageTts: RegenerateVoiceMessageTtsPayload;
  /** Register (or reactivate) a software device for a zone */
  registerSoftwareDevice: RegisterSoftwareDevicePayload;
  /** Remove a member from an organization (soft delete). Only org admins can remove members. */
  removeOrganizationMember: RemoveOrganizationMemberPayload;
  removeTrackFromPlaylist: RemoveTrackFromPlaylistPayload;
  removeVideoFromPlaylist: RemoveVideoFromPlaylistPayload;
  /** Reset shuffle state for a playlist in a zone (starts new shuffle cycle) */
  resetPlaylistShuffle: ResetPlaylistShufflePayload;
  resolveVoicePlaylistRequest: ResolveVoicePlaylistRequestPayload;
  /** Retry a failed Sidekiq job from the retry or dead set. Requires the health.view staff permission. */
  retryJob: RetryJobPayload;
  retryVideoProcessing: RetryVideoProcessingPayload;
  /** Revoke an API token */
  revokeApiToken: RevokeApiTokenPayload;
  /** Withdraw a pending invitation. Org admins only. */
  revokeOrganizationInvitation: RevokeOrganizationInvitationPayload;
  /** Save an Event-explorer query configuration for reuse. Requires the analytics.query staff permission. */
  saveAdminQuery: SaveAdminQueryPayload;
  saveVenueLink: SaveVenueLinkPayload;
  /** Schedule email delivery of a saved Event-explorer query. Requires the analytics.query staff permission. */
  scheduleAdminReport: ScheduleAdminReportPayload;
  /**
   * Send a command to a single device by id. For commands with device-level (not
   * zone-level) semantics, e.g. restart, restart_tailscale.
   */
  sendDeviceCommand: SendDeviceCommandPayload;
  /** Send a message in a conversation the viewer participates in */
  sendMessage: SendMessagePayload;
  /**
   * Send password reset instructions to a user. System admins can reset any user;
   * org admins can reset users in their organization.
   */
  sendPasswordReset: SendPasswordResetPayload;
  sendZoneCommand: SendZoneCommandPayload;
  /** Replace the ordered list of playlists showcased on the viewer's DJ profile */
  setDjSamplePlaylists: SetDjSamplePlaylistsPayload;
  /**
   * Create a new organization and its first admin user from email and password.
   * Sends a verification email but does not block onboarding on confirmation.
   */
  signUp: SignUpPayload;
  /** Get Spotify authorization URL for connecting user's account */
  spotifyAuthorizationUrl: SpotifyAuthorizationUrlPayload;
  /** Handle Spotify OAuth callback and connect user's account */
  spotifyConnectCallback: SpotifyConnectCallbackPayload;
  /** Disconnect user's Spotify account */
  spotifyDisconnect: SpotifyDisconnectPayload;
  /**
   * Open (or return) the conversation between an organization and a DJ.
   * Org-initiated only: the viewer must be a full member of the initiating
   * organization (organizationId, or their current organization by default).
   */
  startConversation: StartConversationPayload;
  /** Stop ad-hoc playlist override and revert to scheduled playback */
  stopZoneOverride: StopZoneOverridePayload;
  submitPlaylistFeedback: SubmitPlaylistFeedbackPayload;
  /** Updates the viewer's active organization */
  switchOrganization: SwitchOrganizationPayload;
  /** Sync an existing Spotify playlist to update tracks and metadata */
  syncSpotifyPlaylist: SyncSpotifyPlaylistPayload;
  /**
   * Fetch a Stripe Checkout Session and sync the resulting state into the local
   * database. Handles both legacy mode=subscription sessions and mode=setup
   * card-collection sessions (attaches the card as the customer default, then adds
   * the zone item from session metadata).
   */
  syncStripeCheckoutSession: SyncStripeCheckoutSessionPayload;
  /** Terminate an engagement, revoking the DJ's access immediately */
  terminateDjEngagement: TerminateDjEngagementPayload;
  /** Remove a DJ bookmark from the current organization */
  unbookmarkDj: UnbookmarkDjPayload;
  /**
   * Undo a pending end-of-period zone cancellation (keep the zone subscribed;
   * add-on cancellations are undone with it). Pass an add-on planId to undo only that add-on.
   */
  uncancelZoneBilling: UncancelZoneBillingPayload;
  /** Update an existing campaign */
  updateCampaign: UpdateCampaignPayload;
  /** Update the viewer's DJ profile (basics, rates, genres, markets, photo) */
  updateDjProfile: UpdateDjProfilePayload;
  updateJukeboxLocationConfiguration: UpdateJukeboxLocationConfigurationPayload;
  updateJukeboxOrgConfiguration: UpdateJukeboxOrgConfigurationPayload;
  updateJukeboxZoneConfiguration: UpdateJukeboxZoneConfigurationPayload;
  /** Update a location's details. */
  updateLocation: UpdateLocationPayload;
  updateOauthApplication: UpdateOauthApplicationPayload;
  /**
   * Update a membership's role in an organization. Only org admins can update;
   * only system admins can change a Spin operator's membership.
   */
  updateOrganizationMembership: UpdateOrganizationMembershipPayload;
  /** Update a playlist's name and/or description */
  updatePlaylist: UpdatePlaylistPayload;
  updatePlaylistPrompt: UpdatePlaylistPromptPayload;
  /** Replace a staff role's permission set. Requires the iam.manage staff permission. */
  updateStaffRolePermissions: UpdateStaffRolePermissionsPayload;
  updateTrack: Track;
  updateTrackLicensingPro: Track;
  updateTrackPosition: UpdateTrackPositionPayload;
  updateVideo: UpdateVideoPayload;
  updateVideoPlaylist: UpdateVideoPlaylistPayload;
  updateVideoPosition: UpdateVideoPositionPayload;
  /** Update an existing voice message */
  updateVoiceMessage: UpdateVoiceMessagePayload;
  /** Update an existing voice message schedule */
  updateVoiceMessageSchedule: UpdateVoiceMessageSchedulePayload;
  /** Update a zone's settings. */
  updateZone: UpdateZonePayload;
  /** Create or update a testimonial on the viewer's DJ profile */
  upsertDjTestimonial: UpsertDjTestimonialPayload;
  upsertPlaylistSchedule: UpsertPlaylistSchedulePayload;
  upsertVideoSchedule: UpsertVideoSchedulePayload;
  /** Updates a user by id */
  userUpdate: UserUpdatePayload;
  /** Get Vimeo authorization URL for connecting the user's account */
  vimeoAuthorizationUrl: VimeoAuthorizationUrlPayload;
  /** Handle Vimeo OAuth callback and connect the user's account */
  vimeoConnectCallback: VimeoConnectCallbackPayload;
  /** Disconnect the user's Vimeo account */
  vimeoDisconnect: VimeoDisconnectPayload;
};


export type MutationAcceptDjEngagementArgs = {
  input: AcceptDjEngagementInput;
};


export type MutationAcceptOrganizationInvitationArgs = {
  input: AcceptOrganizationInvitationInput;
};


export type MutationActivateDeviceArgs = {
  input: ActivateDeviceInput;
};


export type MutationAddTrackToPlaylistArgs = {
  input: AddTrackToPlaylistInput;
};


export type MutationAddVideoToPlaylistArgs = {
  input: AddVideoToPlaylistInput;
};


export type MutationAddVideosToPlaylistArgs = {
  input: AddVideosToPlaylistInput;
};


export type MutationAdminProvisionDeviceArgs = {
  input: AdminProvisionDeviceInput;
};


export type MutationBookmarkDjArgs = {
  input: BookmarkDjInput;
};


export type MutationCancelAiTrackGenerationArgs = {
  input: CancelAiTrackGenerationInput;
};


export type MutationCancelSubscriptionArgs = {
  input: CancelSubscriptionInput;
};


export type MutationCancelZoneBillingArgs = {
  input: CancelZoneBillingInput;
};


export type MutationCompleteDjEngagementArgs = {
  input: CompleteDjEngagementInput;
};


export type MutationCompleteOnboardingArgs = {
  input: CompleteOnboardingInput;
};


export type MutationConnectDeviceArgs = {
  input: ConnectDeviceInput;
};


export type MutationCreateApiTokenArgs = {
  input: CreateApiTokenInput;
};


export type MutationCreateCampaignArgs = {
  input: CreateCampaignInput;
};


export type MutationCreateCheckoutSessionArgs = {
  input: CreateCheckoutSessionInput;
};


export type MutationCreateCustomerPortalSessionArgs = {
  input: CreateCustomerPortalSessionInput;
};


export type MutationCreateDjEngagementArgs = {
  input: CreateDjEngagementInput;
};


export type MutationCreateHardwareCheckoutSessionArgs = {
  input: CreateHardwareCheckoutSessionInput;
};


export type MutationCreateLocationArgs = {
  input: CreateLocationInput;
};


export type MutationCreateOauthApplicationArgs = {
  input: CreateOauthApplicationInput;
};


export type MutationCreatePlaylistArgs = {
  input: CreatePlaylistInput;
};


export type MutationCreateStationArgs = {
  input: CreateStationInput;
};


export type MutationCreateTrackArgs = {
  input: CreateTrackInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCreateVideoArgs = {
  input: CreateVideoInput;
};


export type MutationCreateVideoPlaylistArgs = {
  input: CreateVideoPlaylistInput;
};


export type MutationCreateVideosArgs = {
  input: CreateVideosInput;
};


export type MutationCreateVoiceMessageArgs = {
  input: CreateVoiceMessageInput;
};


export type MutationCreateVoiceMessageScheduleArgs = {
  input: CreateVoiceMessageScheduleInput;
};


export type MutationCreateZoneArgs = {
  input: CreateZoneInput;
};


export type MutationDeactivateDeviceArgs = {
  input: DeactivateDeviceInput;
};


export type MutationDeclineDjEngagementArgs = {
  input: DeclineDjEngagementInput;
};


export type MutationDeclineOrganizationInvitationArgs = {
  input: DeclineOrganizationInvitationInput;
};


export type MutationDeleteAdminQueryArgs = {
  input: DeleteAdminQueryInput;
};


export type MutationDeleteAdminReportArgs = {
  input: DeleteAdminReportInput;
};


export type MutationDeleteCampaignArgs = {
  input: DeleteCampaignInput;
};


export type MutationDeleteDjTestimonialArgs = {
  input: DeleteDjTestimonialInput;
};


export type MutationDeleteOauthApplicationArgs = {
  input: DeleteOauthApplicationInput;
};


export type MutationDeletePlaylistArgs = {
  input: DeletePlaylistInput;
};


export type MutationDeletePlaylistScheduleArgs = {
  input: DeletePlaylistScheduleInput;
};


export type MutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type MutationDeleteVenueLinkArgs = {
  input: DeleteVenueLinkInput;
};


export type MutationDeleteVideoArgs = {
  input: DeleteVideoInput;
};


export type MutationDeleteVideoPlaylistArgs = {
  input: DeleteVideoPlaylistInput;
};


export type MutationDeleteVideoScheduleArgs = {
  input: DeleteVideoScheduleInput;
};


export type MutationDeleteVoiceMessageArgs = {
  input: DeleteVoiceMessageInput;
};


export type MutationDeleteVoiceMessageScheduleArgs = {
  input: DeleteVoiceMessageScheduleInput;
};


export type MutationDeleteZoneArgs = {
  input: DeleteZoneInput;
};


export type MutationDisconnectDeviceArgs = {
  input: DisconnectDeviceInput;
};


export type MutationDislikePlaylistTrackArgs = {
  input: DislikePlaylistTrackInput;
};


export type MutationDislikeStationTrackArgs = {
  input: DislikeStationTrackInput;
};


export type MutationDjSignUpArgs = {
  input: DjSignUpInput;
};


export type MutationFetchSpotifyPlaylistsArgs = {
  input: FetchSpotifyPlaylistsInput;
};


export type MutationGenerateAiMusicPlaylistArgs = {
  input: GenerateAiMusicPlaylistInput;
};


export type MutationGenerateAiTracksForPlaylistArgs = {
  input: GenerateAiTracksForPlaylistInput;
};


export type MutationGenerateAiVideoArgs = {
  input: GenerateAiVideoInput;
};


export type MutationImportPlaylistArgs = {
  input: ImportPlaylistInput;
};


export type MutationImportSpotifyPlaylistArgs = {
  input: ImportSpotifyPlaylistInput;
};


export type MutationImportVideosArgs = {
  input: ImportVideosInput;
};


export type MutationInviteOrganizationMemberArgs = {
  input: InviteOrganizationMemberInput;
};


export type MutationJukeboxCancelPendingRequestArgs = {
  input: JukeboxCancelPendingRequestInput;
};


export type MutationJukeboxCancelRequestArgs = {
  input: JukeboxCancelRequestInput;
};


export type MutationJukeboxConfirmPaymentArgs = {
  input: JukeboxConfirmPaymentInput;
};


export type MutationJukeboxEmergencyLockArgs = {
  input: JukeboxEmergencyLockInput;
};


export type MutationJukeboxLockAllArgs = {
  input: JukeboxLockAllInput;
};


export type MutationJukeboxPauseQueueArgs = {
  input: JukeboxPauseQueueInput;
};


export type MutationJukeboxRemoveItemArgs = {
  input: JukeboxRemoveItemInput;
};


export type MutationJukeboxSkipCurrentArgs = {
  input: JukeboxSkipCurrentInput;
};


export type MutationJukeboxSubmitRequestArgs = {
  input: JukeboxSubmitRequestInput;
};


export type MutationKaraokeAddEntryArgs = {
  input: KaraokeAddEntryInput;
};


export type MutationKaraokeEndSessionArgs = {
  input: KaraokeEndSessionInput;
};


export type MutationKaraokeRemoveEntryArgs = {
  input: KaraokeRemoveEntryInput;
};


export type MutationKaraokeReorderEntryArgs = {
  input: KaraokeReorderEntryInput;
};


export type MutationKaraokeSkipCurrentArgs = {
  input: KaraokeSkipCurrentInput;
};


export type MutationKaraokeStartSessionArgs = {
  input: KaraokeStartSessionInput;
};


export type MutationLikePlaylistTrackArgs = {
  input: LikePlaylistTrackInput;
};


export type MutationLikeStationTrackArgs = {
  input: LikeStationTrackInput;
};


export type MutationLogoutArgs = {
  input: LogoutInput;
};


export type MutationMarkConversationReadArgs = {
  input: MarkConversationReadInput;
};


export type MutationOrganizationUpdateArgs = {
  input: OrganizationUpdateInput;
};


export type MutationPlayPlaylistInZoneArgs = {
  input: PlayPlaylistInZoneInput;
};


export type MutationPreviewCartesiaVoiceArgs = {
  input: PreviewCartesiaVoiceInput;
};


export type MutationProcessVoiceCommandArgs = {
  input: ProcessVoiceCommandInput;
};


export type MutationProposeDjEngagementArgs = {
  input: ProposeDjEngagementInput;
};


export type MutationPublishDjProfileArgs = {
  input: PublishDjProfileInput;
};


export type MutationRecheckTrackLicensingProArgs = {
  input: RecheckTrackLicensingProInput;
};


export type MutationRecordVendorExpenseArgs = {
  input: RecordVendorExpenseInput;
};


export type MutationRefreshPlaylistTrackCoversArgs = {
  input: RefreshPlaylistTrackCoversInput;
};


export type MutationRefreshSupportContextArgs = {
  input: RefreshSupportContextInput;
};


export type MutationRegeneratePlaylistArgs = {
  input: RegeneratePlaylistInput;
};


export type MutationRegenerateVoiceMessageTtsArgs = {
  input: RegenerateVoiceMessageTtsInput;
};


export type MutationRegisterSoftwareDeviceArgs = {
  input: RegisterSoftwareDeviceInput;
};


export type MutationRemoveOrganizationMemberArgs = {
  input: RemoveOrganizationMemberInput;
};


export type MutationRemoveTrackFromPlaylistArgs = {
  input: RemoveTrackFromPlaylistInput;
};


export type MutationRemoveVideoFromPlaylistArgs = {
  input: RemoveVideoFromPlaylistInput;
};


export type MutationResetPlaylistShuffleArgs = {
  input: ResetPlaylistShuffleInput;
};


export type MutationResolveVoicePlaylistRequestArgs = {
  input: ResolveVoicePlaylistRequestInput;
};


export type MutationRetryJobArgs = {
  input: RetryJobInput;
};


export type MutationRetryVideoProcessingArgs = {
  input: RetryVideoProcessingInput;
};


export type MutationRevokeApiTokenArgs = {
  input: RevokeApiTokenInput;
};


export type MutationRevokeOrganizationInvitationArgs = {
  input: RevokeOrganizationInvitationInput;
};


export type MutationSaveAdminQueryArgs = {
  input: SaveAdminQueryInput;
};


export type MutationSaveVenueLinkArgs = {
  input: SaveVenueLinkInput;
};


export type MutationScheduleAdminReportArgs = {
  input: ScheduleAdminReportInput;
};


export type MutationSendDeviceCommandArgs = {
  input: SendDeviceCommandInput;
};


export type MutationSendMessageArgs = {
  input: SendMessageInput;
};


export type MutationSendPasswordResetArgs = {
  input: SendPasswordResetInput;
};


export type MutationSendZoneCommandArgs = {
  input: SendZoneCommandInput;
};


export type MutationSetDjSamplePlaylistsArgs = {
  input: SetDjSamplePlaylistsInput;
};


export type MutationSignUpArgs = {
  input: SignUpInput;
};


export type MutationSpotifyAuthorizationUrlArgs = {
  input: SpotifyAuthorizationUrlInput;
};


export type MutationSpotifyConnectCallbackArgs = {
  input: SpotifyConnectCallbackInput;
};


export type MutationSpotifyDisconnectArgs = {
  input: SpotifyDisconnectInput;
};


export type MutationStartConversationArgs = {
  input: StartConversationInput;
};


export type MutationStopZoneOverrideArgs = {
  input: StopZoneOverrideInput;
};


export type MutationSubmitPlaylistFeedbackArgs = {
  input: SubmitPlaylistFeedbackInput;
};


export type MutationSwitchOrganizationArgs = {
  input: SwitchOrganizationInput;
};


export type MutationSyncSpotifyPlaylistArgs = {
  input: SyncSpotifyPlaylistInput;
};


export type MutationSyncStripeCheckoutSessionArgs = {
  input: SyncStripeCheckoutSessionInput;
};


export type MutationTerminateDjEngagementArgs = {
  input: TerminateDjEngagementInput;
};


export type MutationUnbookmarkDjArgs = {
  input: UnbookmarkDjInput;
};


export type MutationUncancelZoneBillingArgs = {
  input: UncancelZoneBillingInput;
};


export type MutationUpdateCampaignArgs = {
  input: UpdateCampaignInput;
};


export type MutationUpdateDjProfileArgs = {
  input: UpdateDjProfileInput;
};


export type MutationUpdateJukeboxLocationConfigurationArgs = {
  input: UpdateJukeboxLocationConfigurationInput;
};


export type MutationUpdateJukeboxOrgConfigurationArgs = {
  input: UpdateJukeboxOrgConfigurationInput;
};


export type MutationUpdateJukeboxZoneConfigurationArgs = {
  input: UpdateJukeboxZoneConfigurationInput;
};


export type MutationUpdateLocationArgs = {
  input: UpdateLocationInput;
};


export type MutationUpdateOauthApplicationArgs = {
  input: UpdateOauthApplicationInput;
};


export type MutationUpdateOrganizationMembershipArgs = {
  input: UpdateOrganizationMembershipInput;
};


export type MutationUpdatePlaylistArgs = {
  input: UpdatePlaylistInput;
};


export type MutationUpdatePlaylistPromptArgs = {
  input: UpdatePlaylistPromptInput;
};


export type MutationUpdateStaffRolePermissionsArgs = {
  input: UpdateStaffRolePermissionsInput;
};


export type MutationUpdateTrackArgs = {
  input: UpdateTrackInput;
};


export type MutationUpdateTrackLicensingProArgs = {
  input: UpdateTrackLicensingProInput;
};


export type MutationUpdateTrackPositionArgs = {
  input: UpdateTrackPositionInput;
};


export type MutationUpdateVideoArgs = {
  input: UpdateVideoInput;
};


export type MutationUpdateVideoPlaylistArgs = {
  input: UpdateVideoPlaylistInput;
};


export type MutationUpdateVideoPositionArgs = {
  input: UpdateVideoPositionInput;
};


export type MutationUpdateVoiceMessageArgs = {
  input: UpdateVoiceMessageInput;
};


export type MutationUpdateVoiceMessageScheduleArgs = {
  input: UpdateVoiceMessageScheduleInput;
};


export type MutationUpdateZoneArgs = {
  input: UpdateZoneInput;
};


export type MutationUpsertDjTestimonialArgs = {
  input: UpsertDjTestimonialInput;
};


export type MutationUpsertPlaylistScheduleArgs = {
  input: UpsertPlaylistScheduleInput;
};


export type MutationUpsertVideoScheduleArgs = {
  input: UpsertVideoScheduleInput;
};


export type MutationUserUpdateArgs = {
  input: UserUpdateInput;
};


export type MutationVimeoAuthorizationUrlArgs = {
  input: VimeoAuthorizationUrlInput;
};


export type MutationVimeoConnectCallbackArgs = {
  input: VimeoConnectCallbackInput;
};


export type MutationVimeoDisconnectArgs = {
  input: VimeoDisconnectInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

export type OauthApplication = {
  __typename?: 'OauthApplication';
  /** Access tokens neither revoked nor expired. Aggregate count only — per-user token rows are never exposed. */
  activeTokenCount: Scalars['Int']['output'];
  /** Confidential clients hold their secret server-side; public clients (PKCE) do not */
  confidential: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  redirectUri?: Maybe<Scalars['String']['output']>;
  scopes: Scalars['String']['output'];
  /** Client Secret (only shown on creation) */
  secret?: Maybe<Scalars['String']['output']>;
  /** All access tokens ever issued for this application (aggregate count only) */
  totalTokenCount: Scalars['Int']['output'];
  /** Client ID */
  uid: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** Derived per-organization catalog rollup over tracks reachable through the org's scheduled playlists */
export type OrgCatalogRollup = {
  __typename?: 'OrgCatalogRollup';
  organization: Organization;
  /** Of those, tracks with transcoded audio attached (Track.playable) */
  playableCount: Scalars['Int']['output'];
  /** Distinct kept tracks reachable through the org's zones' assigned playlists */
  trackCount: Scalars['Int']['output'];
  /** Of those, tracks with no licensing PRO assigned */
  unlicensedCount: Scalars['Int']['output'];
};

export type OrgDjBookmark = {
  __typename?: 'OrgDjBookmark';
  createdAt: Scalars['ISO8601DateTime']['output'];
  djProfile: DjProfile;
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
};

export type Organization = Node & {
  __typename?: 'Organization';
  activeSubscriptions: BillingSubscriptionConnection;
  /** AI track generation usage for current billing period (RF plans only) */
  aiGenerationUsage?: Maybe<Scalars['JSON']['output']>;
  /**
   * Available AI music generation models based on org's plan mix. Returns {mode:
   * 'fixed', plan_name: '...', model: '...', config: {...}} for uniform plans, or
   * {mode: 'choice', models: [{plan_name: '...', model: '...', config: {...}},
   * ...]} when org has mixed RF plans across zones.
   */
  aiModelOptions?: Maybe<Scalars['JSON']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  /**
   * Consolidated billing state: payment method on file, subscription health, paid
   * zone items. Nil for viewers without billing access.
   */
  billingState?: Maybe<OrganizationBillingState>;
  campaigns: Array<Campaign>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  crossfadeSeconds: Scalars['Int']['output'];
  /** Highest tier active subscription plan */
  currentPlan?: Maybe<BillingPlan>;
  /** Current user's membership in this organization */
  currentUserMembership?: Maybe<OrganizationMembership>;
  /**
   * When the organization was soft-deleted; null for kept orgs. Only ever non-null
   * via admin.organizations(includeDiscarded: true).
   */
  discardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  explicitTracksAllowed: Scalars['Boolean']['output'];
  /** Home screen density: auto (infer from zone/location counts), venue, group or fleet */
  homeLayout: Scalars['String']['output'];
  /** Opening hours by weekday, inherited by locations that set none */
  hours?: Maybe<Scalars['JSON']['output']>;
  hoursNote?: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  locations: Array<Location>;
  name: Scalars['String']['output'];
  /** Playlist used for offline preload on devices */
  offlinePreloadPlaylist?: Maybe<Playlist>;
  /**
   * When the org finished self-serve onboarding including billing. Null means
   * onboarding is incomplete and the app should route the user into the onboarding wizard.
   */
  onboardingCompletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  organizationType: OrganizationType;
  phone?: Maybe<Scalars['String']['output']>;
  publicEmail?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  users: UserConnection;
  /** Brand-level links every location inherits */
  venueLinks: Array<VenueLink>;
  /** Number of active (non-discarded) zones in the organization */
  zonesCount: Scalars['Int']['output'];
};


export type OrganizationActiveSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type OrganizationUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type OrganizationBillingState = {
  __typename?: 'OrganizationBillingState';
  /** Brand of the default card (e.g. visa) */
  cardBrand?: Maybe<Scalars['String']['output']>;
  /** Last 4 digits of the default card */
  cardLast4?: Maybe<Scalars['String']['output']>;
  currentPeriodEnd?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Whether a default payment method is on file for the organization */
  hasPaymentMethod: Scalars['Boolean']['output'];
  /** Current monthly total across zone plan items (tier-aware) and add-on items, excluding metered AI usage */
  monthlyTotalCents: Scalars['Int']['output'];
  /** Status of the organization's subscription ('inactive' when none exists) */
  status: Scalars['String']['output'];
  /** Paid per-zone line items on the active subscription, plan and add-on alike (base item excluded — filter by kind) */
  zoneItems: Array<BillingSubscriptionItem>;
};

/** The connection type for Organization. */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /** A list of edges. */
  edges: Array<OrganizationEdge>;
  /** A list of nodes. */
  nodes: Array<Organization>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organization>;
};

export type OrganizationInput = {
  billingEmail?: InputMaybe<Scalars['String']['input']>;
  crossfadeSeconds?: InputMaybe<Scalars['Int']['input']>;
  explicitTracksAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Home screen density: auto, venue, group or fleet */
  homeLayout?: InputMaybe<Scalars['String']['input']>;
  /** Opening hours by weekday, keyed mon..sun, each a list of opens/closes times. An empty list means closed that day. */
  hours?: InputMaybe<Scalars['JSON']['input']>;
  /** Free text beside the structured week, e.g. Kitchen closes at 11 */
  hoursNote?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  offlinePreloadPlaylistId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  publicEmail?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationInvitation = {
  __typename?: 'OrganizationInvitation';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The invited account's email */
  email: Scalars['String']['output'];
  expiresAt: Scalars['ISO8601DateTime']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitedByName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  membershipRole: MembershipRole;
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  status: OrganizationInvitationStatus;
};

/** Lifecycle status of an invitation of an existing account to an organization */
export enum OrganizationInvitationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type OrganizationMembership = {
  __typename?: 'OrganizationMembership';
  id: Scalars['ID']['output'];
  membershipRole: MembershipRole;
  user: User;
};

/** Organization type enum */
export enum OrganizationType {
  Personal = 'PERSONAL',
  Standard = 'STANDARD',
  System = 'SYSTEM'
}

/** Autogenerated input type of OrganizationUpdate */
export type OrganizationUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  organizationInput: OrganizationInput;
};

/** Autogenerated return type of OrganizationUpdate. */
export type OrganizationUpdatePayload = {
  __typename?: 'OrganizationUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  organization: Organization;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/**
 * Headline platform KPIs for the admin Overview dashboard. Sub-values the viewer
 * lacks permission for (billing.view for MRR, finance.view for infra spend)
 * resolve to null instead of raising.
 */
export type PlatformKpis = {
  __typename?: 'PlatformKpis';
  /**
   * Monthly recurring revenue in cents — the same Admin::BillingReport number the
   * money screen shows. Null without billing.view
   */
  mrrCents?: Maybe<Scalars['Int']['output']>;
  /**
   * Total vendor/infra spend for the previous FULL month (never mixed with the
   * partial current month). Null without finance.view, or when no vendor expenses
   * were recorded for that month
   */
  prevMonthInfraSpendCents?: Maybe<Scalars['Int']['output']>;
  /**
   * Zones currently playing (see ZoneStatusStore.playing_zones_count for the
   * canonical definition); null when the status store is unreachable
   */
  zonesPlaying?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of PlayPlaylistInZone */
export type PlayPlaylistInZoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  playlistId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of PlayPlaylistInZone. */
export type PlayPlaylistInZonePayload = {
  __typename?: 'PlayPlaylistInZonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  zone?: Maybe<Zone>;
};

/** Analytics data for playback events */
export type PlaybackAnalytics = {
  __typename?: 'PlaybackAnalytics';
  /** Average percentage of tracks completed */
  averageTrackCompletionPercentage?: Maybe<Scalars['Float']['output']>;
  /** Daily listening hours breakdown */
  dailyListeningHours: Array<DailyListening>;
  /** Date range for analytics */
  dateRange: DateRange;
  /** Current locations of devices with analytics */
  deviceLocations: Array<DeviceLocationAnalytics>;
  /** Analytics grouped by geographical location */
  locationAnalytics: Array<LocationAnalytics>;
  /** Hours of day with most activity (0-23) */
  mostActiveHours: Array<Scalars['Int']['output']>;
  /** Most played tracks */
  topTracks: Array<TopTrack>;
  /** Total listening time in hours */
  totalListeningTimeHours: Scalars['Float']['output'];
  /** Total listening time in seconds */
  totalListeningTimeSeconds: Scalars['Int']['output'];
  /** Total number of tracks played */
  totalTracksPlayed: Scalars['Int']['output'];
  /** Number of unique tracks played */
  uniqueTracksPlayed: Scalars['Int']['output'];
};

/** A playback event representing track playback activity */
export type PlaybackEvent = {
  __typename?: 'PlaybackEvent';
  /** City where the event occurred */
  city?: Maybe<Scalars['String']['output']>;
  /** Country where the event occurred */
  country?: Maybe<Scalars['String']['output']>;
  /** When the event was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** The device ID that generated the event */
  deviceId: Scalars['ID']['output'];
  /** Track duration in milliseconds */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** The type of playback event */
  eventType: Scalars['String']['output'];
  /** Formatted duration as MM:SS */
  formattedDuration?: Maybe<Scalars['String']['output']>;
  /** Formatted position as MM:SS */
  formattedPosition?: Maybe<Scalars['String']['output']>;
  /** True if the event includes location data */
  hasLocationData: Scalars['Boolean']['output'];
  /** The unique identifier of the playback event */
  id: Scalars['ID']['output'];
  /** True if this is a playback state event */
  isPlaybackState: Scalars['Boolean']['output'];
  /** True if this is a progress event */
  isProgressEvent: Scalars['Boolean']['output'];
  /** True if this is a track ended event */
  isTrackEnded: Scalars['Boolean']['output'];
  /** True if this is a track started event */
  isTrackStarted: Scalars['Boolean']['output'];
  /** Internet service provider */
  isp?: Maybe<Scalars['String']['output']>;
  /** Latitude coordinate */
  latitude?: Maybe<Scalars['Float']['output']>;
  /** Human-readable location name */
  locationDisplayName?: Maybe<Scalars['String']['output']>;
  /** When location data was last updated */
  locationUpdatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Longitude coordinate */
  longitude?: Maybe<Scalars['Float']['output']>;
  /** The organization */
  organization: Organization;
  /** The organization ID */
  organizationId: Scalars['ID']['output'];
  /** Percentage of track played (0-100) */
  playbackPercentage?: Maybe<Scalars['Float']['output']>;
  /** Position in track in milliseconds */
  positionMs?: Maybe<Scalars['Int']['output']>;
  /** Region/state where the event occurred */
  region?: Maybe<Scalars['String']['output']>;
  /** Timezone of the event location */
  timezone?: Maybe<Scalars['String']['output']>;
  /** The track if applicable */
  track?: Maybe<Track>;
  /** The artist of the track from event data or track record */
  trackArtist?: Maybe<Scalars['String']['output']>;
  /** The track ID if applicable */
  trackId?: Maybe<Scalars['ID']['output']>;
  /** The title of the track from event data or track record */
  trackTitle?: Maybe<Scalars['String']['output']>;
  /** When the event was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** Volume level (0-100) */
  volume?: Maybe<Scalars['Int']['output']>;
  /** The zone */
  zone: Zone;
  /** The zone ID where the event occurred */
  zoneId: Scalars['ID']['output'];
};

export type Playlist = Node & {
  __typename?: 'Playlist';
  /** Whether this playlist was generated by AI */
  aiGenerated: Scalars['Boolean']['output'];
  /** Current AI generation status (for polling-based progress display) */
  aiGenerationStatus?: Maybe<PlaylistGenerationStatus>;
  /** AI prompt used to generate this playlist */
  aiPrompt?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  crossfadeOverrideSeconds?: Maybe<Scalars['Int']['output']>;
  crossfadeSeconds: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** Whether this playlist was imported from Spotify */
  isSpotifyPlaylist: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  /** Kept schedules that program this playlist into a zone, soonest daily start first */
  playlistSchedules: Array<PlaylistSchedule>;
  playlistTracks?: Maybe<Array<PlaylistTrack>>;
  playlistType: PlaylistType;
  /** Raw Spotify playlist data */
  spotifyData?: Maybe<Scalars['JSON']['output']>;
  /** Spotify ID if imported from Spotify */
  spotifyId?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  /** Summed duration of the playlist's tracks in milliseconds */
  totalDurationMs: Scalars['BigInt']['output'];
  tracksCount: Scalars['Int']['output'];
  /**
   * Tracks the playlist's organization can't play on its zones (licensed music its
   * plan doesn't include). Players are never sent them; the rest of the playlist plays.
   */
  unlicensedTracksCount: Scalars['Int']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
};


export type PlaylistPlaylistTracksArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Playlist. */
export type PlaylistConnection = {
  __typename?: 'PlaylistConnection';
  /** A list of edges. */
  edges: Array<PlaylistEdge>;
  /** A list of nodes. */
  nodes: Array<Playlist>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlaylistEdge = {
  __typename?: 'PlaylistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Playlist>;
};

/** User feedback for playlists */
export type PlaylistFeedback = {
  __typename?: 'PlaylistFeedback';
  /** AI confidence score (0.0-1.0) */
  aiConfidence?: Maybe<Scalars['Float']['output']>;
  /** AI prompt used for generation (if applicable) */
  aiPrompt?: Maybe<Scalars['String']['output']>;
  /** Detected business context */
  businessContext?: Maybe<Scalars['String']['output']>;
  /** Written feedback comment */
  comment?: Maybe<Scalars['String']['output']>;
  /** How well AI confidence predicted user satisfaction */
  confidenceAccuracyScore?: Maybe<Scalars['Float']['output']>;
  /** When feedback was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Type of feedback */
  feedbackType: PlaylistFeedbackTypeEnum;
  /** Whether this feedback was marked as helpful */
  helpful: Scalars['Boolean']['output'];
  /** Unique identifier for the feedback */
  id: Scalars['ID']['output'];
  /** Whether this is negative feedback (1-2 stars) */
  isNegative: Scalars['Boolean']['output'];
  /** Whether this is positive feedback (4-5 stars) */
  isPositive: Scalars['Boolean']['output'];
  /** The playlist this feedback is for */
  playlist: Playlist;
  /** Rating from 1-5 stars */
  rating?: Maybe<Scalars['Int']['output']>;
  /** Sentiment analysis of comment (positive/negative/neutral) */
  sentiment?: Maybe<Scalars['String']['output']>;
  /** When feedback was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** The user who provided the feedback */
  user: User;
};

/** Types of feedback that can be provided for playlists */
export enum PlaylistFeedbackTypeEnum {
  /** Feedback about AI playlist generation quality and accuracy */
  AiGeneration = 'AI_GENERATION',
  /** Feedback about how well the playlist fits the business context */
  BusinessContext = 'BUSINESS_CONTEXT',
  /** General feedback about the playlist */
  General = 'GENERAL',
  /** Feedback about specific track choices and curation */
  TrackSelection = 'TRACK_SELECTION'
}

/** Status information for AI playlist generation */
export type PlaylistGenerationStatus = {
  __typename?: 'PlaylistGenerationStatus';
  /** Detected business context */
  businessContext?: Maybe<Scalars['String']['output']>;
  /** When generation completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** AI confidence score for the generation */
  confidence?: Maybe<Scalars['Float']['output']>;
  /** Error message if generation failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Extracted musical attributes */
  extractedAttributes?: Maybe<Scalars['JSON']['output']>;
  /** Current status message */
  message?: Maybe<Scalars['String']['output']>;
  /** The playlist being generated */
  playlistId: Scalars['ID']['output'];
  /** Progress percentage (0.0 to 1.0) */
  progress: Scalars['Float']['output'];
  /** Current status: pending, processing, completed, failed */
  status: Scalars['String']['output'];
  /** Total tracks to generate */
  totalTracks: Scalars['Int']['output'];
  /** Per-track generation statuses (for AI music generation) */
  trackStatuses?: Maybe<Array<TrackGenerationStatus>>;
  /** Number of tracks generated so far */
  tracksGenerated: Scalars['Int']['output'];
};

export type PlaylistSchedule = Node & {
  __typename?: 'PlaylistSchedule';
  createdAt: Scalars['ISO8601DateTime']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  playlist?: Maybe<Playlist>;
  rrule?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  zone?: Maybe<Zone>;
};

/** The connection type for PlaylistSchedule. */
export type PlaylistScheduleConnection = {
  __typename?: 'PlaylistScheduleConnection';
  /** A list of edges. */
  edges: Array<PlaylistScheduleEdge>;
  /** A list of nodes. */
  nodes: Array<PlaylistSchedule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type PlaylistScheduleEdge = {
  __typename?: 'PlaylistScheduleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PlaylistSchedule>;
};

export type PlaylistScheduleInput = {
  byWeekday?: InputMaybe<Array<RRuleByWeekday>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endTime: Scalars['String']['input'];
  frequency?: InputMaybe<RRuleFrequency>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  playlistId: Scalars['ID']['input'];
  rrule?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startTime: Scalars['String']['input'];
  zoneId: Scalars['ID']['input'];
};

/** Playlist shuffle state for a zone */
export type PlaylistShuffleState = {
  __typename?: 'PlaylistShuffleState';
  /** ID of the current track in shuffle order */
  currentTrackId?: Maybe<Scalars['ID']['output']>;
  /** Whether the current shuffle cycle is complete */
  cycleComplete: Scalars['Boolean']['output'];
  /** Progress through current shuffle cycle (0.0 to 1.0) */
  cycleProgress: Scalars['Float']['output'];
  /** When the current shuffle cycle started */
  cycleStartedAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the next track in shuffle order */
  nextTrackId?: Maybe<Scalars['ID']['output']>;
  /** Number of tracks played in current cycle */
  playedTracks: Scalars['Int']['output'];
  /** Playlist this shuffle state is for */
  playlist: Playlist;
  /** Number of tracks remaining in current cycle */
  remainingTracks: Scalars['Int']['output'];
  /** Total number of tracks in the shuffle */
  totalTracks: Scalars['Int']['output'];
  /** Zone this shuffle state belongs to */
  zone: Zone;
};

export type PlaylistTrack = Node & {
  __typename?: 'PlaylistTrack';
  addedById: Scalars['ID']['output'];
  /** Whether the viewer added this track (drives the restricted-removal UI for hired DJs) */
  addedByViewer: Scalars['Boolean']['output'];
  /** Whether the viewer may remove this track from the playlist */
  canRemove: Scalars['Boolean']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  track?: Maybe<Track>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** User feedback (like/dislike) for a track in a regular (non-station) playlist */
export type PlaylistTrackFeedback = {
  __typename?: 'PlaylistTrackFeedback';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Type of feedback: 'like' or 'dislike' */
  feedbackType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  playlist: Playlist;
  track: Track;
  user: User;
};

/** Playlist type enum */
export enum PlaylistType {
  Playlist = 'PLAYLIST',
  Station = 'STATION'
}

/** Autogenerated input type of PreviewCartesiaVoice */
export type PreviewCartesiaVoiceInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  input: CartesiaPreviewInput;
};

/** Autogenerated return type of PreviewCartesiaVoice. */
export type PreviewCartesiaVoicePayload = {
  __typename?: 'PreviewCartesiaVoicePayload';
  audioBase64?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Aggregate licensing coverage for one performing rights organization */
export type ProLicensingStat = {
  __typename?: 'ProLicensingStat';
  /** Most recent licensing_pro_checked_at among this PRO's tracks */
  lastCheckedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Number of kept tracks currently assigned to this PRO */
  matchedCount: Scalars['Int']['output'];
  pro: LicensingProEnum;
};

/** Autogenerated input type of ProcessVoiceCommand */
export type ProcessVoiceCommandInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confidence?: InputMaybe<Scalars['Float']['input']>;
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  locationName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  text: Scalars['String']['input'];
  zoneName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ProcessVoiceCommand. */
export type ProcessVoiceCommandPayload = {
  __typename?: 'ProcessVoiceCommandPayload';
  action?: Maybe<Scalars['String']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  devices?: Maybe<Scalars['JSON']['output']>;
  entities?: Maybe<Scalars['JSON']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  intent?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  matches?: Maybe<Scalars['JSON']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  playlistId?: Maybe<Scalars['ID']['output']>;
  searchResults?: Maybe<Scalars['JSON']['output']>;
  success: Scalars['Boolean']['output'];
  trackIds?: Maybe<Array<Scalars['ID']['output']>>;
  voiceCommandEventId?: Maybe<Scalars['ID']['output']>;
  voicePlaylistRequestId?: Maybe<Scalars['ID']['output']>;
  zoneId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of ProposeDjEngagement */
export type ProposeDjEngagementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  id: Scalars['ID']['input'];
  rateCents?: InputMaybe<Scalars['Int']['input']>;
  rateCurrency?: InputMaybe<Scalars['String']['input']>;
  rateType?: InputMaybe<DjRateType>;
  startsOn?: InputMaybe<Scalars['ISO8601Date']['input']>;
  terms?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ProposeDjEngagement. */
export type ProposeDjEngagementPayload = {
  __typename?: 'ProposeDjEngagementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<DjEngagement>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of PublishDjProfile */
export type PublishDjProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  published: Scalars['Boolean']['input'];
};

/** Autogenerated return type of PublishDjProfile. */
export type PublishDjProfilePayload = {
  __typename?: 'PublishDjProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  djProfile?: Maybe<DjProfile>;
  errors: Array<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** Get active sync histories for a playlist */
  activeSyncHistories: Array<SpotifySyncHistory>;
  /** Staff-only queries for the internal admin tool. Raises for non-staff users. */
  admin?: Maybe<Admin>;
  album?: Maybe<Album>;
  albums: AlbumConnection;
  allPlaylists: Array<Playlist>;
  apiTokens: Array<ApiToken>;
  artist?: Maybe<Artist>;
  artists: ArtistConnection;
  billingPlans: BillingPlanConnection;
  /** Get a single campaign by ID */
  campaign?: Maybe<Campaign>;
  /** Query campaigns for an organization */
  campaigns: Array<Campaign>;
  /** Fetch available Cartesia voices and configuration options */
  cartesiaVoiceOptions: CartesiaVoiceOptions;
  /** A single conversation, for participants only */
  conversation?: Maybe<Conversation>;
  /** Conversations visible to the viewer (their org's, or their own as a DJ) */
  conversations: Array<Conversation>;
  discover: Discover;
  /** The current organization's bookmarked DJs */
  djBookmarks: Array<OrgDjBookmark>;
  /** Browse published DJ profiles (the DJ Network marketplace directory) */
  djDirectory: DjProfileConnection;
  /** Engagements visible to the viewer (their org's, or their own as a DJ) */
  djEngagements: Array<DjEngagement>;
  /** A DJ's public profile by slug (marketplace listing) */
  djProfile?: Maybe<DjProfile>;
  fleetOverview: FleetOverview;
  genres: GenreConnection;
  hardwareProducts: Array<HardwareProduct>;
  jukeboxAnalytics: Scalars['JSON']['output'];
  jukeboxBrowseTracks: TrackAvailabilityPage;
  jukeboxEffectiveConfiguration: Scalars['JSON']['output'];
  jukeboxMyRequests: Scalars['JSON']['output'];
  jukeboxQrCode: Scalars['JSON']['output'];
  jukeboxQueue: Scalars['JSON']['output'];
  jukeboxTrackSearch: Array<Track>;
  jukeboxTrackSearchV2: TrackAvailabilityPage;
  jukeboxVenueProfile: Scalars['JSON']['output'];
  jukeboxZonePlaylist: Scalars['JSON']['output'];
  karaokeSession?: Maybe<KaraokeSession>;
  karaokeTracks: Array<KaraokeTrack>;
  location?: Maybe<Location>;
  /** Query location-based analytics for music listening patterns */
  locationAnalytics: Array<LocationAnalytics>;
  locations: LocationConnection;
  locationsForSelect: Array<Location>;
  myOrganizationInvitations: Array<OrganizationInvitation>;
  /**
   * Playlists in the viewer's personal workspace org, regardless of the current
   * organization. Lets a hired DJ pick a playlist to import into a client org
   * (relation scopes are current-org-bound, so the regular playlists query can't see these).
   */
  myWorkspacePlaylists: Array<Playlist>;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Fetches a list of objects given a list of IDs. */
  nodes: Array<Maybe<Node>>;
  oauthApplications: Array<OauthApplication>;
  organization?: Maybe<Organization>;
  organizationInvitations: Array<OrganizationInvitation>;
  organizationInvoices: Array<Invoice>;
  organizationMemberships: Array<OrganizationMembership>;
  organizationSubscriptions: BillingSubscriptionConnection;
  /** Query playback analytics for zones and organizations */
  playbackAnalytics: PlaybackAnalytics;
  /** Query playback events with filtering and pagination */
  playbackEvents: Array<PlaybackEvent>;
  playlist?: Maybe<Playlist>;
  playlistRecommendations: Array<Track>;
  playlistSchedule?: Maybe<PlaylistSchedule>;
  playlistSchedules: PlaylistScheduleConnection;
  /** Get shuffle state information for a playlist in a zone */
  playlistShuffleState?: Maybe<PlaylistShuffleState>;
  playlists: PlaylistConnection;
  /** Return royalty-qualified playback summaries used for PRO remittance */
  royaltyReporting: RoyaltyReport;
  search: SearchResult;
  /** Get a Spotify sync history by ID for the current user */
  spotifySyncHistory?: Maybe<SpotifySyncHistory>;
  /** Get preview tracks for a station (tracks users can expect to hear) */
  stationPreviewTracks: Array<Track>;
  /** Get current playback state for a station in a zone */
  stationState?: Maybe<StationState>;
  stockVideos: Array<StockVideo>;
  track?: Maybe<Track>;
  trackGenerations: Array<TrackGenerationStatus>;
  tracks: TrackConnection;
  users: UserConnection;
  video?: Maybe<Video>;
  videoGenerations: Array<VideoGeneration>;
  videoPlaylist?: Maybe<VideoPlaylist>;
  videoPlaylists: VideoPlaylistConnection;
  videoSchedules: VideoScheduleConnection;
  videos: VideoConnection;
  viewer?: Maybe<User>;
  /** The authenticated user's DJ profile, if they have one */
  viewerDjProfile?: Maybe<DjProfile>;
  vimeoVideos: Array<VimeoVideo>;
  /** Query a single voice message */
  voiceMessage?: Maybe<VoiceMessage>;
  /** Query a single voice message schedule */
  voiceMessageSchedule?: Maybe<VoiceMessageSchedule>;
  /** Query voice message schedules for a voice message */
  voiceMessageSchedules: Array<VoiceMessageSchedule>;
  /** Query voice messages for an organization */
  voiceMessages: Array<VoiceMessage>;
  /** Fetch a single voice playlist request */
  voicePlaylistRequest?: Maybe<VoicePlaylistRequest>;
  /** List voice playlist requests */
  voicePlaylistRequests: VoicePlaylistRequestConnection;
  zone?: Maybe<Zone>;
  zoneStatus: ZoneStatus;
  zones: ZoneConnection;
};


export type QueryActiveSyncHistoriesArgs = {
  playlistId: Scalars['ID']['input'];
};


export type QueryAlbumArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAlbumsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryArtistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryArtistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBillingPlansArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignsArgs = {
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDiscoverArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDjDirectoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genreIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  maxRateCents?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  rateType?: InputMaybe<DjRateType>;
};


export type QueryDjEngagementsArgs = {
  status?: InputMaybe<DjEngagementStatus>;
};


export type QueryDjProfileArgs = {
  slug: Scalars['String']['input'];
};


export type QueryFleetOverviewArgs = {
  organizationId: Scalars['ID']['input'];
  range?: InputMaybe<FleetOverviewRangeEnum>;
};


export type QueryGenresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryJukeboxAnalyticsArgs = {
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  zoneId: Scalars['ID']['input'];
};


export type QueryJukeboxBrowseTracksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  zoneId: Scalars['ID']['input'];
};


export type QueryJukeboxEffectiveConfigurationArgs = {
  zoneId: Scalars['ID']['input'];
};


export type QueryJukeboxMyRequestsArgs = {
  previousTokens?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryJukeboxQrCodeArgs = {
  zoneId: Scalars['ID']['input'];
};


export type QueryJukeboxQueueArgs = {
  zoneId: Scalars['ID']['input'];
};


export type QueryJukeboxTrackSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  zoneId: Scalars['ID']['input'];
};


export type QueryJukeboxTrackSearchV2Args = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  zoneId: Scalars['ID']['input'];
};


export type QueryJukeboxVenueProfileArgs = {
  zoneId: Scalars['ID']['input'];
};


export type QueryJukeboxZonePlaylistArgs = {
  zoneId: Scalars['ID']['input'];
};


export type QueryKaraokeSessionArgs = {
  zoneId: Scalars['ID']['input'];
};


export type QueryKaraokeTracksArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationAnalyticsArgs = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  groupBy?: InputMaybe<LocationGrouping>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryLocationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNodeArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNodesArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrganizationInvitationsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationMembershipsArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryOrganizationSubscriptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryPlaybackAnalyticsArgs = {
  days?: InputMaybe<Scalars['Int']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlaybackEventsArgs = {
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  trackId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlaylistRecommendationsArgs = {
  excludeTrackIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  playlistId: Scalars['ID']['input'];
};


export type QueryPlaylistScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlaylistSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPlaylistShuffleStateArgs = {
  playlistId?: InputMaybe<Scalars['ID']['input']>;
  zoneId: Scalars['ID']['input'];
};


export type QueryPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  createdByViewer?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryRoyaltyReportingArgs = {
  endDate: Scalars['ISO8601Date']['input'];
  includePartial?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySearchArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySpotifySyncHistoryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryStationPreviewTracksArgs = {
  playlistId: Scalars['ID']['input'];
};


export type QueryStationStateArgs = {
  playlistId?: InputMaybe<Scalars['ID']['input']>;
  zoneId: Scalars['ID']['input'];
};


export type QueryStockVideosArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  provider: Scalars['String']['input'];
  query: Scalars['String']['input'];
};


export type QueryTrackArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTrackGenerationsArgs = {
  playlistId: Scalars['ID']['input'];
};


export type QueryTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  albumId?: InputMaybe<Scalars['ID']['input']>;
  artistId?: InputMaybe<Scalars['ID']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  genreId?: InputMaybe<Scalars['ID']['input']>;
  hasAudioUrl?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  licensingPro?: InputMaybe<LicensingProEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<TrackSortByEnum>;
  year?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVideoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVideoGenerationsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryVideoPlaylistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVideoPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVideoSchedulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  processingStatus?: InputMaybe<VideoProcessingStatusEnum>;
  query?: InputMaybe<Scalars['String']['input']>;
  sourceKind?: InputMaybe<VideoSourceKindEnum>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryVimeoVideosArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVoiceMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVoiceMessageScheduleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVoiceMessageSchedulesArgs = {
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  voiceMessageId: Scalars['ID']['input'];
};


export type QueryVoiceMessagesArgs = {
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVoicePlaylistRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVoicePlaylistRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  requestType?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<VoicePlaylistRequestStatusEnum>;
};


export type QueryZoneArgs = {
  id: Scalars['ID']['input'];
};


export type QueryZoneStatusArgs = {
  zoneId: Scalars['ID']['input'];
};


export type QueryZonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** RRule by weekday enum */
export enum RRuleByWeekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** RRule Frequency enum */
export enum RRuleFrequency {
  Daily = 'DAILY',
  Hourly = 'HOURLY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Weekly = 'WEEKLY',
  Yearly = 'YEARLY'
}

/** Autogenerated input type of RecheckTrackLicensingPro */
export type RecheckTrackLicensingProInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of RecordVendorExpense */
export type RecordVendorExpenseInput = {
  amountCents: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Any date within the month the expense covers; normalized to the first of the month */
  period: Scalars['ISO8601Date']['input'];
  vendor: Scalars['String']['input'];
};

/** Autogenerated return type of RecordVendorExpense. */
export type RecordVendorExpensePayload = {
  __typename?: 'RecordVendorExpensePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  vendorExpense?: Maybe<VendorExpense>;
};

/** Autogenerated input type of RefreshPlaylistTrackCovers */
export type RefreshPlaylistTrackCoversInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Playlist ID */
  playlistId: Scalars['ID']['input'];
};

/** Autogenerated return type of RefreshPlaylistTrackCovers. */
export type RefreshPlaylistTrackCoversPayload = {
  __typename?: 'RefreshPlaylistTrackCoversPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RefreshSupportContext */
export type RefreshSupportContextInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ticketId: Scalars['ID']['input'];
};

/** Autogenerated return type of RefreshSupportContext. */
export type RefreshSupportContextPayload = {
  __typename?: 'RefreshSupportContextPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  supportTicket?: Maybe<SupportTicket>;
};

/** Autogenerated input type of RegeneratePlaylist */
export type RegeneratePlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RegeneratePlaylist. */
export type RegeneratePlaylistPayload = {
  __typename?: 'RegeneratePlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  playlist: Playlist;
};

/** Autogenerated input type of RegenerateVoiceMessageTts */
export type RegenerateVoiceMessageTtsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Voice message ID */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RegenerateVoiceMessageTts. */
export type RegenerateVoiceMessageTtsPayload = {
  __typename?: 'RegenerateVoiceMessageTtsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  voiceMessage?: Maybe<VoiceMessage>;
};

/** Autogenerated input type of RegisterSoftwareDevice */
export type RegisterSoftwareDeviceInput = {
  /**
   * Commands this player implements beyond the basics (e.g. insert_track_next).
   * Omitted means none: the backend then never sends them.
   */
  capabilities?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Type of software device: WEB or DESKTOP */
  deviceType: DeviceType;
  /** Optional display name for the device */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Zone to register the software device in */
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegisterSoftwareDevice. */
export type RegisterSoftwareDevicePayload = {
  __typename?: 'RegisterSoftwareDevicePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Device>;
  /** Device token for API authentication */
  deviceToken?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
};

/** Release date precisions type enum */
export enum ReleaseDatePrecision {
  Day = 'DAY',
  Month = 'MONTH',
  Year = 'YEAR'
}

/** Autogenerated input type of RemoveOrganizationMember */
export type RemoveOrganizationMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Membership ID to remove */
  membershipId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveOrganizationMember. */
export type RemoveOrganizationMemberPayload = {
  __typename?: 'RemoveOrganizationMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveTrackFromPlaylist */
export type RemoveTrackFromPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveTrackFromPlaylist. */
export type RemoveTrackFromPlaylistPayload = {
  __typename?: 'RemoveTrackFromPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of RemoveVideoFromPlaylist */
export type RemoveVideoFromPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  videoId: Scalars['ID']['input'];
  videoPlaylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveVideoFromPlaylist. */
export type RemoveVideoFromPlaylistPayload = {
  __typename?: 'RemoveVideoFromPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  videoPlaylist?: Maybe<VideoPlaylist>;
};

/** How often a scheduled admin report is delivered */
export enum ReportCadenceEnum {
  /** Every day */
  Daily = 'DAILY',
  /** The 1st of each month */
  Monthly = 'MONTHLY',
  /** Mondays */
  Weekly = 'WEEKLY'
}

/** Autogenerated input type of ResetPlaylistShuffle */
export type ResetPlaylistShuffleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Playlist ID (uses active playlist if not provided) */
  playlistId?: InputMaybe<Scalars['ID']['input']>;
  /** Zone ID */
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResetPlaylistShuffle. */
export type ResetPlaylistShufflePayload = {
  __typename?: 'ResetPlaylistShufflePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Error message if reset failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Updated shuffle state */
  shuffleState?: Maybe<PlaylistShuffleState>;
  /** Whether the shuffle reset was successful */
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of ResolveVoicePlaylistRequest */
export type ResolveVoicePlaylistRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  playlistId?: InputMaybe<Scalars['ID']['input']>;
  resolutionPayload?: InputMaybe<Scalars['JSON']['input']>;
  status: VoicePlaylistRequestStatusEnum;
  trackIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of ResolveVoicePlaylistRequest. */
export type ResolveVoicePlaylistRequestPayload = {
  __typename?: 'ResolveVoicePlaylistRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  voicePlaylistRequest?: Maybe<VoicePlaylistRequest>;
};

/** Autogenerated input type of RetryJob */
export type RetryJobInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  jid: Scalars['String']['input'];
};

/** Autogenerated return type of RetryJob. */
export type RetryJobPayload = {
  __typename?: 'RetryJobPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Autogenerated input type of RetryVideoProcessing */
export type RetryVideoProcessingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RetryVideoProcessing. */
export type RetryVideoProcessingPayload = {
  __typename?: 'RetryVideoProcessingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  video?: Maybe<Video>;
};

/** Autogenerated input type of RevokeApiToken */
export type RevokeApiTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RevokeApiToken. */
export type RevokeApiTokenPayload = {
  __typename?: 'RevokeApiTokenPayload';
  apiToken?: Maybe<ApiToken>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of RevokeOrganizationInvitation */
export type RevokeOrganizationInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RevokeOrganizationInvitation. */
export type RevokeOrganizationInvitationPayload = {
  __typename?: 'RevokeOrganizationInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Per-PRO royalty rollup for one reporting period (one row per supported PRO plus 'unmatched') */
export type RoyaltyPeriodProRow = {
  __typename?: 'RoyaltyPeriodProRow';
  /** Royalty-bearing plays in the period */
  playCount: Scalars['Int']['output'];
  /** PRO name (ASCAP, BMI, GMR, SESAC) or 'unmatched' for plays of tracks with no licensing PRO */
  pro: Scalars['String']['output'];
  /** Up to 5 most-played tracks for this PRO in the period */
  topTracks: Array<RoyaltyPeriodTopTrack>;
  /** Distinct tracks with royalty-bearing plays in the period */
  trackCount: Scalars['Int']['output'];
};

/** One of the most-played tracks for a PRO within a royalty reporting period */
export type RoyaltyPeriodTopTrack = {
  __typename?: 'RoyaltyPeriodTopTrack';
  /** Display artist (joined artist names) */
  artist: Scalars['String']['output'];
  /** Royalty-bearing plays within the period */
  plays: Scalars['Int']['output'];
  /** Track name */
  trackName: Scalars['String']['output'];
};

/** Royalty-qualified playback reporting payload */
export type RoyaltyReport = {
  __typename?: 'RoyaltyReport';
  /** End timestamp for the reporting window */
  endAt: Scalars['ISO8601DateTime']['output'];
  /** Whether partial plays were included in this report */
  includePartial: Scalars['Boolean']['output'];
  /** Aggregate totals for the report */
  overallTotals: RoyaltyReportTotals;
  /** Aggregated totals per performing rights organization */
  proTotals: Array<RoyaltyReportProTotal>;
  /** Detailed zone and PRO level royalty data */
  rows: Array<RoyaltyReportRow>;
  /** Start timestamp for the reporting window */
  startAt: Scalars['ISO8601DateTime']['output'];
};

/** Aggregate royalty totals for a specific performing rights organization */
export type RoyaltyReportProTotal = {
  __typename?: 'RoyaltyReportProTotal';
  /** Name of the performing rights organization */
  licensingPro?: Maybe<Scalars['String']['output']>;
  /** Number of unique locations with payable activity for the PRO */
  locationsReporting: Scalars['Int']['output'];
  /** Partial plays attributed to the PRO */
  partialPlays: Scalars['Int']['output'];
  /** Qualified listening duration for the PRO in milliseconds */
  qualifiedDurationMs: Scalars['Int']['output'];
  /** Qualified plays attributed to the PRO */
  qualifiedPlays: Scalars['Int']['output'];
  /** Total listening duration for the PRO in milliseconds */
  totalDurationMs: Scalars['Int']['output'];
  /** Total plays attributed to the PRO */
  totalPlays: Scalars['Int']['output'];
  /** Number of unique zones with payable activity for the PRO */
  zonesReporting: Scalars['Int']['output'];
};

/** Royalty reporting details for a specific zone and PRO combination */
export type RoyaltyReportRow = {
  __typename?: 'RoyaltyReportRow';
  /** Performing rights organization name */
  licensingPro?: Maybe<Scalars['String']['output']>;
  /** Location identifier */
  locationId: Scalars['ID']['output'];
  /** Friendly name of the location */
  locationName?: Maybe<Scalars['String']['output']>;
  /** Organization identifier */
  organizationId: Scalars['ID']['output'];
  /** Plays that were tracked but not yet payable */
  partialPlays: Scalars['Int']['output'];
  /** Listening duration for qualified plays in milliseconds */
  qualifiedDurationMs: Scalars['Int']['output'];
  /** Plays that qualify for royalty payouts */
  qualifiedPlays: Scalars['Int']['output'];
  /** Total listening duration across all plays in milliseconds */
  totalDurationMs: Scalars['Int']['output'];
  /** Total plays reported for the zone and PRO */
  totalPlays: Scalars['Int']['output'];
  /** Zone identifier */
  zoneId: Scalars['ID']['output'];
  /** Friendly name of the zone */
  zoneName?: Maybe<Scalars['String']['output']>;
};

/** Aggregate totals for royalty-qualified playback data */
export type RoyaltyReportTotals = {
  __typename?: 'RoyaltyReportTotals';
  /** Number of plays that did not meet the qualification threshold */
  partialPlays: Scalars['Int']['output'];
  /** Listening duration in milliseconds for qualified plays */
  qualifiedDurationMs: Scalars['Int']['output'];
  /** Number of plays that qualify for PRO payouts */
  qualifiedPlays: Scalars['Int']['output'];
  /** Total listening duration in milliseconds for all plays */
  totalDurationMs: Scalars['Int']['output'];
  /** Total number of plays considered in the report */
  totalPlays: Scalars['Int']['output'];
};

/** Autogenerated input type of SaveAdminQuery */
export type SaveAdminQueryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  /** Same shape as EventQueryInput: {from, to, groupBy, orgId?, zoneId?, minCompletionPct?} */
  queryConfig: Scalars['JSON']['input'];
};

/** Autogenerated return type of SaveAdminQuery. */
export type SaveAdminQueryPayload = {
  __typename?: 'SaveAdminQueryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  savedQuery?: Maybe<AdminSavedQuery>;
};

/** Autogenerated input type of SaveVenueLink */
export type SaveVenueLinkInput = {
  /** One of: social, menu, ordering, reservation, website, other */
  category: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Location only. Suppresses the organization link with the same category and platform. */
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Omit to create; provide to update an existing link. */
  id?: InputMaybe<Scalars['ID']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  ownerId: Scalars['ID']['input'];
  /** Organization or Location */
  ownerType: Scalars['String']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SaveVenueLink. */
export type SaveVenueLinkPayload = {
  __typename?: 'SaveVenueLinkPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  venueLink?: Maybe<VenueLink>;
};

/** Autogenerated input type of ScheduleAdminReport */
export type ScheduleAdminReportInput = {
  cadence: ReportCadenceEnum;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Recipient email addresses */
  recipients: Array<Scalars['String']['input']>;
  savedQueryId: Scalars['ID']['input'];
};

/** Autogenerated return type of ScheduleAdminReport. */
export type ScheduleAdminReportPayload = {
  __typename?: 'ScheduleAdminReportPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  scheduledReport?: Maybe<AdminScheduledReport>;
};

/**
 * Two schedule windows on the same zone that overlap within the diagnostic window.
 * Reported once per schedule pair, with the earliest overlapping occurrence as the sample.
 */
export type ScheduleConflict = {
  __typename?: 'ScheduleConflict';
  a: ScheduleConflictOccurrence;
  b: ScheduleConflictOccurrence;
  /** music/music, video/video or music/video (cross-media overlap) */
  kind: Scalars['String']['output'];
  overlapMinutes: Scalars['Int']['output'];
  zone: Zone;
};

/** One side of an overlapping schedule window (a concrete occurrence, zone-local) */
export type ScheduleConflictOccurrence = {
  __typename?: 'ScheduleConflictOccurrence';
  end: Scalars['ISO8601DateTime']['output'];
  /** Playlist or video playlist name */
  programName: Scalars['String']['output'];
  scheduleId: Scalars['ID']['output'];
  start: Scalars['ISO8601DateTime']['output'];
};

export type SearchResult = {
  __typename?: 'SearchResult';
  albums: AlbumConnection;
  artists: ArtistConnection;
  genres: GenreConnection;
  playlists: PlaylistConnection;
  totalCount: Scalars['Int']['output'];
  tracks: TrackConnection;
};


export type SearchResultAlbumsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchResultArtistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchResultGenresArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchResultPlaylistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


export type SearchResultTracksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of SendDeviceCommand */
export type SendDeviceCommandInput = {
  action: CommandAction;
  arg?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Device to receive the command */
  deviceId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendDeviceCommand. */
export type SendDeviceCommandPayload = {
  __typename?: 'SendDeviceCommandPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** ID returned by PlayerEventService for tracing the command through to the status event response */
  correlationId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Autogenerated input type of SendMessage */
export type SendMessageInput = {
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendMessage. */
export type SendMessagePayload = {
  __typename?: 'SendMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  message?: Maybe<Message>;
};

/** Autogenerated input type of SendPasswordReset */
export type SendPasswordResetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendPasswordReset. */
export type SendPasswordResetPayload = {
  __typename?: 'SendPasswordResetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SendZoneCommand */
export type SendZoneCommandInput = {
  action: CommandAction;
  arg?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of SendZoneCommand. */
export type SendZoneCommandPayload = {
  __typename?: 'SendZoneCommandPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
};

/** Point-in-time health of the platform's backing services */
export type ServiceHealth = {
  __typename?: 'ServiceHealth';
  /** Retry-set and dead-set entries, newest first */
  jobFailures: Array<JobFailure>;
  /** Null when the LavinMQ management API is unreachable */
  lavinmq?: Maybe<LavinmqStats>;
  services: Array<ServiceStatus>;
  sidekiqQueues: Array<SidekiqQueueStat>;
};


/** Point-in-time health of the platform's backing services */
export type ServiceHealthJobFailuresArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Health of a single backing service */
export type ServiceStatus = {
  __typename?: 'ServiceStatus';
  host?: Maybe<Scalars['String']['output']>;
  metrics: Array<Metric>;
  name: Scalars['String']['output'];
  /** ok | degraded | down | unknown */
  state: Scalars['String']['output'];
};

/** Cheap header-bar service health: name, state and one headline metric */
export type ServiceSummary = {
  __typename?: 'ServiceSummary';
  metric?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /** ok | degraded | down | unknown */
  state: Scalars['String']['output'];
};

/** Autogenerated input type of SetDjSamplePlaylists */
export type SetDjSamplePlaylistsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Ordered playlist ids from the DJ's workspace */
  playlistIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of SetDjSamplePlaylists. */
export type SetDjSamplePlaylistsPayload = {
  __typename?: 'SetDjSamplePlaylistsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  djProfile?: Maybe<DjProfile>;
  errors: Array<Scalars['String']['output']>;
};

/** Size and latency of one Sidekiq queue */
export type SidekiqQueueStat = {
  __typename?: 'SidekiqQueueStat';
  latencySeconds: Scalars['Float']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

/** Autogenerated input type of SignUp */
export type SignUpInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  organizationName?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

/** Autogenerated return type of SignUp. */
export type SignUpPayload = {
  __typename?: 'SignUpPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of SpotifyAuthorizationUrl */
export type SpotifyAuthorizationUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Override redirect URI for multi-origin (e.g. spin-command) */
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SpotifyAuthorizationUrl. */
export type SpotifyAuthorizationUrlPayload = {
  __typename?: 'SpotifyAuthorizationUrlPayload';
  authorizationUrl: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
};

/** Autogenerated input type of SpotifyConnectCallback */
export type SpotifyConnectCallbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Authorization code from Spotify */
  code: Scalars['String']['input'];
  /** Must match redirect_uri used in authorization request */
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  /** State parameter for CSRF protection */
  state: Scalars['String']['input'];
};

/** Autogenerated return type of SpotifyConnectCallback. */
export type SpotifyConnectCallbackPayload = {
  __typename?: 'SpotifyConnectCallbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

/** Autogenerated input type of SpotifyDisconnect */
export type SpotifyDisconnectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of SpotifyDisconnect. */
export type SpotifyDisconnectPayload = {
  __typename?: 'SpotifyDisconnectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

/** A Spotify image */
export type SpotifyImage = {
  __typename?: 'SpotifyImage';
  /** Height of the image in pixels */
  height?: Maybe<Scalars['Int']['output']>;
  /** URL of the image */
  url: Scalars['String']['output'];
  /** Width of the image in pixels */
  width?: Maybe<Scalars['Int']['output']>;
};

/** A Spotify playlist */
export type SpotifyPlaylist = {
  __typename?: 'SpotifyPlaylist';
  /** Whether the playlist is collaborative */
  collaborative: Scalars['Boolean']['output'];
  /** Description of the playlist */
  description?: Maybe<Scalars['String']['output']>;
  /** External URLs for the playlist */
  externalUrls?: Maybe<Scalars['JSON']['output']>;
  /** Playlist cover images */
  images: Array<SpotifyImage>;
  /** Name of the playlist */
  name: Scalars['String']['output'];
  /** Owner of the playlist */
  owner?: Maybe<SpotifyUser>;
  /** Whether the playlist is public */
  public: Scalars['Boolean']['output'];
  /** Spotify ID of the playlist */
  spotifyId: Scalars['String']['output'];
  /** Total number of tracks in the playlist */
  tracksTotal: Scalars['Int']['output'];
};

/** A Spotify sync history record */
export type SpotifySyncHistory = {
  __typename?: 'SpotifySyncHistory';
  /** When the sync completed */
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the record was created */
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Duration of the sync in seconds */
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for the sync history */
  id: Scalars['ID']['output'];
  /** Whether this sync is currently active */
  isActive: Scalars['Boolean']['output'];
  /** Status message or error description */
  message?: Maybe<Scalars['String']['output']>;
  /** Additional metadata about the sync operation */
  metadata?: Maybe<Scalars['JSON']['output']>;
  /** ID of the associated resource (playlist) */
  resourceId?: Maybe<Scalars['ID']['output']>;
  /** Spotify ID of the resource being synced */
  spotifyResourceId?: Maybe<Scalars['String']['output']>;
  /** When the sync started */
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current status of the sync operation */
  status: Scalars['String']['output'];
  /** Type of sync operation (import, sync) */
  syncType?: Maybe<Scalars['String']['output']>;
  /** When the record was last updated */
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** A Spotify user */
export type SpotifyUser = {
  __typename?: 'SpotifyUser';
  /** Display name of the user */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Spotify ID of the user */
  spotifyId: Scalars['String']['output'];
};

/** A user's staff membership in the internal admin tool */
export type StaffMember = {
  __typename?: 'StaffMember';
  id: Scalars['ID']['output'];
  /** Resolved permission keys for this staff member (super_admin implies all keys) */
  permissions: Array<Scalars['String']['output']>;
  role: StaffRole;
};

/** A staff role for the internal admin tool, granting a set of permission keys */
export type StaffRole = {
  __typename?: 'StaffRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Number of staff members holding this role */
  membersCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
};

/** Autogenerated input type of StartConversation */
export type StartConversationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  djProfileId: Scalars['ID']['input'];
  /** Optional first message */
  message?: InputMaybe<Scalars['String']['input']>;
  /**
   * Venue organization initiating the conversation (defaults to the viewer's
   * current organization). The viewer must be a full member; the policy enforces this.
   */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of StartConversation. */
export type StartConversationPayload = {
  __typename?: 'StartConversationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  errors: Array<Scalars['String']['output']>;
};

/** Current playback state for a station in a zone */
export type StationState = {
  __typename?: 'StationState';
  /** ID of the current track in queue */
  currentTrackId?: Maybe<Scalars['ID']['output']>;
  /** When the queue was last refilled */
  lastRefilledAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** ID of the next track in queue */
  nextTrackId?: Maybe<Scalars['ID']['output']>;
  /** Station playlist */
  playlist: Playlist;
  /** Total number of tracks in queue */
  queueSize: Scalars['Int']['output'];
  /** Number of recently played tracks */
  recentlyPlayedCount: Scalars['Int']['output'];
  /** Number of tracks remaining in queue */
  remainingTracks: Scalars['Int']['output'];
  zone: Zone;
};

/** User feedback (like/dislike) for a track in a station */
export type StationTrackFeedback = {
  __typename?: 'StationTrackFeedback';
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Type of feedback: 'like' or 'dislike' */
  feedbackType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Station playlist */
  playlist: Playlist;
  track: Track;
  user: User;
};

/** A stock-library video available for import */
export type StockVideo = {
  __typename?: 'StockVideo';
  attribution?: Maybe<Scalars['String']['output']>;
  downloadUrl: Scalars['String']['output'];
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  license: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of StopZoneOverride */
export type StopZoneOverrideInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of StopZoneOverride. */
export type StopZoneOverridePayload = {
  __typename?: 'StopZoneOverridePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  zone?: Maybe<Zone>;
};

/** Autogenerated input type of SubmitPlaylistFeedback */
export type SubmitPlaylistFeedbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  feedbackType: PlaylistFeedbackTypeEnum;
  helpful?: InputMaybe<Scalars['Boolean']['input']>;
  playlistId: Scalars['ID']['input'];
  rating?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of SubmitPlaylistFeedback. */
export type SubmitPlaylistFeedbackPayload = {
  __typename?: 'SubmitPlaylistFeedbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  feedback: PlaylistFeedback;
};

/** Real-time subscriptions for the application */
export type Subscription = {
  __typename?: 'Subscription';
  /**
   * Viewer-scoped inbox events: new messages and read-state changes across all of
   * the viewer's conversations. Drives thread-list ordering, unread badges, and toasts.
   */
  inboxUpdated: Scalars['JSON']['output'];
  /** Subscribe to jukebox queue updates for a specific zone */
  jukeboxQueueUpdated: Scalars['JSON']['output'];
  /** Subscribe to karaoke session/queue updates for a specific zone */
  karaokeSessionUpdated: Scalars['JSON']['output'];
  /** Subscribe to new messages in a conversation (DJ Network messaging) */
  messageAdded: Scalars['JSON']['output'];
  /** Subscribe to AI playlist generation status updates */
  playlistGenerationStatus: PlaylistGenerationStatus;
  /** Subscribe to transcode progress updates for a video */
  videoProcessingStatus: VideoProcessingStatus;
  /** Subscribe to zone status updates for a specific zone */
  zoneStatusUpdated: ZoneStatus;
};


/** Real-time subscriptions for the application */
export type SubscriptionJukeboxQueueUpdatedArgs = {
  zoneId: Scalars['ID']['input'];
};


/** Real-time subscriptions for the application */
export type SubscriptionKaraokeSessionUpdatedArgs = {
  zoneId: Scalars['ID']['input'];
};


/** Real-time subscriptions for the application */
export type SubscriptionMessageAddedArgs = {
  conversationId: Scalars['ID']['input'];
};


/** Real-time subscriptions for the application */
export type SubscriptionPlaylistGenerationStatusArgs = {
  playlistId: Scalars['ID']['input'];
};


/** Real-time subscriptions for the application */
export type SubscriptionVideoProcessingStatusArgs = {
  videoId: Scalars['ID']['input'];
};


/** Real-time subscriptions for the application */
export type SubscriptionZoneStatusUpdatedArgs = {
  zoneId: Scalars['ID']['input'];
};

export type SupportTicket = {
  __typename?: 'SupportTicket';
  assigneeName?: Maybe<Scalars['String']['output']>;
  /** Ticket id on the provider side */
  externalId: Scalars['String']['output'];
  /** Provider-native URL for the ticket */
  externalUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastActivityAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** When the provider adapter last refreshed this row; null for manual rows */
  lastSyncedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  openedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Matched organization; null while the ticket is unmatched */
  organization?: Maybe<Organization>;
  /** low, normal, high or urgent; null when the provider sets none */
  priority?: Maybe<Scalars['String']['output']>;
  /** Ticketing platform the row mirrors: zendesk, intercom, front or manual */
  provider: Scalars['String']['output'];
  requesterEmail?: Maybe<Scalars['String']['output']>;
  requesterName?: Maybe<Scalars['String']['output']>;
  /** Spin-side enrichment payload (Support::ContextPayload): plan, billing status, zones, devices, recent playback */
  spinContext: Scalars['JSON']['output'];
  /** open, pending, solved or closed */
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

/** The connection type for SupportTicket. */
export type SupportTicketConnection = {
  __typename?: 'SupportTicketConnection';
  /** A list of edges. */
  edges: Array<SupportTicketEdge>;
  /** A list of nodes. */
  nodes: Array<SupportTicket>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SupportTicketEdge = {
  __typename?: 'SupportTicketEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SupportTicket>;
};

export type SupportTicketStats = {
  __typename?: 'SupportTicketStats';
  /** Tickets currently in the open status */
  open: Scalars['Int']['output'];
  /** Tickets currently in the pending status */
  pending: Scalars['Int']['output'];
  /** Tickets in the solved status whose last activity was today */
  solvedToday: Scalars['Int']['output'];
  /** Tickets not yet matched to an organization (organizationId is null) */
  unmatched: Scalars['Int']['output'];
};

/** Autogenerated input type of SwitchOrganization */
export type SwitchOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of SwitchOrganization. */
export type SwitchOrganizationPayload = {
  __typename?: 'SwitchOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

/** Autogenerated input type of SyncSpotifyPlaylist */
export type SyncSpotifyPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the playlist to sync */
  playlistId: Scalars['ID']['input'];
};

/** Autogenerated return type of SyncSpotifyPlaylist. */
export type SyncSpotifyPlaylistPayload = {
  __typename?: 'SyncSpotifyPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  playlist?: Maybe<Playlist>;
  requiresReauth: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
  syncHistoryId?: Maybe<Scalars['ID']['output']>;
  tracksAdded?: Maybe<Scalars['Int']['output']>;
  tracksUpdated?: Maybe<Scalars['Int']['output']>;
};

/** Autogenerated input type of SyncStripeCheckoutSession */
export type SyncStripeCheckoutSessionInput = {
  checkoutSessionId: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of SyncStripeCheckoutSession. */
export type SyncStripeCheckoutSessionPayload = {
  __typename?: 'SyncStripeCheckoutSessionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  subscription?: Maybe<BillingSubscription>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TerminateDjEngagement */
export type TerminateDjEngagementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of TerminateDjEngagement. */
export type TerminateDjEngagementPayload = {
  __typename?: 'TerminateDjEngagementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  engagement?: Maybe<DjEngagement>;
  errors: Array<Scalars['String']['output']>;
};

/**
 * Configuration presence and cheap status for one third-party service. configured
 * only ever reflects PRESENCE of a credential — never its value.
 */
export type ThirdPartyIntegration = {
  __typename?: 'ThirdPartyIntegration';
  /** Whether the relevant credential/config is present (never the value itself) */
  configured: Scalars['Boolean']['output'];
  /** Cheaply derivable last-activity timestamp, when one exists */
  lastActivityAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  name: Scalars['String']['output'];
  /** Cheap human-readable status (e.g. connected, configured, N connected users) */
  status?: Maybe<Scalars['String']['output']>;
};

/** Top track playback data */
export type TopTrack = {
  __typename?: 'TopTrack';
  /** Average completion percentage */
  averageCompletionPercentage?: Maybe<Scalars['Float']['output']>;
  /** Number of times played */
  playCount: Scalars['Int']['output'];
  /** Total time spent listening to this track */
  totalListeningTimeSeconds: Scalars['Int']['output'];
  /** The track object if available */
  track?: Maybe<Track>;
  /** The track artist */
  trackArtist: Scalars['String']['output'];
  /** The track ID */
  trackId?: Maybe<Scalars['ID']['output']>;
  /** The track title */
  trackTitle: Scalars['String']['output'];
};

export type Track = Node & {
  __typename?: 'Track';
  /** Whether this track was generated by AI */
  aiGenerated: Scalars['Boolean']['output'];
  /** AI model used to generate this track */
  aiGenerationModel?: Maybe<Scalars['String']['output']>;
  album?: Maybe<Album>;
  artists?: Maybe<Array<Artist>>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  coverThumbUrl?: Maybe<Scalars['String']['output']>;
  coverUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  discNumber?: Maybe<Scalars['Int']['output']>;
  displayArtist?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  explicit: Scalars['Boolean']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** Whether this track was imported from Spotify */
  isSpotifyTrack: Scalars['Boolean']['output'];
  /** Primary performing rights organization */
  licensingPro?: Maybe<LicensingProEnum>;
  /** Timestamp when the licensing PRO was last verified */
  licensingProCheckedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  markets?: Maybe<Array<Market>>;
  name: Scalars['String']['output'];
  /** Whether this track has an audio file and can be played */
  playable: Scalars['Boolean']['output'];
  popularity?: Maybe<Scalars['Int']['output']>;
  /** Raw Spotify track data */
  spotifyData?: Maybe<Scalars['JSON']['output']>;
  /** Spotify ID if imported from Spotify */
  spotifyId?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  trackAudioFeature?: Maybe<TrackAudioFeature>;
  trackNumber?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

export type TrackAudioFeature = Node & {
  __typename?: 'TrackAudioFeature';
  /** A confidence measure from 0.0 to 1.0 of whether the track is acoustic */
  acousticness?: Maybe<Scalars['Float']['output']>;
  /** The tempo of the track in beats per minute (BPM) */
  bpm?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** Danceability describes how suitable a track is for dancing based on a combination of musical elements */
  danceability?: Maybe<Scalars['Float']['output']>;
  /** Energy is a measure from 0.0 to 1.0 and represents a perceptual measure of intensity and power */
  energy?: Maybe<Scalars['Float']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** Predicts whether a track contains no vocals */
  instrumentalness?: Maybe<Scalars['Float']['output']>;
  /** The key the track is in. Integers map to pitches using standard Pitch Class notation */
  key?: Maybe<Scalars['Int']['output']>;
  /** Detects the presence of an audience in the recording */
  liveness?: Maybe<Scalars['Float']['output']>;
  /** The overall loudness of a track in decibels (dB) */
  loudness?: Maybe<Scalars['Float']['output']>;
  /** Track lyrics if available */
  lyrics?: Maybe<Scalars['String']['output']>;
  /** Mode indicates the modality (major or minor) of a track */
  mode?: Maybe<Scalars['Int']['output']>;
  /** Speechiness detects the presence of spoken words in a track */
  speechiness?: Maybe<Scalars['Float']['output']>;
  /** The overall estimated tempo of a track in beats per minute (BPM) */
  tempo?: Maybe<Scalars['Float']['output']>;
  /** An estimated overall time signature of a track */
  timeSignature?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  /** A measure from 0.0 to 1.0 describing the musical positiveness conveyed by a track */
  valence?: Maybe<Scalars['Float']['output']>;
};

/** Input for track audio features */
export type TrackAudioFeatureInput = {
  /** A confidence measure from 0.0 to 1.0 of whether the track is acoustic */
  acousticness?: InputMaybe<Scalars['Float']['input']>;
  /** The tempo of the track in beats per minute (BPM) */
  bpm?: InputMaybe<Scalars['Float']['input']>;
  /** Danceability describes how suitable a track is for dancing based on a combination of musical elements */
  danceability?: InputMaybe<Scalars['Float']['input']>;
  /** Energy is a measure from 0.0 to 1.0 and represents a perceptual measure of intensity and power */
  energy?: InputMaybe<Scalars['Float']['input']>;
  /** Predicts whether a track contains no vocals */
  instrumentalness?: InputMaybe<Scalars['Float']['input']>;
  /** The key the track is in. Integers map to pitches using standard Pitch Class notation */
  key?: InputMaybe<Scalars['Int']['input']>;
  /** Detects the presence of an audience in the recording */
  liveness?: InputMaybe<Scalars['Float']['input']>;
  /** The overall loudness of a track in decibels (dB) */
  loudness?: InputMaybe<Scalars['Float']['input']>;
  /** Track lyrics if available */
  lyrics?: InputMaybe<Scalars['String']['input']>;
  /** Mode indicates the modality (major or minor) of a track */
  mode?: InputMaybe<Scalars['Int']['input']>;
  /** Speechiness detects the presence of spoken words in a track */
  speechiness?: InputMaybe<Scalars['Float']['input']>;
  /** The overall estimated tempo of a track in beats per minute (BPM) */
  tempo?: InputMaybe<Scalars['Float']['input']>;
  /** An estimated overall time signature of a track */
  timeSignature?: InputMaybe<Scalars['Float']['input']>;
  /** A measure from 0.0 to 1.0 describing the musical positiveness conveyed by a track */
  valence?: InputMaybe<Scalars['Float']['input']>;
};

/** A track wrapped with a zone-specific availability verdict */
export type TrackAvailability = {
  __typename?: 'TrackAvailability';
  /** Whether this track can be requested in the current zone/mode */
  available: Scalars['Boolean']['output'];
  track: Track;
  /** Reason code; null iff `available` is true */
  unavailableReason?: Maybe<JukeboxUnavailableReasonEnum>;
};

/** Paginated list of tracks with zone-specific availability info */
export type TrackAvailabilityPage = {
  __typename?: 'TrackAvailabilityPage';
  items: Array<TrackAvailability>;
  pageInfo: JukeboxPageInfo;
};

/** The connection type for Track. */
export type TrackConnection = {
  __typename?: 'TrackConnection';
  /** A list of edges. */
  edges: Array<TrackEdge>;
  /** A list of nodes. */
  nodes: Array<Track>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type TrackEdge = {
  __typename?: 'TrackEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Track>;
};

/** Status of an individual AI music track generation */
export type TrackGenerationStatus = {
  __typename?: 'TrackGenerationStatus';
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Generation cost in cents */
  costCents?: Maybe<Scalars['Int']['output']>;
  /** Duration of generated track in milliseconds */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** Error message if generation failed */
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** AI model used for generation */
  model: Scalars['String']['output'];
  /** Position in the playlist */
  position: Scalars['Int']['output'];
  /** The music generation prompt used */
  prompt: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  /** Current status: pending, generating, processing, completed, failed */
  status: Scalars['String']['output'];
  /** The generated track (available after generation completes) */
  track?: Maybe<Track>;
};

/** Sort options for tracks */
export enum TrackSortByEnum {
  /** Sort by duration (longest first) */
  Duration = 'duration',
  /** Sort by name (A-Z) */
  NameAsc = 'name_asc',
  /** Sort by name (Z-A) */
  NameDesc = 'name_desc',
  /** Sort by creation date (newest first) */
  Newest = 'newest',
  /** Sort by creation date (oldest first) */
  Oldest = 'oldest',
  /** Sort by popularity (highest first) */
  Popularity = 'popularity',
  /** Sort by album release date (newest first) */
  ReleaseDateDesc = 'release_date_desc'
}

/**
 * A group of items needing staff attention on the Overview dashboard. Groups are
 * built only from existing queryable state; empty groups and groups the viewer
 * lacks the underlying permission for are omitted.
 */
export type TriageGroup = {
  __typename?: 'TriageGroup';
  /** devices_down | service_degraded | billing_exceptions | unmatched_licensing */
  category: Scalars['String']['output'];
  /** Total items in the group (rows are capped) */
  count: Scalars['Int']['output'];
  rows: Array<TriageRow>;
  /** critical | warning | info */
  severity: Scalars['String']['output'];
};

/** One actionable row inside a triage group */
export type TriageRow = {
  __typename?: 'TriageRow';
  /** spin-admin route where the row can be acted on (e.g. /fleet, /health, /money, /licensing) */
  detailPath: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** Autogenerated input type of UnbookmarkDj */
export type UnbookmarkDjInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  djProfileId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnbookmarkDj. */
export type UnbookmarkDjPayload = {
  __typename?: 'UnbookmarkDjPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UncancelZoneBilling */
export type UncancelZoneBillingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An add-on plan id to keep only that add-on; omit to keep the zone subscribed (and its add-ons) */
  planId?: InputMaybe<Scalars['ID']['input']>;
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of UncancelZoneBilling. */
export type UncancelZoneBillingPayload = {
  __typename?: 'UncancelZoneBillingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  zoneItem?: Maybe<BillingSubscriptionItem>;
};

/** Autogenerated input type of UpdateCampaign */
export type UpdateCampaignInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Campaign ID */
  id: Scalars['ID']['input'];
  /** Campaign attributes */
  input: CampaignInput;
};

/** Autogenerated return type of UpdateCampaign. */
export type UpdateCampaignPayload = {
  __typename?: 'UpdateCampaignPayload';
  campaign?: Maybe<Campaign>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateDjProfile */
export type UpdateDjProfileInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  genreIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<Scalars['JSON']['input']>;
  marketIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Signed blob id from a direct upload */
  photoBlobId?: InputMaybe<Scalars['String']['input']>;
  rateCents?: InputMaybe<Scalars['Int']['input']>;
  rateCurrency?: InputMaybe<Scalars['String']['input']>;
  rateNotes?: InputMaybe<Scalars['String']['input']>;
  rateType?: InputMaybe<DjRateType>;
  slug?: InputMaybe<Scalars['String']['input']>;
  yearsExperience?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateDjProfile. */
export type UpdateDjProfilePayload = {
  __typename?: 'UpdateDjProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  djProfile?: Maybe<DjProfile>;
  errors: Array<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateJukeboxLocationConfiguration */
export type UpdateJukeboxLocationConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config: JukeboxConfigurationInput;
  locationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateJukeboxLocationConfiguration. */
export type UpdateJukeboxLocationConfigurationPayload = {
  __typename?: 'UpdateJukeboxLocationConfigurationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  jukeboxConfiguration?: Maybe<JukeboxConfiguration>;
};

/** Autogenerated input type of UpdateJukeboxOrgConfiguration */
export type UpdateJukeboxOrgConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config: JukeboxConfigurationInput;
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateJukeboxOrgConfiguration. */
export type UpdateJukeboxOrgConfigurationPayload = {
  __typename?: 'UpdateJukeboxOrgConfigurationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  jukeboxConfiguration?: Maybe<JukeboxConfiguration>;
};

/** Autogenerated input type of UpdateJukeboxZoneConfiguration */
export type UpdateJukeboxZoneConfigurationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  config: JukeboxConfigurationInput;
  zoneId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateJukeboxZoneConfiguration. */
export type UpdateJukeboxZoneConfigurationPayload = {
  __typename?: 'UpdateJukeboxZoneConfigurationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  jukeboxConfiguration?: Maybe<JukeboxConfiguration>;
};

/** Autogenerated input type of UpdateLocation */
export type UpdateLocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** This location's own opening hours. Null clears the override so it inherits the organization's. */
  hours?: InputMaybe<Scalars['JSON']['input']>;
  /** Free text beside the structured week, e.g. Kitchen closes at 11 */
  hoursNote?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  publicEmail?: InputMaybe<Scalars['String']['input']>;
  /** Operational region for fleet rollups. Blank clears it. */
  region?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLocation. */
export type UpdateLocationPayload = {
  __typename?: 'UpdateLocationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  location: Location;
};

/** Autogenerated input type of UpdateOauthApplication */
export type UpdateOauthApplicationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateOauthApplication. */
export type UpdateOauthApplicationPayload = {
  __typename?: 'UpdateOauthApplicationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  oauthApplication: OauthApplication;
};

/** Autogenerated input type of UpdateOrganizationMembership */
export type UpdateOrganizationMembershipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  membershipId: Scalars['ID']['input'];
  membershipRole: MembershipRole;
};

/** Autogenerated return type of UpdateOrganizationMembership. */
export type UpdateOrganizationMembershipPayload = {
  __typename?: 'UpdateOrganizationMembershipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  organizationMembership?: Maybe<OrganizationMembership>;
};

/** Autogenerated input type of UpdatePlaylist */
export type UpdatePlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Playlist ID */
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdatePlaylist. */
export type UpdatePlaylistPayload = {
  __typename?: 'UpdatePlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  playlist?: Maybe<Playlist>;
};

/** Autogenerated input type of UpdatePlaylistPrompt */
export type UpdatePlaylistPromptInput = {
  aiPrompt: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  regenerate?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdatePlaylistPrompt. */
export type UpdatePlaylistPromptPayload = {
  __typename?: 'UpdatePlaylistPromptPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  playlist: Playlist;
};

/** Autogenerated input type of UpdateStaffRolePermissions */
export type UpdateStaffRolePermissionsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  permissions: Array<Scalars['String']['input']>;
  roleId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateStaffRolePermissions. */
export type UpdateStaffRolePermissionsPayload = {
  __typename?: 'UpdateStaffRolePermissionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  staffRole?: Maybe<StaffRole>;
};

/** Autogenerated input type of UpdateTrack */
export type UpdateTrackInput = {
  albumId?: InputMaybe<Scalars['ID']['input']>;
  artistIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  audioFeatures?: InputMaybe<TrackAudioFeatureInput>;
  audioSignedId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  coverSignedId?: InputMaybe<Scalars['ID']['input']>;
  discNumber?: InputMaybe<Scalars['Int']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  explicit?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  popularity?: InputMaybe<Scalars['Int']['input']>;
  trackNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of UpdateTrackLicensingPro */
export type UpdateTrackLicensingProInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  /** The PRO to assign (ASCAP, BMI, GMR, SESAC) */
  pro: LicensingProEnum;
};

/** Autogenerated input type of UpdateTrackPosition */
export type UpdateTrackPositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPosition: Scalars['Int']['input'];
  playlistId: Scalars['ID']['input'];
  playlistTrackId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateTrackPosition. */
export type UpdateTrackPositionPayload = {
  __typename?: 'UpdateTrackPositionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateVideo */
export type UpdateVideoInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of UpdateVideo. */
export type UpdateVideoPayload = {
  __typename?: 'UpdateVideoPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  video?: Maybe<Video>;
};

/** Autogenerated input type of UpdateVideoPlaylist */
export type UpdateVideoPlaylistInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateVideoPlaylist. */
export type UpdateVideoPlaylistPayload = {
  __typename?: 'UpdateVideoPlaylistPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  videoPlaylist?: Maybe<VideoPlaylist>;
};

/** Autogenerated input type of UpdateVideoPosition */
export type UpdateVideoPositionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPosition: Scalars['Int']['input'];
  videoId: Scalars['ID']['input'];
  videoPlaylistId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateVideoPosition. */
export type UpdateVideoPositionPayload = {
  __typename?: 'UpdateVideoPositionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UpdateVoiceMessage */
export type UpdateVoiceMessageInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Voice message ID */
  id: Scalars['ID']['input'];
  /** Voice message attributes */
  input: VoiceMessageInput;
};

/** Autogenerated return type of UpdateVoiceMessage. */
export type UpdateVoiceMessagePayload = {
  __typename?: 'UpdateVoiceMessagePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  voiceMessage?: Maybe<VoiceMessage>;
};

/** Autogenerated input type of UpdateVoiceMessageSchedule */
export type UpdateVoiceMessageScheduleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Voice message schedule ID */
  id: Scalars['ID']['input'];
  /** Voice message schedule attributes */
  input: VoiceMessageScheduleInput;
};

/** Autogenerated return type of UpdateVoiceMessageSchedule. */
export type UpdateVoiceMessageSchedulePayload = {
  __typename?: 'UpdateVoiceMessageSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  voiceMessageSchedule?: Maybe<VoiceMessageSchedule>;
};

/** Autogenerated input type of UpdateZone */
export type UpdateZoneInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateZone. */
export type UpdateZonePayload = {
  __typename?: 'UpdateZonePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  zone: Zone;
};

/** Autogenerated input type of UpsertDjTestimonial */
export type UpsertDjTestimonialInput = {
  authorName: Scalars['String']['input'];
  authorTitle?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  displayed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  quote: Scalars['String']['input'];
};

/** Autogenerated return type of UpsertDjTestimonial. */
export type UpsertDjTestimonialPayload = {
  __typename?: 'UpsertDjTestimonialPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors: Array<Scalars['String']['output']>;
  testimonial?: Maybe<DjTestimonial>;
};

/** Autogenerated input type of UpsertPlaylistSchedule */
export type UpsertPlaylistScheduleInput = {
  attrs: PlaylistScheduleInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpsertPlaylistSchedule. */
export type UpsertPlaylistSchedulePayload = {
  __typename?: 'UpsertPlaylistSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  schedule?: Maybe<PlaylistSchedule>;
};

/** Autogenerated input type of UpsertVideoSchedule */
export type UpsertVideoScheduleInput = {
  attrs: VideoScheduleInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpsertVideoSchedule. */
export type UpsertVideoSchedulePayload = {
  __typename?: 'UpsertVideoSchedulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Scalars['String']['output']>>;
  schedule?: Maybe<VideoSchedule>;
};

export type User = Node & {
  __typename?: 'User';
  avatarThumbUrl?: Maybe<Scalars['String']['output']>;
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  currentOrganization?: Maybe<Organization>;
  djProfile?: Maybe<DjProfile>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  organizations: MembershipConnection;
  recentOrganizations: Array<Organization>;
  spotifyConnected: Scalars['Boolean']['output'];
  spotifyId?: Maybe<Scalars['String']['output']>;
  timeZone: Scalars['String']['output'];
  /** Viewer's unread DJ Network messages across all conversations (0 for other users) */
  unreadMessagesCount: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  userRole: UserRole;
  userStatus: UserStatus;
  vimeoConnected: Scalars['Boolean']['output'];
};


export type UserOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for User. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges: Array<UserEdge>;
  /** A list of nodes. */
  nodes: Array<User>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

export type UserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  userRole?: InputMaybe<UserRole>;
  userStatus?: InputMaybe<UserStatus>;
};

/** User role enum */
export enum UserRole {
  Member = 'MEMBER',
  OrgAdmin = 'ORG_ADMIN',
  SystemAdmin = 'SYSTEM_ADMIN'
}

/** User status enum */
export enum UserStatus {
  Active = 'ACTIVE',
  Blocked = 'BLOCKED',
  Invited = 'INVITED'
}

/** Autogenerated input type of UserUpdate */
export type UserUpdateInput = {
  avatarSignedId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Required when a user changes their own email (re-authentication) */
  currentPassword?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  removeAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  userInput: UserInput;
};

/** Autogenerated return type of UserUpdate. */
export type UserUpdatePayload = {
  __typename?: 'UserUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type VendorExpense = Node & {
  __typename?: 'VendorExpense';
  amountCents: Scalars['Int']['output'];
  createdAt: Scalars['ISO8601DateTime']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  /** First day of the month this expense covers */
  period: Scalars['ISO8601Date']['output'];
  /** manual | api | receipt */
  source: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  vendor: Scalars['String']['output'];
};

export type VendorExpenseLine = {
  __typename?: 'VendorExpenseLine';
  amountCents: Scalars['Int']['output'];
  /** manual | api | receipt */
  source: Scalars['String']['output'];
  vendor: Scalars['String']['output'];
};

export type VendorExpenseMonth = {
  __typename?: 'VendorExpenseMonth';
  /** Per-vendor lines, sorted by amount descending */
  byVendor: Array<VendorExpenseLine>;
  /** First day of the month */
  period: Scalars['ISO8601Date']['output'];
  totalCents: Scalars['Int']['output'];
};

export type VendorExpenseReport = {
  __typename?: 'VendorExpenseReport';
  /** Newest first; one entry per month in the requested window, even months with no recorded expenses */
  months: Array<VendorExpenseMonth>;
};

export type VenueLink = {
  __typename?: 'VenueLink';
  category: Scalars['String']['output'];
  /** A suppression rather than a link: hides the organization entry with the same category and platform */
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Whether the client is expected to have branded treatment for this platform. False means render a generic link. */
  knownPlatform: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  ownerId: Scalars['ID']['output'];
  ownerType: Scalars['String']['output'];
  /**
   * Freeform platform slug (instagram, doordash, or something we've never heard
   * of). Null for links that aren't tied to a platform.
   */
  platform?: Maybe<Scalars['String']['output']>;
  position: Scalars['Int']['output'];
  published: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type Video = Node & {
  __typename?: 'Video';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** Signed URL for the HEVC device rendition */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['BigInt']['output']>;
  fileSize?: Maybe<Scalars['BigInt']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  posterUrl?: Maybe<Scalars['String']['output']>;
  /** Universal H.264 HLS playlist for browser preview */
  previewHlsUrl?: Maybe<Scalars['String']['output']>;
  processingError?: Maybe<Scalars['String']['output']>;
  processingProgress: Scalars['Int']['output'];
  processingStatus: VideoProcessingStatusEnum;
  renditions: Scalars['JSON']['output'];
  sourceCodec?: Maybe<Scalars['String']['output']>;
  sourceKind: VideoSourceKindEnum;
  sourceMetadata: Scalars['JSON']['output'];
  storyboardUrl?: Maybe<Scalars['String']['output']>;
  tags: Scalars['JSON']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  user?: Maybe<User>;
  /** Kept video playlists that include this asset, ordered by name */
  videoPlaylists: Array<VideoPlaylist>;
  /** Kept schedules that program this asset into a zone (through the kept playlists containing it) */
  videoSchedules: Array<VideoSchedule>;
  width?: Maybe<Scalars['Int']['output']>;
};

/** The connection type for Video. */
export type VideoConnection = {
  __typename?: 'VideoConnection';
  /** A list of edges. */
  edges: Array<VideoEdge>;
  /** A list of nodes. */
  nodes: Array<Video>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VideoEdge = {
  __typename?: 'VideoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Video>;
};

export type VideoGeneration = {
  __typename?: 'VideoGeneration';
  aspectRatio: Scalars['String']['output'];
  completedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  costCents?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  durationSeconds: Scalars['Int']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  model: Scalars['String']['output'];
  prompt: Scalars['String']['output'];
  status: Scalars['String']['output'];
  video?: Maybe<Video>;
};

/** One video to import from an external source */
export type VideoImportItemInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  attribution?: InputMaybe<Scalars['String']['input']>;
  downloadUrl?: InputMaybe<Scalars['String']['input']>;
  fileId?: InputMaybe<Scalars['String']['input']>;
  license?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  providerUrl?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  vimeoVideoId?: InputMaybe<Scalars['String']['input']>;
};

/** External sources a video can be imported from */
export enum VideoImportSourceEnum {
  /** Dropbox Chooser direct link */
  Dropbox = 'dropbox',
  /** Google Drive (Picker + drive.file token) */
  GoogleDrive = 'google_drive',
  /** OneDrive/SharePoint (File Picker download URL) */
  Onedrive = 'onedrive',
  /** Pexels stock library */
  StockPexels = 'stock_pexels',
  /** Pixabay stock library */
  StockPixabay = 'stock_pixabay',
  /** Direct HTTPS link to a video file */
  Url = 'url',
  /** The user's own Vimeo videos */
  Vimeo = 'vimeo'
}

export type VideoPlaylist = Node & {
  __typename?: 'VideoPlaylist';
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  totalDurationMs: Scalars['BigInt']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  videoCount: Scalars['Int']['output'];
  videoPlaylistVideos: Array<VideoPlaylistVideo>;
};

/** The connection type for VideoPlaylist. */
export type VideoPlaylistConnection = {
  __typename?: 'VideoPlaylistConnection';
  /** A list of edges. */
  edges: Array<VideoPlaylistEdge>;
  /** A list of nodes. */
  nodes: Array<VideoPlaylist>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VideoPlaylistEdge = {
  __typename?: 'VideoPlaylistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VideoPlaylist>;
};

export type VideoPlaylistVideo = {
  __typename?: 'VideoPlaylistVideo';
  createdAt: Scalars['ISO8601DateTime']['output'];
  position: Scalars['Int']['output'];
  video: Video;
};

/** Live transcode progress for a video */
export type VideoProcessingStatus = {
  __typename?: 'VideoProcessingStatus';
  error?: Maybe<Scalars['String']['output']>;
  progress: Scalars['Int']['output'];
  status: VideoProcessingStatusEnum;
  videoId: Scalars['ID']['output'];
};

/** Transcode pipeline state of a video */
export enum VideoProcessingStatusEnum {
  /** Import source file is being fetched */
  Downloading = 'downloading',
  /** Transcoding failed */
  Failed = 'failed',
  /** Waiting for transcoding to start */
  Pending = 'pending',
  /** Transcoding in progress */
  Processing = 'processing',
  /** All renditions available */
  Ready = 'ready'
}

export type VideoSchedule = Node & {
  __typename?: 'VideoSchedule';
  createdAt: Scalars['ISO8601DateTime']['output'];
  endDate?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  /** ID of the object. */
  id: Scalars['ID']['output'];
  rrule?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  videoPlaylist?: Maybe<VideoPlaylist>;
  zone?: Maybe<Zone>;
};

/** The connection type for VideoSchedule. */
export type VideoScheduleConnection = {
  __typename?: 'VideoScheduleConnection';
  /** A list of edges. */
  edges: Array<VideoScheduleEdge>;
  /** A list of nodes. */
  nodes: Array<VideoSchedule>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VideoScheduleEdge = {
  __typename?: 'VideoScheduleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VideoSchedule>;
};

export type VideoScheduleInput = {
  byWeekday?: InputMaybe<Array<RRuleByWeekday>>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endTime: Scalars['String']['input'];
  frequency?: InputMaybe<RRuleFrequency>;
  interval?: InputMaybe<Scalars['Int']['input']>;
  rrule?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  startTime: Scalars['String']['input'];
  videoPlaylistId: Scalars['ID']['input'];
  zoneId: Scalars['ID']['input'];
};

/** Where a video came from */
export enum VideoSourceKindEnum {
  /** Generated with an AI video model */
  AiGenerated = 'ai_generated',
  /** Imported from Dropbox */
  Dropbox = 'dropbox',
  /** Imported from Google Drive */
  GoogleDrive = 'google_drive',
  /** Imported from OneDrive/SharePoint */
  Onedrive = 'onedrive',
  /** Imported from the Pexels stock library */
  StockPexels = 'stock_pexels',
  /** Imported from the Pixabay stock library */
  StockPixabay = 'stock_pixabay',
  /** Direct browser upload */
  Upload = 'upload',
  /** Imported from a direct URL */
  Url = 'url',
  /** Imported from the user's Vimeo account */
  Vimeo = 'vimeo'
}

/** One file in a bulk video upload */
export type VideoUploadItemInput = {
  name: Scalars['String']['input'];
  originalSignedId: Scalars['ID']['input'];
};

/** Autogenerated input type of VimeoAuthorizationUrl */
export type VimeoAuthorizationUrlInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of VimeoAuthorizationUrl. */
export type VimeoAuthorizationUrlPayload = {
  __typename?: 'VimeoAuthorizationUrlPayload';
  authorizationUrl: Scalars['String']['output'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of VimeoConnectCallback */
export type VimeoConnectCallbackInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['String']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

/** Autogenerated return type of VimeoConnectCallback. */
export type VimeoConnectCallbackPayload = {
  __typename?: 'VimeoConnectCallbackPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Autogenerated input type of VimeoDisconnect */
export type VimeoDisconnectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of VimeoDisconnect. */
export type VimeoDisconnectPayload = {
  __typename?: 'VimeoDisconnectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** A video on the user's connected Vimeo account */
export type VimeoVideo = {
  __typename?: 'VimeoVideo';
  /** False when the Vimeo plan doesn't expose source files */
  downloadable: Scalars['Boolean']['output'];
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type VoiceCommandEvent = Node & {
  __typename?: 'VoiceCommandEvent';
  action: Scalars['String']['output'];
  confidence?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  entities: Scalars['JSON']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  intent: Scalars['String']['output'];
  locale?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  metadata: Scalars['JSON']['output'];
  normalizedText: Scalars['String']['output'];
  organization: Organization;
  playlist?: Maybe<Playlist>;
  rawText: Scalars['String']['output'];
  resolvedTrackIds: Scalars['JSON']['output'];
  searchResults: Scalars['JSON']['output'];
  success: Scalars['Boolean']['output'];
  user: User;
  zone?: Maybe<Zone>;
};

/** A voice message that can be scheduled for playback */
export type VoiceMessage = {
  __typename?: 'VoiceMessage';
  audioFileUrl?: Maybe<Scalars['String']['output']>;
  audioUrl?: Maybe<Scalars['String']['output']>;
  campaigns: Array<Campaign>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName: Scalars['String']['output'];
  durationFormatted?: Maybe<Scalars['String']['output']>;
  durationSeconds?: Maybe<Scalars['Int']['output']>;
  enabled: Scalars['Boolean']['output'];
  hasActiveSchedules: Scalars['Boolean']['output'];
  hlsUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organization: Organization;
  organizationId: Scalars['ID']['output'];
  readyForPlayback: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
  ttsEmotion: Scalars['String']['output'];
  ttsErrorMessage?: Maybe<Scalars['String']['output']>;
  ttsModelId: Scalars['String']['output'];
  ttsSpeed: Scalars['Float']['output'];
  ttsStatus: Scalars['String']['output'];
  ttsVoiceId: Scalars['String']['output'];
  ttsVolume: Scalars['Float']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for VoiceMessage. */
export type VoiceMessageConnection = {
  __typename?: 'VoiceMessageConnection';
  /** A list of edges. */
  edges: Array<VoiceMessageEdge>;
  /** A list of nodes. */
  nodes: Array<VoiceMessage>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VoiceMessageEdge = {
  __typename?: 'VoiceMessageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VoiceMessage>;
};

/** Input for creating or updating a voice message */
export type VoiceMessageInput = {
  /** Whether this voice message is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization (required for create, defaults to current) */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** The text that will be converted to speech */
  text: Scalars['String']['input'];
  /** User-facing name for the voice message */
  title: Scalars['String']['input'];
  /** Emotional style for the generated voice */
  ttsEmotion?: InputMaybe<Scalars['String']['input']>;
  /** Cartesia model ID */
  ttsModelId?: InputMaybe<Scalars['String']['input']>;
  /** Playback speed multiplier (0.5 - 2.0) */
  ttsSpeed?: InputMaybe<Scalars['Float']['input']>;
  /** Cartesia voice ID to use for synthesis */
  ttsVoiceId?: InputMaybe<Scalars['String']['input']>;
  /** Output volume multiplier (0 - 2.0) */
  ttsVolume?: InputMaybe<Scalars['Float']['input']>;
};

/** A schedule for when a voice message should be played */
export type VoiceMessageSchedule = {
  __typename?: 'VoiceMessageSchedule';
  createdAt: Scalars['ISO8601DateTime']['output'];
  displayName: Scalars['String']['output'];
  durationMinutes: Scalars['Int']['output'];
  enabled: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['ISO8601Date']['output']>;
  endTime: Scalars['String']['output'];
  forceInterrupt: Scalars['Boolean']['output'];
  frequencyDescription: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  nextOccurrence?: Maybe<Scalars['ISO8601DateTime']['output']>;
  priority: Scalars['Int']['output'];
  rrule?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['ISO8601Date']['output']>;
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  voiceMessage: VoiceMessage;
  voiceMessageId: Scalars['ID']['output'];
};

/** Input for creating or updating a voice message schedule */
export type VoiceMessageScheduleInput = {
  /** Whether this schedule is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** End date for the schedule */
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** End time in HH:MM format */
  endTime: Scalars['String']['input'];
  /** Whether to interrupt current playback */
  forceInterrupt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Priority level (higher numbers = higher priority) */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Recurrence rule in RRULE format */
  rrule?: InputMaybe<Scalars['String']['input']>;
  /** Start date for the schedule */
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  /** Start time in HH:MM format */
  startTime: Scalars['String']['input'];
  /** The voice message to schedule */
  voiceMessageId: Scalars['ID']['input'];
};

export type VoicePlaylistRequest = Node & {
  __typename?: 'VoicePlaylistRequest';
  artistName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  playlist?: Maybe<Playlist>;
  playlistId?: Maybe<Scalars['ID']['output']>;
  requestType: Scalars['String']['output'];
  requestedMetadata: Scalars['JSON']['output'];
  resolutionPayload: Scalars['JSON']['output'];
  status: VoicePlaylistRequestStatusEnum;
  targetKind: Scalars['String']['output'];
  targetName: Scalars['String']['output'];
  updatedAt: Scalars['ISO8601DateTime']['output'];
  voiceCommandEvent: VoiceCommandEvent;
  voiceCommandEventId: Scalars['ID']['output'];
};

/** The connection type for VoicePlaylistRequest. */
export type VoicePlaylistRequestConnection = {
  __typename?: 'VoicePlaylistRequestConnection';
  /** A list of edges. */
  edges: Array<VoicePlaylistRequestEdge>;
  /** A list of nodes. */
  nodes: Array<VoicePlaylistRequest>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type VoicePlaylistRequestEdge = {
  __typename?: 'VoicePlaylistRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VoicePlaylistRequest>;
};

/** Status of a voice playlist request */
export enum VoicePlaylistRequestStatusEnum {
  /** Request has been handled */
  Completed = 'COMPLETED',
  /** Request requires manual review */
  NeedsReview = 'NEEDS_REVIEW'
}

export type Zone = Node & {
  __typename?: 'Zone';
  createdAt: Scalars['ISO8601DateTime']['output'];
  devices?: Maybe<Array<Device>>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  overrideActive: Scalars['Boolean']['output'];
  /** When the live override ends and the schedule resumes; null with no override or one with no end */
  overrideExpiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  overridePlaylistId?: Maybe<Scalars['ID']['output']>;
  /**
   * Whether any playlist schedule has an occurrence today in the zone's time zone.
   * Powers the fleet home's silent-zone detection.
   */
  scheduledToday: Scalars['Boolean']['output'];
  schedules?: Maybe<Array<PlaylistSchedule>>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
};

/** The connection type for Zone. */
export type ZoneConnection = {
  __typename?: 'ZoneConnection';
  /** A list of edges. */
  edges: Array<ZoneEdge>;
  /** A list of nodes. */
  nodes: Array<Zone>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type ZoneEdge = {
  __typename?: 'ZoneEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Zone>;
};

export type ZoneStatus = {
  __typename?: 'ZoneStatus';
  crossfade: Scalars['Int']['output'];
  currentPosition: Scalars['Float']['output'];
  currentTrack?: Maybe<Track>;
  formattedDuration: Scalars['String']['output'];
  formattedPosition: Scalars['String']['output'];
  playing: Scalars['Boolean']['output'];
  /** ID of the playlist currently loaded in the zone */
  playlistId?: Maybe<Scalars['ID']['output']>;
  trackDuration?: Maybe<Scalars['Float']['output']>;
  volume: Scalars['Int']['output'];
};

export type AdminDashboardQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AdminDashboardQuery = { __typename?: 'Query', playbackAnalytics: { __typename?: 'PlaybackAnalytics', totalListeningTimeHours: number, totalTracksPlayed: number, averageTrackCompletionPercentage?: number | null, topTracks: Array<{ __typename?: 'TopTrack', playCount: number, track?: { __typename?: 'Track', id: string, name: string, artists?: Array<{ __typename?: 'Artist', name: string }> | null } | null }> }, organizationInvoices: Array<{ __typename?: 'Invoice', id: string, amount: number, createdAt: string, status: string }>, organizationSubscriptions: { __typename?: 'BillingSubscriptionConnection', nodes: Array<{ __typename?: 'BillingSubscription', id: string, status: string, quantity: number, billingPlan?: { __typename?: 'BillingPlan', name: string, monthlyBasePriceCents?: number | null } | null, zone?: { __typename?: 'Zone', id: string, name: string } | null }> }, zones: { __typename?: 'ZoneConnection', nodes: Array<{ __typename?: 'Zone', id: string, name: string, location?: { __typename?: 'Location', id: string, name: string } | null, devices?: Array<{ __typename?: 'Device', id: string, code: string, status?: string | null }> | null, schedules?: Array<{ __typename?: 'PlaylistSchedule', id: string, startTime: string, endTime: string, rrule?: string | null, playlist?: { __typename?: 'Playlist', id: string, name: string } | null }> | null }> } };

export type ZoneStatusQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
}>;


export type ZoneStatusQuery = { __typename?: 'Query', zoneStatus: { __typename?: 'ZoneStatus', playing: boolean, formattedPosition: string, formattedDuration: string, volume: number, currentTrack?: { __typename?: 'Track', id: string, name: string, artists?: Array<{ __typename?: 'Artist', name: string }> | null } | null } };

export type CachedViewerContextFragment = { __typename?: 'User', id: string, fullName: string, firstName: string, lastName: string, email?: string | null, createdAt?: string | null, userRole: UserRole, avatarThumbUrl?: string | null, spotifyConnected: boolean, spotifyId?: string | null, currentOrganization?: { __typename?: 'Organization', id: string, name: string, slug: string, organizationType: OrganizationType, crossfadeSeconds: number, billingEmail?: string | null, explicitTracksAllowed: boolean, stripeCustomerId?: string | null } | null, recentOrganizations: Array<{ __typename?: 'Organization', id: string, name: string, slug: string, organizationType: OrganizationType }> };

export type LogoutMutationVariables = Exact<{
  input: LogoutInput;
}>;


export type LogoutMutation = { __typename?: 'Mutation', logout: { __typename?: 'LogoutPayload', success: boolean } };

export type ViewerQueryVariables = Exact<{ [key: string]: never; }>;


export type ViewerQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, fullName: string, firstName: string, lastName: string, email?: string | null, createdAt?: string | null, userRole: UserRole, avatarThumbUrl?: string | null, spotifyConnected: boolean, spotifyId?: string | null, currentOrganization?: { __typename?: 'Organization', id: string, name: string, slug: string, organizationType: OrganizationType, crossfadeSeconds: number, billingEmail?: string | null, explicitTracksAllowed: boolean, stripeCustomerId?: string | null } | null, recentOrganizations: Array<{ __typename?: 'Organization', id: string, name: string, slug: string, organizationType: OrganizationType }> } | null };

export type BillingLocationsForSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingLocationsForSelectQuery = { __typename?: 'Query', locationsForSelect: Array<{ __typename?: 'Location', id: string, name: string, zones?: Array<{ __typename?: 'Zone', id: string, name: string }> | null }> };

export type OrganizationSubscriptionsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationSubscriptionsQuery = { __typename?: 'Query', organizationSubscriptions: { __typename?: 'BillingSubscriptionConnection', edges: Array<{ __typename?: 'BillingSubscriptionEdge', node?: { __typename?: 'BillingSubscription', id: string, status: string, currentPeriodStart?: string | null, currentPeriodEnd?: string | null, cancelAtPeriodEnd: boolean, billingPlan?: { __typename?: 'BillingPlan', id: string, name: string, slug: string, monthlyBasePriceCents?: number | null, entitlements: any, restrictions: any } | null, zone?: { __typename?: 'Zone', id: string, name: string } | null } | null }> } };

export type OrganizationInvoicesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationInvoicesQuery = { __typename?: 'Query', organizationInvoices: Array<{ __typename?: 'Invoice', id: string, amount: number, status: string, createdAt: string, pdfUrl?: string | null, hostedInvoiceUrl?: string | null, number?: string | null }> };

export type CreateCustomerPortalSessionMutationVariables = Exact<{
  input: CreateCustomerPortalSessionInput;
}>;


export type CreateCustomerPortalSessionMutation = { __typename?: 'Mutation', createCustomerPortalSession: { __typename?: 'CreateCustomerPortalSessionPayload', errors?: Array<string> | null, customerPortalSession: { __typename?: 'CustomerPortalSession', url: string } } };

export type HardwareProductsQueryVariables = Exact<{ [key: string]: never; }>;


export type HardwareProductsQuery = { __typename?: 'Query', hardwareProducts: Array<{ __typename?: 'HardwareProduct', id: string, name: string, productType: string, priceCents: number, description?: string | null, stripePriceId?: string | null, active: boolean }> };

export type CreateHardwareCheckoutSessionMutationVariables = Exact<{
  input: CreateHardwareCheckoutSessionInput;
}>;


export type CreateHardwareCheckoutSessionMutation = { __typename?: 'Mutation', createHardwareCheckoutSession: { __typename?: 'CreateHardwareCheckoutSessionPayload', errors?: Array<string> | null, checkoutSession: { __typename?: 'CheckoutSession', url?: string | null, sessionId?: string | null } } };

export type OrganizationForBillingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type OrganizationForBillingQuery = { __typename?: 'Query', node?: { __typename?: 'Album' } | { __typename?: 'Artist' } | { __typename?: 'BillingPlan' } | { __typename?: 'BillingSubscription' } | { __typename?: 'BillingSubscriptionItem' } | { __typename?: 'Conversation' } | { __typename?: 'Device' } | { __typename?: 'DjEngagement' } | { __typename?: 'DjProfile' } | { __typename?: 'DjTestimonial' } | { __typename?: 'Genre' } | { __typename?: 'HardwareOrder' } | { __typename?: 'HardwareProduct' } | { __typename?: 'Location' } | { __typename?: 'Market' } | { __typename?: 'Message' } | { __typename?: 'Organization', id: string, aiGenerationUsage?: any | null, aiModelOptions?: any | null, currentPlan?: { __typename?: 'BillingPlan', id: string, slug: string, name: string, entitlements: any, restrictions: any } | null, activeSubscriptions: { __typename?: 'BillingSubscriptionConnection', edges: Array<{ __typename?: 'BillingSubscriptionEdge', node?: { __typename?: 'BillingSubscription', id: string, status: string, billingPlan?: { __typename?: 'BillingPlan', id: string, slug: string, name: string, entitlements: any, restrictions: any } | null } | null }> } } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistSchedule' } | { __typename?: 'PlaylistTrack' } | { __typename?: 'Track' } | { __typename?: 'TrackAudioFeature' } | { __typename?: 'User' } | { __typename?: 'VendorExpense' } | { __typename?: 'Video' } | { __typename?: 'VideoPlaylist' } | { __typename?: 'VideoSchedule' } | { __typename?: 'VoiceCommandEvent' } | { __typename?: 'VoicePlaylistRequest' } | { __typename?: 'Zone' } | null };

export type SpotifyAuthorizationUrlMutationVariables = Exact<{
  input: SpotifyAuthorizationUrlInput;
}>;


export type SpotifyAuthorizationUrlMutation = { __typename?: 'Mutation', spotifyAuthorizationUrl: { __typename?: 'SpotifyAuthorizationUrlPayload', authorizationUrl: string, state: string } };

export type SpotifyConnectCallbackMutationVariables = Exact<{
  input: SpotifyConnectCallbackInput;
}>;


export type SpotifyConnectCallbackMutation = { __typename?: 'Mutation', spotifyConnectCallback: { __typename?: 'SpotifyConnectCallbackPayload', success: boolean, error?: string | null, user?: { __typename?: 'User', id: string, spotifyConnected: boolean, spotifyId?: string | null } | null } };

export type FetchSpotifyPlaylistsMutationVariables = Exact<{
  input: FetchSpotifyPlaylistsInput;
}>;


export type FetchSpotifyPlaylistsMutation = { __typename?: 'Mutation', fetchSpotifyPlaylists: { __typename?: 'FetchSpotifyPlaylistsPayload', success: boolean, error?: string | null, requiresReauth: boolean, playlists: Array<{ __typename?: 'SpotifyPlaylist', spotifyId: string, name: string, description?: string | null, tracksTotal: number, public: boolean, collaborative: boolean, images: Array<{ __typename?: 'SpotifyImage', url: string, width?: number | null, height?: number | null }>, owner?: { __typename?: 'SpotifyUser', spotifyId: string, displayName?: string | null } | null }> } };

export type ImportSpotifyPlaylistMutationVariables = Exact<{
  input: ImportSpotifyPlaylistInput;
}>;


export type ImportSpotifyPlaylistMutation = { __typename?: 'Mutation', importSpotifyPlaylist: { __typename?: 'ImportSpotifyPlaylistPayload', success: boolean, error?: string | null, requiresReauth: boolean, syncHistoryId?: string | null, playlist?: { __typename?: 'Playlist', id: string, name: string, isSpotifyPlaylist: boolean, tracksCount: number } | null } };

export type SpotifyDisconnectMutationVariables = Exact<{
  input: SpotifyDisconnectInput;
}>;


export type SpotifyDisconnectMutation = { __typename?: 'Mutation', spotifyDisconnect: { __typename?: 'SpotifyDisconnectPayload', success: boolean, error?: string | null, user?: { __typename?: 'User', id: string, spotifyConnected: boolean, spotifyId?: string | null } | null } };

export type ViewerOrganizationSwitcherQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ViewerOrganizationSwitcherQuery = { __typename?: 'Query', viewer?: { __typename?: 'User', id: string, currentOrganization?: { __typename?: 'Organization', id: string, name: string, slug: string, organizationType: OrganizationType, crossfadeSeconds: number, billingEmail?: string | null, explicitTracksAllowed: boolean } | null, recentOrganizations: Array<{ __typename?: 'Organization', id: string, name: string, slug: string, organizationType: OrganizationType, crossfadeSeconds: number, billingEmail?: string | null, explicitTracksAllowed: boolean, stripeCustomerId?: string | null }>, organizations: { __typename?: 'MembershipConnection', edges: Array<{ __typename?: 'MembershipEdge', cursor: string, node?: { __typename?: 'Organization', id: string, name: string, slug: string, organizationType: OrganizationType } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } } | null };

export type SwitchOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type SwitchOrganizationMutation = { __typename?: 'Mutation', switchOrganization: { __typename?: 'SwitchOrganizationPayload', user: { __typename?: 'User', id: string, currentOrganization?: { __typename?: 'Organization', id: string, name: string, slug: string, organizationType: OrganizationType, crossfadeSeconds: number, billingEmail?: string | null, explicitTracksAllowed: boolean, stripeCustomerId?: string | null } | null, recentOrganizations: Array<{ __typename?: 'Organization', id: string, name: string, slug: string, organizationType: OrganizationType }> } } };

export type GlobalSearchQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GlobalSearchQuery = { __typename?: 'Query', zones: { __typename?: 'ZoneConnection', nodes: Array<{ __typename?: 'Zone', id: string, name: string, location?: { __typename?: 'Location', name: string } | null }> }, playlists: { __typename?: 'PlaylistConnection', nodes: Array<{ __typename?: 'Playlist', id: string, name: string, playlistType: PlaylistType }> }, tracks: { __typename?: 'TrackConnection', nodes: Array<{ __typename?: 'Track', id: string, name: string, artists?: Array<{ __typename?: 'Artist', name: string }> | null, album?: { __typename?: 'Album', name: string } | null }> }, playlistSchedules: { __typename?: 'PlaylistScheduleConnection', nodes: Array<{ __typename?: 'PlaylistSchedule', id: string, startTime: string, endTime: string, playlist?: { __typename?: 'Playlist', id: string, name: string } | null, zone?: { __typename?: 'Zone', id: string, name: string } | null }> }, voiceMessages: Array<{ __typename?: 'VoiceMessage', id: string, displayName: string, text: string }> };

export type PlaylistGenerationStatusSubscriptionVariables = Exact<{
  playlistId: Scalars['ID']['input'];
}>;


export type PlaylistGenerationStatusSubscription = { __typename?: 'Subscription', playlistGenerationStatus: { __typename?: 'PlaylistGenerationStatus', playlistId: string, status: string, progress: number, tracksGenerated: number, totalTracks: number, message?: string | null, completedAt?: string | null, error?: string | null, confidence?: number | null, businessContext?: string | null, extractedAttributes?: any | null } };

export type GenerateAiTracksForPlaylistMutationVariables = Exact<{
  input: GenerateAiTracksForPlaylistInput;
}>;


export type GenerateAiTracksForPlaylistMutation = { __typename?: 'Mutation', generateAiTracksForPlaylist: { __typename?: 'GenerateAiTracksForPlaylistPayload', errors: Array<string>, playlist?: { __typename?: 'Playlist', id: string, aiGenerationStatus?: { __typename?: 'PlaylistGenerationStatus', status: string, progress: number, tracksGenerated: number, totalTracks: number, message?: string | null, error?: string | null } | null } | null } };

export type SubmitPlaylistFeedbackMutationVariables = Exact<{
  input: SubmitPlaylistFeedbackInput;
}>;


export type SubmitPlaylistFeedbackMutation = { __typename?: 'Mutation', submitPlaylistFeedback: { __typename?: 'SubmitPlaylistFeedbackPayload', errors?: Array<string> | null, feedback: { __typename?: 'PlaylistFeedback', id: string, rating?: number | null, comment?: string | null, feedbackType: PlaylistFeedbackTypeEnum, isPositive: boolean, sentiment?: string | null } } };

export type PlaylistQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlaylistQuery = { __typename?: 'Query', playlist?: { __typename?: 'Playlist', id: string, name: string, playlistType: PlaylistType, isSpotifyPlaylist: boolean, spotifyId?: string | null, aiGenerated: boolean, aiPrompt?: string | null, createdAt: string, playlistTracks?: Array<{ __typename?: 'PlaylistTrack', id: string, position: number, track?: { __typename?: 'Track', id: string, name: string, trackNumber?: number | null, durationMs?: number | null, audioUrl?: string | null, coverUrl?: string | null, playable: boolean, isSpotifyTrack: boolean, spotifyId?: string | null, licensingPro?: LicensingProEnum | null, licensingProCheckedAt?: string | null, artists?: Array<{ __typename?: 'Artist', id: string, name: string }> | null, album?: { __typename?: 'Album', id: string, name: string } | null } | null }> | null, aiGenerationStatus?: { __typename?: 'PlaylistGenerationStatus', status: string, progress: number, tracksGenerated: number, totalTracks: number, message?: string | null, error?: string | null } | null } | null };

export type StationPreviewTracksQueryVariables = Exact<{
  playlistId: Scalars['ID']['input'];
}>;


export type StationPreviewTracksQuery = { __typename?: 'Query', stationPreviewTracks: Array<{ __typename?: 'Track', id: string, name: string, coverUrl?: string | null, artists?: Array<{ __typename?: 'Artist', id: string, name: string }> | null, album?: { __typename?: 'Album', id: string, name: string } | null }> };

export type PlaylistScreenGenerationStatusSubscriptionVariables = Exact<{
  playlistId: Scalars['ID']['input'];
}>;


export type PlaylistScreenGenerationStatusSubscription = { __typename?: 'Subscription', playlistGenerationStatus: { __typename?: 'PlaylistGenerationStatus', playlistId: string, status: string, progress: number, tracksGenerated: number, totalTracks: number, message?: string | null, completedAt?: string | null, error?: string | null, confidence?: number | null, businessContext?: string | null, extractedAttributes?: any | null } };

export type SearchTracksQueryVariables = Exact<{
  query: Scalars['String']['input'];
  licensingPro?: InputMaybe<LicensingProEnum>;
}>;


export type SearchTracksQuery = { __typename?: 'Query', tracks: { __typename?: 'TrackConnection', edges: Array<{ __typename?: 'TrackEdge', node?: { __typename?: 'Track', id: string, name: string, durationMs?: number | null, audioUrl?: string | null, coverUrl?: string | null, playable: boolean, isSpotifyTrack: boolean, spotifyId?: string | null, licensingPro?: LicensingProEnum | null, licensingProCheckedAt?: string | null, artists?: Array<{ __typename?: 'Artist', id: string, name: string }> | null, album?: { __typename?: 'Album', id: string, name: string } | null } | null }> } };

export type AddTrackToPlaylistMutationVariables = Exact<{
  input: AddTrackToPlaylistInput;
}>;


export type AddTrackToPlaylistMutation = { __typename?: 'Mutation', addTrackToPlaylist: { __typename?: 'AddTrackToPlaylistPayload', playlistTrack?: { __typename?: 'PlaylistTrack', id: string, position: number, track?: { __typename?: 'Track', id: string, name: string, trackNumber?: number | null, durationMs?: number | null, audioUrl?: string | null, playable: boolean, isSpotifyTrack: boolean, spotifyId?: string | null, artists?: Array<{ __typename?: 'Artist', id: string, name: string }> | null, album?: { __typename?: 'Album', id: string, name: string } | null } | null } | null } };

export type RemoveTrackFromPlaylistMutationVariables = Exact<{
  input: RemoveTrackFromPlaylistInput;
}>;


export type RemoveTrackFromPlaylistMutation = { __typename?: 'Mutation', removeTrackFromPlaylist: { __typename?: 'RemoveTrackFromPlaylistPayload', success: boolean } };

export type UpdateTrackPositionMutationVariables = Exact<{
  input: UpdateTrackPositionInput;
}>;


export type UpdateTrackPositionMutation = { __typename?: 'Mutation', updateTrackPosition: { __typename?: 'UpdateTrackPositionPayload', success: boolean } };

export type SyncSpotifyPlaylistMutationVariables = Exact<{
  input: SyncSpotifyPlaylistInput;
}>;


export type SyncSpotifyPlaylistMutation = { __typename?: 'Mutation', syncSpotifyPlaylist: { __typename?: 'SyncSpotifyPlaylistPayload', success: boolean, error?: string | null, requiresReauth: boolean, tracksAdded?: number | null, tracksUpdated?: number | null, syncHistoryId?: string | null, playlist?: { __typename?: 'Playlist', id: string, name: string } | null } };

export type ActiveSyncHistoriesQueryVariables = Exact<{
  playlistId: Scalars['ID']['input'];
}>;


export type ActiveSyncHistoriesQuery = { __typename?: 'Query', activeSyncHistories: Array<{ __typename?: 'SpotifySyncHistory', id: string, syncType?: string | null, status: string, message?: string | null, startedAt?: string | null, resourceId?: string | null, spotifyResourceId?: string | null, isActive: boolean, metadata?: any | null }> };

export type PlaylistsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PlaylistsQuery = { __typename?: 'Query', playlists: { __typename?: 'PlaylistConnection', edges: Array<{ __typename?: 'PlaylistEdge', node?: { __typename?: 'Playlist', id: string, name: string, playlistType: PlaylistType, tracksCount: number, createdAt: string } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type CreatePlaylistMutationVariables = Exact<{
  input: CreatePlaylistInput;
}>;


export type CreatePlaylistMutation = { __typename?: 'Mutation', createPlaylist: { __typename?: 'CreatePlaylistPayload', playlist: { __typename?: 'Playlist', id: string, name: string, playlistType: PlaylistType, tracksCount: number, createdAt: string, aiGenerated: boolean, aiPrompt?: string | null } } };

export type CreateStationMutationVariables = Exact<{
  input: CreateStationInput;
}>;


export type CreateStationMutation = { __typename?: 'Mutation', createStation: { __typename?: 'CreateStationPayload', errors?: Array<string> | null, playlist: { __typename?: 'Playlist', id: string, name: string, playlistType: PlaylistType, tracksCount: number, createdAt: string, aiGenerated: boolean, aiPrompt?: string | null } } };

export type ImportSpotifyPlaylistOnPlaylistsScreenMutationVariables = Exact<{
  input: ImportSpotifyPlaylistInput;
}>;


export type ImportSpotifyPlaylistOnPlaylistsScreenMutation = { __typename?: 'Mutation', importSpotifyPlaylist: { __typename?: 'ImportSpotifyPlaylistPayload', success: boolean, error?: string | null, requiresReauth: boolean, playlist?: { __typename?: 'Playlist', id: string, name: string, isSpotifyPlaylist: boolean, tracksCount: number } | null } };

export type UserUpdateMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'UserUpdatePayload', user: { __typename?: 'User', id: string, avatarThumbUrl?: string | null } } };

export type UpdateProfileMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UpdateProfileMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'UserUpdatePayload', user: { __typename?: 'User', id: string, firstName: string, lastName: string } } };

export type LocationAnalyticsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<LocationGrouping>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LocationAnalyticsQuery = { __typename?: 'Query', locationAnalytics: Array<{ __typename?: 'LocationAnalytics', country?: string | null, city?: string | null, region?: string | null, locationDisplayName?: string | null, latitude?: number | null, longitude?: number | null, timezone?: string | null, totalEvents: number, uniqueTracks: number, uniqueDevices: number, listeningTimeSeconds: number, listeningTimeHours: number, topTracks: Array<{ __typename?: 'TopTrack', trackId?: string | null, trackTitle: string, trackArtist: string, playCount: number }> }> };

export type PlaybackAnalyticsWithLocationQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PlaybackAnalyticsWithLocationQuery = { __typename?: 'Query', playbackAnalytics: { __typename?: 'PlaybackAnalytics', deviceLocations: Array<{ __typename?: 'DeviceLocationAnalytics', deviceId: string, deviceName?: string | null, latitude?: number | null, longitude?: number | null, city?: string | null, country?: string | null, timezone?: string | null, locationDisplayName: string, lastLocationUpdate?: string | null, totalEvents: number, listeningTimeHours: number, uniqueTracksPlayed: number, status?: string | null }> } };

export type PlaybackAnalyticsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601Date']['input']>;
  days?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PlaybackAnalyticsQuery = { __typename?: 'Query', playbackAnalytics: { __typename?: 'PlaybackAnalytics', totalListeningTimeSeconds: number, totalListeningTimeHours: number, totalTracksPlayed: number, uniqueTracksPlayed: number, averageTrackCompletionPercentage?: number | null, mostActiveHours: Array<number>, dailyListeningHours: Array<{ __typename?: 'DailyListening', date: string, hours: number, tracksPlayed: number }>, topTracks: Array<{ __typename?: 'TopTrack', trackId?: string | null, trackTitle: string, trackArtist: string, playCount: number, totalListeningTimeSeconds: number, averageCompletionPercentage?: number | null, track?: { __typename?: 'Track', id: string, name: string, displayArtist?: string | null } | null }>, dateRange: { __typename?: 'DateRange', startDate: string, endDate: string, days: number } } };

export type PlaybackEventsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
  deviceId?: InputMaybe<Scalars['ID']['input']>;
  trackId?: InputMaybe<Scalars['ID']['input']>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PlaybackEventsQuery = { __typename?: 'Query', playbackEvents: Array<{ __typename?: 'PlaybackEvent', id: string, eventType: string, organizationId: string, zoneId: string, deviceId: string, trackId?: string | null, positionMs?: number | null, durationMs?: number | null, volume?: number | null, createdAt: string, updatedAt: string, trackTitle?: string | null, trackArtist?: string | null, playbackPercentage?: number | null, formattedPosition?: string | null, formattedDuration?: string | null, isTrackStarted: boolean, isTrackEnded: boolean, isPlaybackState: boolean, isProgressEvent: boolean, zone: { __typename?: 'Zone', id: string, name: string }, track?: { __typename?: 'Track', id: string, name: string, displayArtist?: string | null } | null }> };

export type RoyaltyReportQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  zoneId?: InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  startDate: Scalars['ISO8601Date']['input'];
  endDate: Scalars['ISO8601Date']['input'];
  includePartial?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type RoyaltyReportQuery = { __typename?: 'Query', royaltyReporting: { __typename?: 'RoyaltyReport', startAt: string, endAt: string, includePartial: boolean, overallTotals: { __typename?: 'RoyaltyReportTotals', totalPlays: number, qualifiedPlays: number, partialPlays: number, totalDurationMs: number, qualifiedDurationMs: number }, proTotals: Array<{ __typename?: 'RoyaltyReportProTotal', licensingPro?: string | null, totalPlays: number, qualifiedPlays: number, partialPlays: number, totalDurationMs: number, qualifiedDurationMs: number, zonesReporting: number, locationsReporting: number }>, rows: Array<{ __typename?: 'RoyaltyReportRow', organizationId: string, locationId: string, locationName?: string | null, zoneId: string, zoneName?: string | null, licensingPro?: string | null, totalPlays: number, qualifiedPlays: number, partialPlays: number, totalDurationMs: number, qualifiedDurationMs: number }> } };

export type ZonesForReportingQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ZonesForReportingQuery = { __typename?: 'Query', zones: { __typename?: 'ZoneConnection', edges: Array<{ __typename?: 'ZoneEdge', node?: { __typename?: 'Zone', id: string, name: string, location?: { __typename?: 'Location', id: string, name: string } | null, devices?: Array<{ __typename?: 'Device', id: string, code: string, status?: string | null }> | null } | null }> } };

export type PlaylistScheduleQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PlaylistScheduleQuery = { __typename?: 'Query', playlistSchedule?: { __typename?: 'PlaylistSchedule', startDate?: string | null, endDate?: string | null, startTime: string, endTime: string, rrule?: string | null, zone?: { __typename?: 'Zone', id: string, name: string, location?: { __typename?: 'Location', id: string, name: string, address?: string | null, timeZone?: string | null } | null } | null, playlist?: { __typename?: 'Playlist', id: string, name: string } | null } | null };

export type UpsertPlaylistScheduleMutationVariables = Exact<{
  input: UpsertPlaylistScheduleInput;
}>;


export type UpsertPlaylistScheduleMutation = { __typename?: 'Mutation', upsertPlaylistSchedule: { __typename?: 'UpsertPlaylistSchedulePayload', schedule?: { __typename?: 'PlaylistSchedule', id: string, startDate?: string | null, endDate?: string | null, startTime: string, endTime: string, rrule?: string | null, zone?: { __typename?: 'Zone', id: string, name: string, location?: { __typename?: 'Location', id: string, name: string, address?: string | null, timeZone?: string | null } | null } | null, playlist?: { __typename?: 'Playlist', id: string, name: string } | null } | null } };

export type LocationsForSelectQueryVariables = Exact<{ [key: string]: never; }>;


export type LocationsForSelectQuery = { __typename?: 'Query', locationsForSelect: Array<{ __typename?: 'Location', id: string, name: string, address?: string | null, timeZone?: string | null, zones?: Array<{ __typename?: 'Zone', id: string, name: string }> | null }> };

export type AllPlaylistsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllPlaylistsQuery = { __typename?: 'Query', allPlaylists: Array<{ __typename?: 'Playlist', id: string, name: string, tracksCount: number }> };

export type PlaylistSchedulesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PlaylistSchedulesQuery = { __typename?: 'Query', playlistSchedules: { __typename?: 'PlaylistScheduleConnection', edges: Array<{ __typename?: 'PlaylistScheduleEdge', node?: { __typename?: 'PlaylistSchedule', id: string, startDate?: string | null, endDate?: string | null, startTime: string, endTime: string, rrule?: string | null, zone?: { __typename?: 'Zone', id: string, name: string, location?: { __typename?: 'Location', id: string, name: string, address?: string | null, timeZone?: string | null } | null } | null, playlist?: { __typename?: 'Playlist', id: string, name: string } | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: OrganizationUpdateInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', organizationUpdate: { __typename?: 'OrganizationUpdatePayload', organization: { __typename?: 'Organization', id: string, name: string, crossfadeSeconds: number, billingEmail?: string | null, explicitTracksAllowed: boolean } } };

export type CreateTrackMutationVariables = Exact<{
  input: CreateTrackInput;
}>;


export type CreateTrackMutation = { __typename?: 'Mutation', createTrack: { __typename?: 'Track', id: string, name: string, licensingPro?: LicensingProEnum | null, licensingProCheckedAt?: string | null } };

export type UpdateTrackMutationVariables = Exact<{
  input: UpdateTrackInput;
}>;


export type UpdateTrackMutation = { __typename?: 'Mutation', updateTrack: { __typename?: 'Track', id: string, name: string, licensingPro?: LicensingProEnum | null, licensingProCheckedAt?: string | null } };

export type RecheckTrackLicensingProMutationVariables = Exact<{
  input: RecheckTrackLicensingProInput;
}>;


export type RecheckTrackLicensingProMutation = { __typename?: 'Mutation', recheckTrackLicensingPro: { __typename?: 'Track', id: string, name: string, licensingPro?: LicensingProEnum | null, licensingProCheckedAt?: string | null } };

export type ArtistsForTrackModalQueryVariables = Exact<{ [key: string]: never; }>;


export type ArtistsForTrackModalQuery = { __typename?: 'Query', artists: { __typename?: 'ArtistConnection', edges: Array<{ __typename?: 'ArtistEdge', node?: { __typename?: 'Artist', id: string, name: string } | null }> } };

export type AlbumsForTrackModalQueryVariables = Exact<{ [key: string]: never; }>;


export type AlbumsForTrackModalQuery = { __typename?: 'Query', albums: { __typename?: 'AlbumConnection', edges: Array<{ __typename?: 'AlbumEdge', node?: { __typename?: 'Album', id: string, name: string, releaseDate?: string | null } | null }> } };

export type TracksQueryQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  artistId?: InputMaybe<Scalars['ID']['input']>;
  albumId?: InputMaybe<Scalars['ID']['input']>;
  genreId?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
  hasAudioUrl?: InputMaybe<Scalars['Boolean']['input']>;
  licensingPro?: InputMaybe<LicensingProEnum>;
  sortBy?: InputMaybe<TrackSortByEnum>;
}>;


export type TracksQueryQuery = { __typename?: 'Query', tracks: { __typename?: 'TrackConnection', edges: Array<{ __typename?: 'TrackEdge', node?: { __typename?: 'Track', id: string, name: string, durationMs?: number | null, popularity?: number | null, explicit: boolean, trackNumber?: number | null, discNumber?: number | null, displayArtist?: string | null, licensingPro?: LicensingProEnum | null, licensingProCheckedAt?: string | null, playable: boolean, createdAt: string, coverThumbUrl?: string | null, audioUrl?: string | null, isSpotifyTrack: boolean, album?: { __typename?: 'Album', id: string, name: string, releaseDate?: string | null } | null, artists?: Array<{ __typename?: 'Artist', id: string, name: string }> | null } | null }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } };

export type ArtistsForFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type ArtistsForFilterQuery = { __typename?: 'Query', artists: { __typename?: 'ArtistConnection', edges: Array<{ __typename?: 'ArtistEdge', node?: { __typename?: 'Artist', id: string, name: string } | null }> } };

export type AlbumsForFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type AlbumsForFilterQuery = { __typename?: 'Query', albums: { __typename?: 'AlbumConnection', edges: Array<{ __typename?: 'AlbumEdge', node?: { __typename?: 'Album', id: string, name: string, releaseDate?: string | null } | null }> } };

export type GenresForFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type GenresForFilterQuery = { __typename?: 'Query', genres: { __typename?: 'GenreConnection', edges: Array<{ __typename?: 'GenreEdge', node?: { __typename?: 'Genre', id: string, name: string } | null }> } };

export type UserAvatarFragment = { __typename?: 'User', id: string, firstName: string, lastName: string, avatarThumbUrl?: string | null };

export type UserDetailsQueryVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserDetailsQuery = { __typename?: 'Query', node?: { __typename?: 'Album' } | { __typename?: 'Artist' } | { __typename?: 'BillingPlan' } | { __typename?: 'BillingSubscription' } | { __typename?: 'BillingSubscriptionItem' } | { __typename?: 'Conversation' } | { __typename?: 'Device' } | { __typename?: 'DjEngagement' } | { __typename?: 'DjProfile' } | { __typename?: 'DjTestimonial' } | { __typename?: 'Genre' } | { __typename?: 'HardwareOrder' } | { __typename?: 'HardwareProduct' } | { __typename?: 'Location' } | { __typename?: 'Market' } | { __typename?: 'Message' } | { __typename?: 'Organization' } | { __typename?: 'Playlist' } | { __typename?: 'PlaylistSchedule' } | { __typename?: 'PlaylistTrack' } | { __typename?: 'Track' } | { __typename?: 'TrackAudioFeature' } | { __typename?: 'User', firstName: string, lastName: string, userRole: UserRole, fullName: string, email?: string | null } | { __typename?: 'VendorExpense' } | { __typename?: 'Video' } | { __typename?: 'VideoPlaylist' } | { __typename?: 'VideoSchedule' } | { __typename?: 'VoiceCommandEvent' } | { __typename?: 'VoicePlaylistRequest' } | { __typename?: 'Zone' } | null };

export type UsersAdminQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type UsersAdminQuery = { __typename?: 'Query', users: { __typename?: 'UserConnection', edges: Array<{ __typename?: 'UserEdge', node?: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email?: string | null, userRole: UserRole, userStatus: UserStatus, timeZone: string, createdAt?: string | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'CreateUserPayload', errors?: Array<string> | null, user: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email?: string | null, userRole: UserRole, userStatus: UserStatus, timeZone: string, createdAt?: string | null } } };

export type UserUpdateAdminMutationVariables = Exact<{
  input: UserUpdateInput;
}>;


export type UserUpdateAdminMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'UserUpdatePayload', user: { __typename?: 'User', id: string, firstName: string, lastName: string, fullName: string, email?: string | null, userRole: UserRole, userStatus: UserStatus, timeZone: string, createdAt?: string | null } } };

export type DeleteUserMutationVariables = Exact<{
  input: DeleteUserInput;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'DeleteUserPayload', success: boolean, errors?: Array<string> | null } };

export type VoiceMessageQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VoiceMessageQuery = { __typename?: 'Query', voiceMessage?: { __typename?: 'VoiceMessage', id: string, title: string, text: string, ttsStatus: string, ttsErrorMessage?: string | null, audioUrl?: string | null, durationSeconds?: number | null, enabled: boolean, ttsModelId: string, ttsVoiceId: string, ttsSpeed: number, ttsVolume: number, ttsEmotion: string, createdAt: string, updatedAt: string, durationFormatted?: string | null, displayName: string, readyForPlayback: boolean } | null };

export type UpdateVoiceMessageMutationVariables = Exact<{
  input: UpdateVoiceMessageInput;
}>;


export type UpdateVoiceMessageMutation = { __typename?: 'Mutation', updateVoiceMessage: { __typename?: 'UpdateVoiceMessagePayload', errors: Array<string>, voiceMessage?: { __typename?: 'VoiceMessage', id: string, text: string, ttsStatus: string, enabled: boolean, ttsModelId: string, ttsVoiceId: string, ttsSpeed: number, ttsVolume: number, ttsEmotion: string } | null } };

export type RegenerateTtsMutationVariables = Exact<{
  input: RegenerateVoiceMessageTtsInput;
}>;


export type RegenerateTtsMutation = { __typename?: 'Mutation', regenerateVoiceMessageTts: { __typename?: 'RegenerateVoiceMessageTtsPayload', errors: Array<string>, voiceMessage?: { __typename?: 'VoiceMessage', id: string, ttsStatus: string } | null } };

export type CartesiaVoiceOptionsForEditQueryVariables = Exact<{ [key: string]: never; }>;


export type CartesiaVoiceOptionsForEditQuery = { __typename?: 'Query', cartesiaVoiceOptions: { __typename?: 'CartesiaVoiceOptions', defaultVoiceId: string, defaultModelId: string, defaultSpeed: number, defaultVolume: number, speedMin: number, speedMax: number, volumeMin: number, volumeMax: number, emotions: Array<string>, recommendedVoiceIds: Array<string>, voices: Array<{ __typename?: 'CartesiaVoice', id: string, voiceId: string, name: string, language?: string | null, description?: string | null, emotive: boolean, recommended: boolean, tags?: string | null }> } };

export type PreviewCartesiaVoiceMutationVariables = Exact<{
  input: PreviewCartesiaVoiceInput;
}>;


export type PreviewCartesiaVoiceMutation = { __typename?: 'Mutation', previewCartesiaVoice: { __typename?: 'PreviewCartesiaVoicePayload', audioBase64?: string | null, contentType?: string | null, errors: Array<string> } };

export type CreateVoiceMessageMutationVariables = Exact<{
  input: CreateVoiceMessageInput;
}>;


export type CreateVoiceMessageMutation = { __typename?: 'Mutation', createVoiceMessage: { __typename?: 'CreateVoiceMessagePayload', errors: Array<string>, voiceMessage?: { __typename?: 'VoiceMessage', id: string, text: string, ttsStatus: string, enabled: boolean, ttsModelId: string, ttsVoiceId: string, ttsSpeed: number, ttsVolume: number, ttsEmotion: string } | null } };

export type CartesiaVoiceOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type CartesiaVoiceOptionsQuery = { __typename?: 'Query', cartesiaVoiceOptions: { __typename?: 'CartesiaVoiceOptions', defaultVoiceId: string, defaultModelId: string, defaultSpeed: number, defaultVolume: number, speedMin: number, speedMax: number, volumeMin: number, volumeMax: number, emotions: Array<string>, recommendedVoiceIds: Array<string>, voices: Array<{ __typename?: 'CartesiaVoice', id: string, voiceId: string, name: string, language?: string | null, description?: string | null, emotive: boolean, recommended: boolean, tags?: string | null }> } };

export type VoiceMessageWithSchedulesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VoiceMessageWithSchedulesQuery = { __typename?: 'Query', voiceMessage?: { __typename?: 'VoiceMessage', id: string, text: string, displayName: string, enabled: boolean, ttsStatus: string, audioUrl?: string | null, durationSeconds?: number | null, campaigns: Array<{ __typename?: 'Campaign', id: string, name: string, nextOccurrence?: string | null, enabled: boolean }> } | null };

export type VoiceMessageSchedulesQueryVariables = Exact<{
  voiceMessageId: Scalars['ID']['input'];
  enabledOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VoiceMessageSchedulesQuery = { __typename?: 'Query', voiceMessageSchedules: Array<{ __typename?: 'VoiceMessageSchedule', id: string, startDate?: string | null, endDate?: string | null, startTime: string, endTime: string, rrule?: string | null, forceInterrupt: boolean, priority: number, enabled: boolean, displayName: string, frequencyDescription: string, durationMinutes: number, nextOccurrence?: string | null, createdAt: string, updatedAt: string }> };

export type CreateVoiceMessageScheduleMutationVariables = Exact<{
  input: CreateVoiceMessageScheduleInput;
}>;


export type CreateVoiceMessageScheduleMutation = { __typename?: 'Mutation', createVoiceMessageSchedule: { __typename?: 'CreateVoiceMessageSchedulePayload', errors: Array<string>, voiceMessageSchedule?: { __typename?: 'VoiceMessageSchedule', id: string, startDate?: string | null, endDate?: string | null, startTime: string, endTime: string, rrule?: string | null, forceInterrupt: boolean, priority: number, enabled: boolean, displayName: string, frequencyDescription: string, durationMinutes: number, nextOccurrence?: string | null } | null } };

export type UpdateVoiceMessageScheduleMutationVariables = Exact<{
  input: UpdateVoiceMessageScheduleInput;
}>;


export type UpdateVoiceMessageScheduleMutation = { __typename?: 'Mutation', updateVoiceMessageSchedule: { __typename?: 'UpdateVoiceMessageSchedulePayload', errors: Array<string>, voiceMessageSchedule?: { __typename?: 'VoiceMessageSchedule', id: string, startDate?: string | null, endDate?: string | null, startTime: string, endTime: string, rrule?: string | null, forceInterrupt: boolean, priority: number, enabled: boolean, displayName: string, frequencyDescription: string, durationMinutes: number, nextOccurrence?: string | null } | null } };

export type DeleteVoiceMessageScheduleMutationVariables = Exact<{
  input: DeleteVoiceMessageScheduleInput;
}>;


export type DeleteVoiceMessageScheduleMutation = { __typename?: 'Mutation', deleteVoiceMessageSchedule: { __typename?: 'DeleteVoiceMessageSchedulePayload', success: boolean, errors: Array<string> } };

export type VoiceMessagesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type VoiceMessagesQuery = { __typename?: 'Query', voiceMessages: Array<{ __typename?: 'VoiceMessage', id: string, text: string, title: string, ttsStatus: string, ttsErrorMessage?: string | null, audioUrl?: string | null, durationSeconds?: number | null, enabled: boolean, createdAt: string, updatedAt: string, durationFormatted?: string | null, displayName: string, readyForPlayback: boolean, hasActiveSchedules: boolean, campaigns: Array<{ __typename?: 'Campaign', id: string, name: string, nextOccurrence?: string | null, enabled: boolean }> }> };

export type DeleteVoiceMessageMutationVariables = Exact<{
  input: DeleteVoiceMessageInput;
}>;


export type DeleteVoiceMessageMutation = { __typename?: 'Mutation', deleteVoiceMessage: { __typename?: 'DeleteVoiceMessagePayload', success: boolean, errors: Array<string> } };

export type VoicePlaylistRequestsQueryVariables = Exact<{
  status?: InputMaybe<VoicePlaylistRequestStatusEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type VoicePlaylistRequestsQuery = { __typename?: 'Query', voicePlaylistRequests: { __typename?: 'VoicePlaylistRequestConnection', edges: Array<{ __typename?: 'VoicePlaylistRequestEdge', node?: { __typename?: 'VoicePlaylistRequest', id: string, requestType: string, targetKind: string, targetName: string, artistName?: string | null, status: VoicePlaylistRequestStatusEnum, errorMessage?: string | null, requestedMetadata: any, resolutionPayload: any, createdAt: string, playlist?: { __typename?: 'Playlist', id: string, name: string } | null, voiceCommandEvent: { __typename?: 'VoiceCommandEvent', id: string, rawText: string, normalizedText: string, intent: string, action: string, success: boolean, locale?: string | null, confidence?: number | null, createdAt: string, user: { __typename?: 'User', id: string, fullName: string, email?: string | null }, location?: { __typename?: 'Location', id: string, name: string } | null, zone?: { __typename?: 'Zone', id: string, name: string } | null } } | null }> } };

export type VoicePlaylistRequestPlaylistsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type VoicePlaylistRequestPlaylistsQuery = { __typename?: 'Query', playlists: { __typename?: 'PlaylistConnection', edges: Array<{ __typename?: 'PlaylistEdge', node?: { __typename?: 'Playlist', id: string, name: string } | null }> } };

export type VoicePlaylistRequestTracksQueryVariables = Exact<{
  query?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type VoicePlaylistRequestTracksQuery = { __typename?: 'Query', tracks: { __typename?: 'TrackConnection', edges: Array<{ __typename?: 'TrackEdge', node?: { __typename?: 'Track', id: string, name: string, displayArtist?: string | null, playable: boolean, album?: { __typename?: 'Album', id: string, name: string } | null } | null }> } };

export type ResolveVoicePlaylistRequestMutationVariables = Exact<{
  input: ResolveVoicePlaylistRequestInput;
}>;


export type ResolveVoicePlaylistRequestMutation = { __typename?: 'Mutation', resolveVoicePlaylistRequest: { __typename?: 'ResolveVoicePlaylistRequestPayload', errors: Array<string>, voicePlaylistRequest?: { __typename?: 'VoicePlaylistRequest', id: string, status: VoicePlaylistRequestStatusEnum, resolutionPayload: any, playlist?: { __typename?: 'Playlist', id: string, name: string } | null } | null } };

export type VoicePlaylistRequestAddTrackMutationVariables = Exact<{
  input: AddTrackToPlaylistInput;
}>;


export type VoicePlaylistRequestAddTrackMutation = { __typename?: 'Mutation', addTrackToPlaylist: { __typename?: 'AddTrackToPlaylistPayload', errors: Array<string>, playlistTrack?: { __typename?: 'PlaylistTrack', id: string } | null } };

export type JukeboxAnalyticsQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
  startDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  endDate?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
}>;


export type JukeboxAnalyticsQuery = { __typename?: 'Query', jukeboxAnalytics: any };

export type JukeboxQueueQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
}>;


export type JukeboxQueueQuery = { __typename?: 'Query', jukeboxQueue: any };

export type JukeboxRemoveItemMutationVariables = Exact<{
  input: JukeboxRemoveItemInput;
}>;


export type JukeboxRemoveItemMutation = { __typename?: 'Mutation', jukeboxRemoveItem: { __typename?: 'JukeboxRemoveItemPayload', success: boolean, errors: Array<string> } };

export type JukeboxSkipCurrentMutationVariables = Exact<{
  input: JukeboxSkipCurrentInput;
}>;


export type JukeboxSkipCurrentMutation = { __typename?: 'Mutation', jukeboxSkipCurrent: { __typename?: 'JukeboxSkipCurrentPayload', success: boolean, errors: Array<string> } };

export type JukeboxPauseQueueMutationVariables = Exact<{
  input: JukeboxPauseQueueInput;
}>;


export type JukeboxPauseQueueMutation = { __typename?: 'Mutation', jukeboxPauseQueue: { __typename?: 'JukeboxPauseQueuePayload', success: boolean, paused: boolean, errors: Array<string> } };

export type JukeboxEmergencyLockMutationVariables = Exact<{
  input: JukeboxEmergencyLockInput;
}>;


export type JukeboxEmergencyLockMutation = { __typename?: 'Mutation', jukeboxEmergencyLock: { __typename?: 'JukeboxEmergencyLockPayload', success: boolean, refundedCount?: number | null, errors: Array<string> } };

export type JukeboxEffectiveConfigurationQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
}>;


export type JukeboxEffectiveConfigurationQuery = { __typename?: 'Query', jukeboxEffectiveConfiguration: any };

export type UpdateJukeboxZoneConfigurationMutationVariables = Exact<{
  input: UpdateJukeboxZoneConfigurationInput;
}>;


export type UpdateJukeboxZoneConfigurationMutation = { __typename?: 'Mutation', updateJukeboxZoneConfiguration: { __typename?: 'UpdateJukeboxZoneConfigurationPayload', errors: Array<string>, jukeboxConfiguration?: { __typename?: 'JukeboxConfiguration', id: string, enabled?: boolean | null, mode?: string | null } | null } };

export type JukeboxQrCodeQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
}>;


export type JukeboxQrCodeQuery = { __typename?: 'Query', jukeboxQrCode: any };

export type ZoneBillingContextQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
}>;


export type ZoneBillingContextQuery = { __typename?: 'Query', zone?: { __typename?: 'Zone', id: string, name: string, location?: { __typename?: 'Location', id: string, name: string } | null } | null, billingPlans: { __typename?: 'BillingPlanConnection', edges: Array<{ __typename?: 'BillingPlanEdge', node?: { __typename?: 'BillingPlan', id: string, name: string, slug: string, monthlyBasePriceCents?: number | null, entitlements: any, restrictions: any, active: boolean } | null }> }, organizationSubscriptions: { __typename?: 'BillingSubscriptionConnection', edges: Array<{ __typename?: 'BillingSubscriptionEdge', node?: { __typename?: 'BillingSubscription', id: string, status: string, currentPeriodStart?: string | null, currentPeriodEnd?: string | null, cancelAtPeriodEnd: boolean, billingPlan?: { __typename?: 'BillingPlan', id: string, name: string, slug: string, monthlyBasePriceCents?: number | null } | null, zone?: { __typename?: 'Zone', id: string, name: string } | null, billingSubscriptionItems: Array<{ __typename?: 'BillingSubscriptionItem', id: string, quantity: number, zone?: { __typename?: 'Zone', id: string, name: string } | null, billingPlan: { __typename?: 'BillingPlan', id: string, name: string, slug: string, monthlyBasePriceCents?: number | null } }> } | null }> } };

export type CreateCheckoutSessionForZoneMutationVariables = Exact<{
  input: CreateCheckoutSessionInput;
}>;


export type CreateCheckoutSessionForZoneMutation = { __typename?: 'Mutation', createCheckoutSession: { __typename?: 'CreateCheckoutSessionPayload', errors: Array<string>, checkoutSession?: { __typename?: 'CheckoutSession', url?: string | null, sessionId?: string | null } | null } };

export type SyncStripeCheckoutSessionMutationVariables = Exact<{
  input: SyncStripeCheckoutSessionInput;
}>;


export type SyncStripeCheckoutSessionMutation = { __typename?: 'Mutation', syncStripeCheckoutSession: { __typename?: 'SyncStripeCheckoutSessionPayload', success: boolean, errors: Array<string>, subscription?: { __typename?: 'BillingSubscription', id: string, status: string, currentPeriodEnd?: string | null, billingPlan?: { __typename?: 'BillingPlan', id: string, name: string, monthlyBasePriceCents?: number | null } | null, zone?: { __typename?: 'Zone', id: string } | null } | null } };

export type SendZoneCommandMutationVariables = Exact<{
  input: SendZoneCommandInput;
}>;


export type SendZoneCommandMutation = { __typename?: 'Mutation', sendZoneCommand: { __typename?: 'SendZoneCommandPayload', status: string } };

export type GetZoneQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
}>;


export type GetZoneQuery = { __typename?: 'Query', zone?: { __typename?: 'Zone', id: string, name: string, location?: { __typename?: 'Location', id: string, name: string, address?: string | null, timeZone?: string | null } | null } | null };

export type GetZoneStatusQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
}>;


export type GetZoneStatusQuery = { __typename?: 'Query', zoneStatus: { __typename?: 'ZoneStatus', playing: boolean, currentPosition: number, trackDuration?: number | null, formattedPosition: string, formattedDuration: string, volume: number, crossfade: number, currentTrack?: { __typename?: 'Track', id: string, name: string, artists?: Array<{ __typename?: 'Artist', name: string }> | null } | null } };

export type GetZonePlaylistQueryVariables = Exact<{
  zoneId: Scalars['ID']['input'];
}>;


export type GetZonePlaylistQuery = { __typename?: 'Query', playlistSchedules: { __typename?: 'PlaylistScheduleConnection', edges: Array<{ __typename?: 'PlaylistScheduleEdge', node?: { __typename?: 'PlaylistSchedule', id: string, playlist?: { __typename?: 'Playlist', id: string, name: string, playlistType: PlaylistType, playlistTracks?: Array<{ __typename?: 'PlaylistTrack', id: string, position: number, track?: { __typename?: 'Track', id: string, name: string, artists?: Array<{ __typename?: 'Artist', name: string }> | null } | null }> | null } | null } | null }> } };

export type UpdateZoneMutationVariables = Exact<{
  input: UpdateZoneInput;
}>;


export type UpdateZoneMutation = { __typename?: 'Mutation', updateZone: { __typename?: 'UpdateZonePayload', errors?: Array<string> | null, zone: { __typename?: 'Zone', id: string, name: string } } };

export type LocationsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type LocationsQuery = { __typename?: 'Query', locations: { __typename?: 'LocationConnection', edges: Array<{ __typename?: 'LocationEdge', node?: { __typename?: 'Location', id: string, name: string, address?: string | null, timeZone?: string | null, zones?: Array<{ __typename?: 'Zone', id: string, name: string }> | null } | null }>, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean } } };

export type CreateLocationMutationVariables = Exact<{
  input: CreateLocationInput;
}>;


export type CreateLocationMutation = { __typename?: 'Mutation', createLocation: { __typename?: 'CreateLocationPayload', location: { __typename?: 'Location', id: string, name: string, address?: string | null, timeZone?: string | null, zones?: Array<{ __typename?: 'Zone', id: string, name: string }> | null } } };

export type CreateZoneMutationVariables = Exact<{
  input: CreateZoneInput;
}>;


export type CreateZoneMutation = { __typename?: 'Mutation', createZone: { __typename?: 'CreateZonePayload', zone?: { __typename?: 'Zone', id: string, name: string } | null } };

export type UpdateLocationMutationVariables = Exact<{
  input: UpdateLocationInput;
}>;


export type UpdateLocationMutation = { __typename?: 'Mutation', updateLocation: { __typename?: 'UpdateLocationPayload', errors?: Array<string> | null, location: { __typename?: 'Location', id: string, name: string, address?: string | null, timeZone?: string | null } } };

export const CachedViewerContextFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedViewerContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyConnected"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyId"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"crossfadeSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"explicitTracksAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}}]}}]}}]} as unknown as DocumentNode<CachedViewerContextFragment, unknown>;
export const UserAvatarFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserAvatar"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}}]}}]} as unknown as DocumentNode<UserAvatarFragment, unknown>;
export const AdminDashboardDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AdminDashboard"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playbackAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"IntValue","value":"30"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalListeningTimeHours"}},{"kind":"Field","name":{"kind":"Name","value":"totalTracksPlayed"}},{"kind":"Field","name":{"kind":"Name","value":"averageTrackCompletionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"topTracks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"track"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"playCount"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"billingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyBasePriceCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"schedules"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AdminDashboardQuery, AdminDashboardQueryVariables>;
export const ZoneStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ZoneStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zoneStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playing"}},{"kind":"Field","name":{"kind":"Name","value":"currentTrack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"formattedPosition"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDuration"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}}]}}]}}]} as unknown as DocumentNode<ZoneStatusQuery, ZoneStatusQueryVariables>;
export const LogoutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Logout"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LogoutInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"logout"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<LogoutMutation, LogoutMutationVariables>;
export const ViewerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CachedViewerContext"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CachedViewerContext"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyConnected"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyId"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"crossfadeSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"explicitTracksAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}}]}}]}}]} as unknown as DocumentNode<ViewerQuery, ViewerQueryVariables>;
export const BillingLocationsForSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"BillingLocationsForSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsForSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<BillingLocationsForSelectQuery, BillingLocationsForSelectQueryVariables>;
export const OrganizationSubscriptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationSubscriptions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodStart"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"billingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyBasePriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"}},{"kind":"Field","name":{"kind":"Name","value":"restrictions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationSubscriptionsQuery, OrganizationSubscriptionsQueryVariables>;
export const OrganizationInvoicesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationInvoices"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationInvoices"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"pdfUrl"}},{"kind":"Field","name":{"kind":"Name","value":"hostedInvoiceUrl"}},{"kind":"Field","name":{"kind":"Name","value":"number"}}]}}]}}]} as unknown as DocumentNode<OrganizationInvoicesQuery, OrganizationInvoicesQueryVariables>;
export const CreateCustomerPortalSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCustomerPortalSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCustomerPortalSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCustomerPortalSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"customerPortalSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateCustomerPortalSessionMutation, CreateCustomerPortalSessionMutationVariables>;
export const HardwareProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HardwareProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hardwareProducts"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"productType"}},{"kind":"Field","name":{"kind":"Name","value":"priceCents"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"stripePriceId"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]} as unknown as DocumentNode<HardwareProductsQuery, HardwareProductsQueryVariables>;
export const CreateHardwareCheckoutSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateHardwareCheckoutSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateHardwareCheckoutSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createHardwareCheckoutSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateHardwareCheckoutSessionMutation, CreateHardwareCheckoutSessionMutationVariables>;
export const OrganizationForBillingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"OrganizationForBilling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Organization"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"}},{"kind":"Field","name":{"kind":"Name","value":"restrictions"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerationUsage"}},{"kind":"Field","name":{"kind":"Name","value":"aiModelOptions"}},{"kind":"Field","name":{"kind":"Name","value":"activeSubscriptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"billingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"}},{"kind":"Field","name":{"kind":"Name","value":"restrictions"}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<OrganizationForBillingQuery, OrganizationForBillingQueryVariables>;
export const SpotifyAuthorizationUrlDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SpotifyAuthorizationUrl"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpotifyAuthorizationUrlInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spotifyAuthorizationUrl"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authorizationUrl"}},{"kind":"Field","name":{"kind":"Name","value":"state"}}]}}]}}]} as unknown as DocumentNode<SpotifyAuthorizationUrlMutation, SpotifyAuthorizationUrlMutationVariables>;
export const SpotifyConnectCallbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SpotifyConnectCallback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpotifyConnectCallbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spotifyConnectCallback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyConnected"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<SpotifyConnectCallbackMutation, SpotifyConnectCallbackMutationVariables>;
export const FetchSpotifyPlaylistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FetchSpotifyPlaylists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FetchSpotifyPlaylistsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetchSpotifyPlaylists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"playlists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spotifyId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"tracksTotal"}},{"kind":"Field","name":{"kind":"Name","value":"public"}},{"kind":"Field","name":{"kind":"Name","value":"collaborative"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}},{"kind":"Field","name":{"kind":"Name","value":"owner"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spotifyId"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"requiresReauth"}}]}}]}}]} as unknown as DocumentNode<FetchSpotifyPlaylistsMutation, FetchSpotifyPlaylistsMutationVariables>;
export const ImportSpotifyPlaylistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportSpotifyPlaylist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImportSpotifyPlaylistInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importSpotifyPlaylist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSpotifyPlaylist"}},{"kind":"Field","name":{"kind":"Name","value":"tracksCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"requiresReauth"}},{"kind":"Field","name":{"kind":"Name","value":"syncHistoryId"}}]}}]}}]} as unknown as DocumentNode<ImportSpotifyPlaylistMutation, ImportSpotifyPlaylistMutationVariables>;
export const SpotifyDisconnectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SpotifyDisconnect"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SpotifyDisconnectInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"spotifyDisconnect"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyConnected"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}}]} as unknown as DocumentNode<SpotifyDisconnectMutation, SpotifyDisconnectMutationVariables>;
export const ViewerOrganizationSwitcherDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ViewerOrganizationSwitcher"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"viewer"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"crossfadeSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"explicitTracksAllowed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"crossfadeSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"explicitTracksAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cursor"}},{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ViewerOrganizationSwitcherQuery, ViewerOrganizationSwitcherQueryVariables>;
export const SwitchOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SwitchOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"switchOrganization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"currentOrganization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}},{"kind":"Field","name":{"kind":"Name","value":"crossfadeSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"explicitTracksAllowed"}},{"kind":"Field","name":{"kind":"Name","value":"stripeCustomerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"recentOrganizations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"organizationType"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SwitchOrganizationMutation, SwitchOrganizationMutationVariables>;
export const GlobalSearchDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GlobalSearch"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"playlists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistType"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"tracks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"album"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"playlistSchedules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"50"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"nodes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"voiceMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"text"}}]}}]}}]} as unknown as DocumentNode<GlobalSearchQuery, GlobalSearchQueryVariables>;
export const PlaylistGenerationStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PlaylistGenerationStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"playlistId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlistGenerationStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"playlistId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"playlistId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"tracksGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"totalTracks"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"businessContext"}},{"kind":"Field","name":{"kind":"Name","value":"extractedAttributes"}}]}}]}}]} as unknown as DocumentNode<PlaylistGenerationStatusSubscription, PlaylistGenerationStatusSubscriptionVariables>;
export const GenerateAiTracksForPlaylistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"GenerateAiTracksForPlaylist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GenerateAiTracksForPlaylistInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateAiTracksForPlaylist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"tracksGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"totalTracks"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<GenerateAiTracksForPlaylistMutation, GenerateAiTracksForPlaylistMutationVariables>;
export const SubmitPlaylistFeedbackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitPlaylistFeedback"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SubmitPlaylistFeedbackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitPlaylistFeedback"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"feedback"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"feedbackType"}},{"kind":"Field","name":{"kind":"Name","value":"isPositive"}},{"kind":"Field","name":{"kind":"Name","value":"sentiment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<SubmitPlaylistFeedbackMutation, SubmitPlaylistFeedbackMutationVariables>;
export const PlaylistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Playlist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistType"}},{"kind":"Field","name":{"kind":"Name","value":"isSpotifyPlaylist"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyId"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"aiPrompt"}},{"kind":"Field","name":{"kind":"Name","value":"playlistTracks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"track"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"trackNumber"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"playable"}},{"kind":"Field","name":{"kind":"Name","value":"isSpotifyTrack"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyId"}},{"kind":"Field","name":{"kind":"Name","value":"licensingPro"}},{"kind":"Field","name":{"kind":"Name","value":"licensingProCheckedAt"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"album"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerationStatus"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"tracksGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"totalTracks"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"error"}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<PlaylistQuery, PlaylistQueryVariables>;
export const StationPreviewTracksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"StationPreviewTracks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"playlistId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"stationPreviewTracks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"playlistId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"playlistId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"album"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<StationPreviewTracksQuery, StationPreviewTracksQueryVariables>;
export const PlaylistScreenGenerationStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"subscription","name":{"kind":"Name","value":"PlaylistScreenGenerationStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"playlistId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlistGenerationStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"playlistId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"playlistId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlistId"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"progress"}},{"kind":"Field","name":{"kind":"Name","value":"tracksGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"totalTracks"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"completedAt"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"businessContext"}},{"kind":"Field","name":{"kind":"Name","value":"extractedAttributes"}}]}}]}}]} as unknown as DocumentNode<PlaylistScreenGenerationStatusSubscription, PlaylistScreenGenerationStatusSubscriptionVariables>;
export const SearchTracksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchTracks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"licensingPro"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LicensingProEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tracks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"licensingPro"},"value":{"kind":"Variable","name":{"kind":"Name","value":"licensingPro"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"coverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"playable"}},{"kind":"Field","name":{"kind":"Name","value":"isSpotifyTrack"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyId"}},{"kind":"Field","name":{"kind":"Name","value":"licensingPro"}},{"kind":"Field","name":{"kind":"Name","value":"licensingProCheckedAt"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"album"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<SearchTracksQuery, SearchTracksQueryVariables>;
export const AddTrackToPlaylistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AddTrackToPlaylist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddTrackToPlaylistInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addTrackToPlaylist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlistTrack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"track"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"trackNumber"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"playable"}},{"kind":"Field","name":{"kind":"Name","value":"isSpotifyTrack"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyId"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"album"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<AddTrackToPlaylistMutation, AddTrackToPlaylistMutationVariables>;
export const RemoveTrackFromPlaylistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RemoveTrackFromPlaylist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RemoveTrackFromPlaylistInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeTrackFromPlaylist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<RemoveTrackFromPlaylistMutation, RemoveTrackFromPlaylistMutationVariables>;
export const UpdateTrackPositionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTrackPosition"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTrackPositionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTrackPosition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateTrackPositionMutation, UpdateTrackPositionMutationVariables>;
export const SyncSpotifyPlaylistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncSpotifyPlaylist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SyncSpotifyPlaylistInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncSpotifyPlaylist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"requiresReauth"}},{"kind":"Field","name":{"kind":"Name","value":"tracksAdded"}},{"kind":"Field","name":{"kind":"Name","value":"tracksUpdated"}},{"kind":"Field","name":{"kind":"Name","value":"syncHistoryId"}}]}}]}}]} as unknown as DocumentNode<SyncSpotifyPlaylistMutation, SyncSpotifyPlaylistMutationVariables>;
export const ActiveSyncHistoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ActiveSyncHistories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"playlistId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeSyncHistories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"playlistId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"playlistId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"syncType"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"message"}},{"kind":"Field","name":{"kind":"Name","value":"startedAt"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"spotifyResourceId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<ActiveSyncHistoriesQuery, ActiveSyncHistoriesQueryVariables>;
export const PlaylistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Playlists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistType"}},{"kind":"Field","name":{"kind":"Name","value":"tracksCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<PlaylistsQuery, PlaylistsQueryVariables>;
export const CreatePlaylistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreatePlaylist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreatePlaylistInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createPlaylist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistType"}},{"kind":"Field","name":{"kind":"Name","value":"tracksCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"aiPrompt"}}]}}]}}]}}]} as unknown as DocumentNode<CreatePlaylistMutation, CreatePlaylistMutationVariables>;
export const CreateStationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateStation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateStationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createStation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistType"}},{"kind":"Field","name":{"kind":"Name","value":"tracksCount"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"aiGenerated"}},{"kind":"Field","name":{"kind":"Name","value":"aiPrompt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateStationMutation, CreateStationMutationVariables>;
export const ImportSpotifyPlaylistOnPlaylistsScreenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ImportSpotifyPlaylistOnPlaylistsScreen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ImportSpotifyPlaylistInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"importSpotifyPlaylist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isSpotifyPlaylist"}},{"kind":"Field","name":{"kind":"Name","value":"tracksCount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"error"}},{"kind":"Field","name":{"kind":"Name","value":"requiresReauth"}}]}}]}}]} as unknown as DocumentNode<ImportSpotifyPlaylistOnPlaylistsScreenMutation, ImportSpotifyPlaylistOnPlaylistsScreenMutationVariables>;
export const UserUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"avatarThumbUrl"}}]}}]}}]}}]} as unknown as DocumentNode<UserUpdateMutation, UserUpdateMutationVariables>;
export const UpdateProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateProfile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateProfileMutation, UpdateProfileMutationVariables>;
export const LocationAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"country"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"city"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationGrouping"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}},{"kind":"Argument","name":{"kind":"Name","value":"country"},"value":{"kind":"Variable","name":{"kind":"Name","value":"country"}}},{"kind":"Argument","name":{"kind":"Name","value":"city"},"value":{"kind":"Variable","name":{"kind":"Name","value":"city"}}},{"kind":"Argument","name":{"kind":"Name","value":"timezone"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timezone"}}},{"kind":"Argument","name":{"kind":"Name","value":"groupBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"groupBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"region"}},{"kind":"Field","name":{"kind":"Name","value":"locationDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"totalEvents"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueTracks"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueDevices"}},{"kind":"Field","name":{"kind":"Name","value":"listeningTimeSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"listeningTimeHours"}},{"kind":"Field","name":{"kind":"Name","value":"topTracks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackId"}},{"kind":"Field","name":{"kind":"Name","value":"trackTitle"}},{"kind":"Field","name":{"kind":"Name","value":"trackArtist"}},{"kind":"Field","name":{"kind":"Name","value":"playCount"}}]}}]}}]}}]} as unknown as DocumentNode<LocationAnalyticsQuery, LocationAnalyticsQueryVariables>;
export const PlaybackAnalyticsWithLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlaybackAnalyticsWithLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playbackAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceLocations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceName"}},{"kind":"Field","name":{"kind":"Name","value":"latitude"}},{"kind":"Field","name":{"kind":"Name","value":"longitude"}},{"kind":"Field","name":{"kind":"Name","value":"city"}},{"kind":"Field","name":{"kind":"Name","value":"country"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"locationDisplayName"}},{"kind":"Field","name":{"kind":"Name","value":"lastLocationUpdate"}},{"kind":"Field","name":{"kind":"Name","value":"totalEvents"}},{"kind":"Field","name":{"kind":"Name","value":"listeningTimeHours"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueTracksPlayed"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]} as unknown as DocumentNode<PlaybackAnalyticsWithLocationQuery, PlaybackAnalyticsWithLocationQueryVariables>;
export const PlaybackAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlaybackAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601Date"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playbackAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalListeningTimeSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"totalListeningTimeHours"}},{"kind":"Field","name":{"kind":"Name","value":"totalTracksPlayed"}},{"kind":"Field","name":{"kind":"Name","value":"uniqueTracksPlayed"}},{"kind":"Field","name":{"kind":"Name","value":"averageTrackCompletionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"mostActiveHours"}},{"kind":"Field","name":{"kind":"Name","value":"dailyListeningHours"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"hours"}},{"kind":"Field","name":{"kind":"Name","value":"tracksPlayed"}}]}},{"kind":"Field","name":{"kind":"Name","value":"topTracks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"trackId"}},{"kind":"Field","name":{"kind":"Name","value":"trackTitle"}},{"kind":"Field","name":{"kind":"Name","value":"trackArtist"}},{"kind":"Field","name":{"kind":"Name","value":"playCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalListeningTimeSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"averageCompletionPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"track"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayArtist"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dateRange"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"days"}}]}}]}}]}}]} as unknown as DocumentNode<PlaybackAnalyticsQuery, PlaybackAnalyticsQueryVariables>;
export const PlaybackEventsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlaybackEvents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"trackId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"eventTypes"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playbackEvents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}},{"kind":"Argument","name":{"kind":"Name","value":"deviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"deviceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"trackId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"trackId"}}},{"kind":"Argument","name":{"kind":"Name","value":"eventTypes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"eventTypes"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"eventType"}},{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"zoneId"}},{"kind":"Field","name":{"kind":"Name","value":"deviceId"}},{"kind":"Field","name":{"kind":"Name","value":"trackId"}},{"kind":"Field","name":{"kind":"Name","value":"positionMs"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"trackTitle"}},{"kind":"Field","name":{"kind":"Name","value":"trackArtist"}},{"kind":"Field","name":{"kind":"Name","value":"playbackPercentage"}},{"kind":"Field","name":{"kind":"Name","value":"formattedPosition"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDuration"}},{"kind":"Field","name":{"kind":"Name","value":"isTrackStarted"}},{"kind":"Field","name":{"kind":"Name","value":"isTrackEnded"}},{"kind":"Field","name":{"kind":"Name","value":"isPlaybackState"}},{"kind":"Field","name":{"kind":"Name","value":"isProgressEvent"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"track"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayArtist"}}]}}]}}]}}]} as unknown as DocumentNode<PlaybackEventsQuery, PlaybackEventsQueryVariables>;
export const RoyaltyReportDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"RoyaltyReport"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601Date"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"includePartial"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"royaltyReporting"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"includePartial"},"value":{"kind":"Variable","name":{"kind":"Name","value":"includePartial"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startAt"}},{"kind":"Field","name":{"kind":"Name","value":"endAt"}},{"kind":"Field","name":{"kind":"Name","value":"includePartial"}},{"kind":"Field","name":{"kind":"Name","value":"overallTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalPlays"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedPlays"}},{"kind":"Field","name":{"kind":"Name","value":"partialPlays"}},{"kind":"Field","name":{"kind":"Name","value":"totalDurationMs"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedDurationMs"}}]}},{"kind":"Field","name":{"kind":"Name","value":"proTotals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"licensingPro"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlays"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedPlays"}},{"kind":"Field","name":{"kind":"Name","value":"partialPlays"}},{"kind":"Field","name":{"kind":"Name","value":"totalDurationMs"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedDurationMs"}},{"kind":"Field","name":{"kind":"Name","value":"zonesReporting"}},{"kind":"Field","name":{"kind":"Name","value":"locationsReporting"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"locationName"}},{"kind":"Field","name":{"kind":"Name","value":"zoneId"}},{"kind":"Field","name":{"kind":"Name","value":"zoneName"}},{"kind":"Field","name":{"kind":"Name","value":"licensingPro"}},{"kind":"Field","name":{"kind":"Name","value":"totalPlays"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedPlays"}},{"kind":"Field","name":{"kind":"Name","value":"partialPlays"}},{"kind":"Field","name":{"kind":"Name","value":"totalDurationMs"}},{"kind":"Field","name":{"kind":"Name","value":"qualifiedDurationMs"}}]}}]}}]}}]} as unknown as DocumentNode<RoyaltyReportQuery, RoyaltyReportQueryVariables>;
export const ZonesForReportingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ZonesForReporting"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zones"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"devices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ZonesForReportingQuery, ZonesForReportingQueryVariables>;
export const PlaylistScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlaylistSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlistSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<PlaylistScheduleQuery, PlaylistScheduleQueryVariables>;
export const UpsertPlaylistScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpsertPlaylistSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpsertPlaylistScheduleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertPlaylistSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<UpsertPlaylistScheduleMutation, UpsertPlaylistScheduleMutationVariables>;
export const LocationsForSelectDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LocationsForSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationsForSelect"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<LocationsForSelectQuery, LocationsForSelectQueryVariables>;
export const AllPlaylistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllPlaylists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allPlaylists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tracksCount"}}]}}]}}]} as unknown as DocumentNode<AllPlaylistsQuery, AllPlaylistsQueryVariables>;
export const PlaylistSchedulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"PlaylistSchedules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlistSchedules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<PlaylistSchedulesQuery, PlaylistSchedulesQueryVariables>;
export const UpdateOrganizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOrganization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrganizationUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organizationUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"crossfadeSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"billingEmail"}},{"kind":"Field","name":{"kind":"Name","value":"explicitTracksAllowed"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const CreateTrackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateTrack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateTrackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createTrack"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"licensingPro"}},{"kind":"Field","name":{"kind":"Name","value":"licensingProCheckedAt"}}]}}]}}]} as unknown as DocumentNode<CreateTrackMutation, CreateTrackMutationVariables>;
export const UpdateTrackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateTrack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateTrackInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateTrack"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"licensingPro"}},{"kind":"Field","name":{"kind":"Name","value":"licensingProCheckedAt"}}]}}]}}]} as unknown as DocumentNode<UpdateTrackMutation, UpdateTrackMutationVariables>;
export const RecheckTrackLicensingProDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RecheckTrackLicensingPro"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RecheckTrackLicensingProInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recheckTrackLicensingPro"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"licensingPro"}},{"kind":"Field","name":{"kind":"Name","value":"licensingProCheckedAt"}}]}}]}}]} as unknown as DocumentNode<RecheckTrackLicensingProMutation, RecheckTrackLicensingProMutationVariables>;
export const ArtistsForTrackModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArtistsForTrackModal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"200"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ArtistsForTrackModalQuery, ArtistsForTrackModalQueryVariables>;
export const AlbumsForTrackModalDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AlbumsForTrackModal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"albums"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"200"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AlbumsForTrackModalQuery, AlbumsForTrackModalQueryVariables>;
export const TracksQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"TracksQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"artistId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"albumId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"genreId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"year"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"hasAudioUrl"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"licensingPro"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LicensingProEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"TrackSortByEnum"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tracks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"artistId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"artistId"}}},{"kind":"Argument","name":{"kind":"Name","value":"albumId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"albumId"}}},{"kind":"Argument","name":{"kind":"Name","value":"genreId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"genreId"}}},{"kind":"Argument","name":{"kind":"Name","value":"year"},"value":{"kind":"Variable","name":{"kind":"Name","value":"year"}}},{"kind":"Argument","name":{"kind":"Name","value":"hasAudioUrl"},"value":{"kind":"Variable","name":{"kind":"Name","value":"hasAudioUrl"}}},{"kind":"Argument","name":{"kind":"Name","value":"licensingPro"},"value":{"kind":"Variable","name":{"kind":"Name","value":"licensingPro"}}},{"kind":"Argument","name":{"kind":"Name","value":"sortBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"sortBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"durationMs"}},{"kind":"Field","name":{"kind":"Name","value":"popularity"}},{"kind":"Field","name":{"kind":"Name","value":"explicit"}},{"kind":"Field","name":{"kind":"Name","value":"trackNumber"}},{"kind":"Field","name":{"kind":"Name","value":"discNumber"}},{"kind":"Field","name":{"kind":"Name","value":"displayArtist"}},{"kind":"Field","name":{"kind":"Name","value":"licensingPro"}},{"kind":"Field","name":{"kind":"Name","value":"licensingProCheckedAt"}},{"kind":"Field","name":{"kind":"Name","value":"playable"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"coverThumbUrl"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"isSpotifyTrack"}},{"kind":"Field","name":{"kind":"Name","value":"album"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}}]}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}},{"kind":"Field","name":{"kind":"Name","value":"hasPreviousPage"}},{"kind":"Field","name":{"kind":"Name","value":"startCursor"}},{"kind":"Field","name":{"kind":"Name","value":"endCursor"}}]}}]}}]}}]} as unknown as DocumentNode<TracksQueryQuery, TracksQueryQueryVariables>;
export const ArtistsForFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArtistsForFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"artists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ArtistsForFilterQuery, ArtistsForFilterQueryVariables>;
export const AlbumsForFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AlbumsForFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"albums"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"releaseDate"}}]}}]}}]}}]}}]} as unknown as DocumentNode<AlbumsForFilterQuery, AlbumsForFilterQueryVariables>;
export const GenresForFilterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GenresForFilter"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"genres"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"100"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GenresForFilterQuery, GenresForFilterQueryVariables>;
export const UserDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}}]}}]} as unknown as DocumentNode<UserDetailsQuery, UserDetailsQueryVariables>;
export const UsersAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"UsersAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"50"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<UsersAdminQuery, UsersAdminQueryVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const UserUpdateAdminDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UserUpdateAdmin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"userRole"}},{"kind":"Field","name":{"kind":"Name","value":"userStatus"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]}}]} as unknown as DocumentNode<UserUpdateAdminMutation, UserUpdateAdminMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteUserInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const VoiceMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VoiceMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voiceMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ttsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ttsErrorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"ttsModelId"}},{"kind":"Field","name":{"kind":"Name","value":"ttsVoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"ttsSpeed"}},{"kind":"Field","name":{"kind":"Name","value":"ttsVolume"}},{"kind":"Field","name":{"kind":"Name","value":"ttsEmotion"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"durationFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"readyForPlayback"}}]}}]}}]} as unknown as DocumentNode<VoiceMessageQuery, VoiceMessageQueryVariables>;
export const UpdateVoiceMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVoiceMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateVoiceMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVoiceMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voiceMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ttsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"ttsModelId"}},{"kind":"Field","name":{"kind":"Name","value":"ttsVoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"ttsSpeed"}},{"kind":"Field","name":{"kind":"Name","value":"ttsVolume"}},{"kind":"Field","name":{"kind":"Name","value":"ttsEmotion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateVoiceMessageMutation, UpdateVoiceMessageMutationVariables>;
export const RegenerateTtsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RegenerateTts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegenerateVoiceMessageTtsInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regenerateVoiceMessageTts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voiceMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"ttsStatus"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<RegenerateTtsMutation, RegenerateTtsMutationVariables>;
export const CartesiaVoiceOptionsForEditDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CartesiaVoiceOptionsForEdit"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartesiaVoiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultVoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultModelId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultSpeed"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVolume"}},{"kind":"Field","name":{"kind":"Name","value":"speedMin"}},{"kind":"Field","name":{"kind":"Name","value":"speedMax"}},{"kind":"Field","name":{"kind":"Name","value":"volumeMin"}},{"kind":"Field","name":{"kind":"Name","value":"volumeMax"}},{"kind":"Field","name":{"kind":"Name","value":"emotions"}},{"kind":"Field","name":{"kind":"Name","value":"recommendedVoiceIds"}},{"kind":"Field","name":{"kind":"Name","value":"voices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voiceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"emotive"}},{"kind":"Field","name":{"kind":"Name","value":"recommended"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}}]}}]}}]} as unknown as DocumentNode<CartesiaVoiceOptionsForEditQuery, CartesiaVoiceOptionsForEditQueryVariables>;
export const PreviewCartesiaVoiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PreviewCartesiaVoice"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PreviewCartesiaVoiceInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"previewCartesiaVoice"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"audioBase64"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<PreviewCartesiaVoiceMutation, PreviewCartesiaVoiceMutationVariables>;
export const CreateVoiceMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateVoiceMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateVoiceMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createVoiceMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voiceMessage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"ttsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"ttsModelId"}},{"kind":"Field","name":{"kind":"Name","value":"ttsVoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"ttsSpeed"}},{"kind":"Field","name":{"kind":"Name","value":"ttsVolume"}},{"kind":"Field","name":{"kind":"Name","value":"ttsEmotion"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateVoiceMessageMutation, CreateVoiceMessageMutationVariables>;
export const CartesiaVoiceOptionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CartesiaVoiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cartesiaVoiceOptions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultVoiceId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultModelId"}},{"kind":"Field","name":{"kind":"Name","value":"defaultSpeed"}},{"kind":"Field","name":{"kind":"Name","value":"defaultVolume"}},{"kind":"Field","name":{"kind":"Name","value":"speedMin"}},{"kind":"Field","name":{"kind":"Name","value":"speedMax"}},{"kind":"Field","name":{"kind":"Name","value":"volumeMin"}},{"kind":"Field","name":{"kind":"Name","value":"volumeMax"}},{"kind":"Field","name":{"kind":"Name","value":"emotions"}},{"kind":"Field","name":{"kind":"Name","value":"recommendedVoiceIds"}},{"kind":"Field","name":{"kind":"Name","value":"voices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"voiceId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"language"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"emotive"}},{"kind":"Field","name":{"kind":"Name","value":"recommended"}},{"kind":"Field","name":{"kind":"Name","value":"tags"}}]}}]}}]}}]} as unknown as DocumentNode<CartesiaVoiceOptionsQuery, CartesiaVoiceOptionsQueryVariables>;
export const VoiceMessageWithSchedulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VoiceMessageWithSchedules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voiceMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"ttsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nextOccurrence"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}}]}}]}}]} as unknown as DocumentNode<VoiceMessageWithSchedulesQuery, VoiceMessageWithSchedulesQueryVariables>;
export const VoiceMessageSchedulesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VoiceMessageSchedules"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"voiceMessageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enabledOnly"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voiceMessageSchedules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"voiceMessageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"voiceMessageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"enabledOnly"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enabledOnly"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}},{"kind":"Field","name":{"kind":"Name","value":"forceInterrupt"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"frequencyDescription"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"nextOccurrence"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<VoiceMessageSchedulesQuery, VoiceMessageSchedulesQueryVariables>;
export const CreateVoiceMessageScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateVoiceMessageSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateVoiceMessageScheduleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createVoiceMessageSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voiceMessageSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}},{"kind":"Field","name":{"kind":"Name","value":"forceInterrupt"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"frequencyDescription"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"nextOccurrence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateVoiceMessageScheduleMutation, CreateVoiceMessageScheduleMutationVariables>;
export const UpdateVoiceMessageScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateVoiceMessageSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateVoiceMessageScheduleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateVoiceMessageSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voiceMessageSchedule"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"rrule"}},{"kind":"Field","name":{"kind":"Name","value":"forceInterrupt"}},{"kind":"Field","name":{"kind":"Name","value":"priority"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"frequencyDescription"}},{"kind":"Field","name":{"kind":"Name","value":"durationMinutes"}},{"kind":"Field","name":{"kind":"Name","value":"nextOccurrence"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateVoiceMessageScheduleMutation, UpdateVoiceMessageScheduleMutationVariables>;
export const DeleteVoiceMessageScheduleDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteVoiceMessageSchedule"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteVoiceMessageScheduleInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteVoiceMessageSchedule"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteVoiceMessageScheduleMutation, DeleteVoiceMessageScheduleMutationVariables>;
export const VoiceMessagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VoiceMessages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voiceMessages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"ttsStatus"}},{"kind":"Field","name":{"kind":"Name","value":"ttsErrorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"audioUrl"}},{"kind":"Field","name":{"kind":"Name","value":"durationSeconds"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"campaigns"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"nextOccurrence"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}}]}},{"kind":"Field","name":{"kind":"Name","value":"durationFormatted"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"readyForPlayback"}},{"kind":"Field","name":{"kind":"Name","value":"hasActiveSchedules"}}]}}]}}]} as unknown as DocumentNode<VoiceMessagesQuery, VoiceMessagesQueryVariables>;
export const DeleteVoiceMessageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteVoiceMessage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DeleteVoiceMessageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteVoiceMessage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<DeleteVoiceMessageMutation, DeleteVoiceMessageMutationVariables>;
export const VoicePlaylistRequestsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VoicePlaylistRequests"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VoicePlaylistRequestStatusEnum"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voicePlaylistRequests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requestType"}},{"kind":"Field","name":{"kind":"Name","value":"targetKind"}},{"kind":"Field","name":{"kind":"Name","value":"targetName"}},{"kind":"Field","name":{"kind":"Name","value":"artistName"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"requestedMetadata"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionPayload"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"voiceCommandEvent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rawText"}},{"kind":"Field","name":{"kind":"Name","value":"normalizedText"}},{"kind":"Field","name":{"kind":"Name","value":"intent"}},{"kind":"Field","name":{"kind":"Name","value":"action"}},{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"locale"}},{"kind":"Field","name":{"kind":"Name","value":"confidence"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fullName"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<VoicePlaylistRequestsQuery, VoicePlaylistRequestsQueryVariables>;
export const VoicePlaylistRequestPlaylistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VoicePlaylistRequestPlaylists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlists"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<VoicePlaylistRequestPlaylistsQuery, VoicePlaylistRequestPlaylistsQueryVariables>;
export const VoicePlaylistRequestTracksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"VoicePlaylistRequestTracks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"query"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tracks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"query"},"value":{"kind":"Variable","name":{"kind":"Name","value":"query"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"displayArtist"}},{"kind":"Field","name":{"kind":"Name","value":"playable"}},{"kind":"Field","name":{"kind":"Name","value":"album"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<VoicePlaylistRequestTracksQuery, VoicePlaylistRequestTracksQueryVariables>;
export const ResolveVoicePlaylistRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResolveVoicePlaylistRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResolveVoicePlaylistRequestInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resolveVoicePlaylistRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"voicePlaylistRequest"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"resolutionPayload"}},{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<ResolveVoicePlaylistRequestMutation, ResolveVoicePlaylistRequestMutationVariables>;
export const VoicePlaylistRequestAddTrackDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"VoicePlaylistRequestAddTrack"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AddTrackToPlaylistInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"addTrackToPlaylist"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlistTrack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<VoicePlaylistRequestAddTrackMutation, VoicePlaylistRequestAddTrackMutationVariables>;
export const JukeboxAnalyticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JukeboxAnalytics"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ISO8601DateTime"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jukeboxAnalytics"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}},{"kind":"Argument","name":{"kind":"Name","value":"startDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"startDate"}}},{"kind":"Argument","name":{"kind":"Name","value":"endDate"},"value":{"kind":"Variable","name":{"kind":"Name","value":"endDate"}}}]}]}}]} as unknown as DocumentNode<JukeboxAnalyticsQuery, JukeboxAnalyticsQueryVariables>;
export const JukeboxQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JukeboxQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jukeboxQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}}]}]}}]} as unknown as DocumentNode<JukeboxQueueQuery, JukeboxQueueQueryVariables>;
export const JukeboxRemoveItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JukeboxRemoveItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JukeboxRemoveItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jukeboxRemoveItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<JukeboxRemoveItemMutation, JukeboxRemoveItemMutationVariables>;
export const JukeboxSkipCurrentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JukeboxSkipCurrent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JukeboxSkipCurrentInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jukeboxSkipCurrent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<JukeboxSkipCurrentMutation, JukeboxSkipCurrentMutationVariables>;
export const JukeboxPauseQueueDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JukeboxPauseQueue"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JukeboxPauseQueueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jukeboxPauseQueue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"paused"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<JukeboxPauseQueueMutation, JukeboxPauseQueueMutationVariables>;
export const JukeboxEmergencyLockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"JukeboxEmergencyLock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"JukeboxEmergencyLockInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jukeboxEmergencyLock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"refundedCount"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<JukeboxEmergencyLockMutation, JukeboxEmergencyLockMutationVariables>;
export const JukeboxEffectiveConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JukeboxEffectiveConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jukeboxEffectiveConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}}]}]}}]} as unknown as DocumentNode<JukeboxEffectiveConfigurationQuery, JukeboxEffectiveConfigurationQueryVariables>;
export const UpdateJukeboxZoneConfigurationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateJukeboxZoneConfiguration"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateJukeboxZoneConfigurationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateJukeboxZoneConfiguration"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jukeboxConfiguration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"mode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateJukeboxZoneConfigurationMutation, UpdateJukeboxZoneConfigurationMutationVariables>;
export const JukeboxQrCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"JukeboxQrCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"jukeboxQrCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}}]}]}}]} as unknown as DocumentNode<JukeboxQrCodeQuery, JukeboxQrCodeQueryVariables>;
export const ZoneBillingContextDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ZoneBillingContext"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingPlans"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyBasePriceCents"}},{"kind":"Field","name":{"kind":"Name","value":"entitlements"}},{"kind":"Field","name":{"kind":"Name","value":"restrictions"}},{"kind":"Field","name":{"kind":"Name","value":"active"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"organizationSubscriptions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodStart"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"cancelAtPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"billingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyBasePriceCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingSubscriptionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyBasePriceCents"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ZoneBillingContextQuery, ZoneBillingContextQueryVariables>;
export const CreateCheckoutSessionForZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateCheckoutSessionForZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateCheckoutSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createCheckoutSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkoutSession"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"sessionId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<CreateCheckoutSessionForZoneMutation, CreateCheckoutSessionForZoneMutationVariables>;
export const SyncStripeCheckoutSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SyncStripeCheckoutSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SyncStripeCheckoutSessionInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"syncStripeCheckoutSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}},{"kind":"Field","name":{"kind":"Name","value":"errors"}},{"kind":"Field","name":{"kind":"Name","value":"subscription"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"currentPeriodEnd"}},{"kind":"Field","name":{"kind":"Name","value":"billingPlan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"monthlyBasePriceCents"}}]}},{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]}}]} as unknown as DocumentNode<SyncStripeCheckoutSessionMutation, SyncStripeCheckoutSessionMutationVariables>;
export const SendZoneCommandDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendZoneCommand"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SendZoneCommandInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendZoneCommand"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]} as unknown as DocumentNode<SendZoneCommandMutation, SendZoneCommandMutationVariables>;
export const GetZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}}]}}]}}]}}]} as unknown as DocumentNode<GetZoneQuery, GetZoneQueryVariables>;
export const GetZoneStatusDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZoneStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zoneStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentTrack"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"playing"}},{"kind":"Field","name":{"kind":"Name","value":"currentPosition"}},{"kind":"Field","name":{"kind":"Name","value":"trackDuration"}},{"kind":"Field","name":{"kind":"Name","value":"formattedPosition"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDuration"}},{"kind":"Field","name":{"kind":"Name","value":"volume"}},{"kind":"Field","name":{"kind":"Name","value":"crossfade"}}]}}]}}]} as unknown as DocumentNode<GetZoneStatusQuery, GetZoneStatusQueryVariables>;
export const GetZonePlaylistDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetZonePlaylist"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"playlistSchedules"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"zoneId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"zoneId"}}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"IntValue","value":"1"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"playlist"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"playlistType"}},{"kind":"Field","name":{"kind":"Name","value":"playlistTracks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"position"}},{"kind":"Field","name":{"kind":"Name","value":"track"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"artists"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetZonePlaylistQuery, GetZonePlaylistQueryVariables>;
export const UpdateZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateZoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateZoneMutation, UpdateZoneMutationVariables>;
export const LocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Locations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"first"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"20"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"after"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"first"}}},{"kind":"Argument","name":{"kind":"Name","value":"after"},"value":{"kind":"Variable","name":{"kind":"Name","value":"after"}}},{"kind":"Argument","name":{"kind":"Name","value":"organizationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"organizationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNextPage"}}]}}]}}]}}]} as unknown as DocumentNode<LocationsQuery, LocationsQueryVariables>;
export const CreateLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}},{"kind":"Field","name":{"kind":"Name","value":"zones"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CreateLocationMutation, CreateLocationMutationVariables>;
export const CreateZoneDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateZone"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateZoneInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createZone"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"zone"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateZoneMutation, CreateZoneMutationVariables>;
export const UpdateLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateLocationInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"timeZone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"}}]}}]}}]} as unknown as DocumentNode<UpdateLocationMutation, UpdateLocationMutationVariables>;